/**
 * Do not edit directly
 * Generated on Wed, 27 Mar 2024 08:56:39 GMT
 */

export const actionPrimaryColorAccentDefaultText = "#ffffff";
export const actionPrimaryColorAccentDefaultBackground = "#2563eb";
export const actionPrimaryColorAccentDefaultBorder = "#bfdbfe";
export const actionPrimaryColorAccentDefaultIcon = "#ffffff";
export const actionPrimaryColorAccentHoverText = "#ffffff";
export const actionPrimaryColorAccentHoverBackground = "#1e40af";
export const actionPrimaryColorAccentHoverBorder = "#bfdbfe";
export const actionPrimaryColorAccentHoverIcon = "#ffffff";
export const actionPrimaryColorAccentFocusedText = "#ffffff";
export const actionPrimaryColorAccentFocusedBackground = "#2563eb";
export const actionPrimaryColorAccentFocusedBorder = "#ffffff 0%";
export const actionPrimaryColorAccentFocusedIcon = "#ffffff";
export const actionPrimaryColorAccentActiveText = "#ffffff";
export const actionPrimaryColorAccentActiveBackground = "#1d4ed8";
export const actionPrimaryColorAccentActiveBorder = "#bfdbfe";
export const actionPrimaryColorAccentActiveIcon = "#ffffff";
export const actionPrimaryColorAccentDisabledText = "#bfdbfe";
export const actionPrimaryColorAccentDisabledBackground = "#eff6ff";
export const actionPrimaryColorAccentDisabledBorder = "#dbeafe";
export const actionPrimaryColorAccentDisabledIcon = "#bfdbfe";
export const actionPrimaryColorAccentSelectedText = "#ffffff";
export const actionPrimaryColorAccentSelectedBackground = "#1d4ed8";
export const actionPrimaryColorAccentSelectedBorder = "#bfdbfe";
export const actionPrimaryColorAccentSelectedIcon = "#ffffff";
export const actionPrimaryColorDangerDefaultText = "#ffffff";
export const actionPrimaryColorDangerDefaultBackground = "#dc2626";
export const actionPrimaryColorDangerDefaultBorder = "#fecaca";
export const actionPrimaryColorDangerDefaultIcon = "#ffffff";
export const actionPrimaryColorDangerHoverText = "#ffffff";
export const actionPrimaryColorDangerHoverBackground = "#b91c1c";
export const actionPrimaryColorDangerHoverBorder = "#fecaca";
export const actionPrimaryColorDangerHoverIcon = "#ffffff";
export const actionPrimaryColorDangerFocusedText = "#ffffff";
export const actionPrimaryColorDangerFocusedBackground = "#dc2626";
export const actionPrimaryColorDangerFocusedBorder = "#FFFFFF00";
export const actionPrimaryColorDangerFocusedIcon = "#ffffff";
export const actionPrimaryColorDangerFocusedBorderStrong = "#ef4444";
export const actionPrimaryColorDangerActiveText = "#ffffff";
export const actionPrimaryColorDangerActiveBackground = "#dc2626";
export const actionPrimaryColorDangerActiveBorder = "#fecaca";
export const actionPrimaryColorDangerActiveIcon = "#ffffff";
export const actionPrimaryColorDangerDisabledText = "#fecaca";
export const actionPrimaryColorDangerDisabledBackground = "#fef2f2";
export const actionPrimaryColorDangerDisabledBorder = "#fee2e2";
export const actionPrimaryColorDangerDisabledIcon = "#fecaca";
export const actionPrimaryColorDangerSelectedText = "#ffffff";
export const actionPrimaryColorDangerSelectedBackground = "#dc2626";
export const actionPrimaryColorDangerSelectedBorder = "#fecaca";
export const actionPrimaryColorDangerSelectedIcon = "#ffffff";
export const actionPrimaryColorNeutralDefaultText = "#374151";
export const actionPrimaryColorNeutralDefaultBackground = "#f3f4f6";
export const actionPrimaryColorNeutralDefaultBorder = "#d1d5db";
export const actionPrimaryColorNeutralDefaultIcon = "#6b7280";
export const actionPrimaryColorNeutralHoverText = "#111827";
export const actionPrimaryColorNeutralHoverBackground = "#e5e7eb";
export const actionPrimaryColorNeutralHoverBorder = "#d1d5db";
export const actionPrimaryColorNeutralHoverIcon = "#374151";
export const actionPrimaryColorNeutralFocusedText = "#374151";
export const actionPrimaryColorNeutralFocusedBackground = "#f3f4f6";
export const actionPrimaryColorNeutralFocusedBorder = "#d1d5db";
export const actionPrimaryColorNeutralFocusedIcon = "#6b7280";
export const actionPrimaryColorNeutralActiveText = "#374151";
export const actionPrimaryColorNeutralActiveBackground = "#f3f4f6";
export const actionPrimaryColorNeutralActiveBorder = "#d1d5db";
export const actionPrimaryColorNeutralActiveIcon = "#6b7280";
export const actionPrimaryColorNeutralDisabledText = "#d1d5db";
export const actionPrimaryColorNeutralDisabledBackground = "#f3f4f6";
export const actionPrimaryColorNeutralDisabledBorder = "#e5e7eb";
export const actionPrimaryColorNeutralDisabledIcon = "#e5e7eb";
export const actionPrimaryColorNeutralSelectedText = "#374151";
export const actionPrimaryColorNeutralSelectedBackground = "#e5e7eb";
export const actionPrimaryColorNeutralSelectedBorder = "#d1d5db";
export const actionPrimaryColorNeutralSelectedIcon = "#6b7280";
export const actionPrimaryColorSuccessDefaultText = "#ffffff";
export const actionPrimaryColorSuccessDefaultBackground = "#059669";
export const actionPrimaryColorSuccessDefaultBorder = "#a7f3d0";
export const actionPrimaryColorSuccessDefaultIcon = "#ffffff";
export const actionPrimaryColorSuccessHoverText = "#ffffff";
export const actionPrimaryColorSuccessHoverBackground = "#047857";
export const actionPrimaryColorSuccessHoverBorder = "#a7f3d0";
export const actionPrimaryColorSuccessHoverIcon = "#ffffff";
export const actionPrimaryColorSuccessFocusedText = "#ffffff";
export const actionPrimaryColorSuccessFocusedBackground = "#059669";
export const actionPrimaryColorSuccessFocusedBorder = "#FFFFFF00";
export const actionPrimaryColorSuccessFocusedIcon = "#ffffff";
export const actionPrimaryColorSuccessActiveText = "#ffffff";
export const actionPrimaryColorSuccessActiveBackground = "#059669";
export const actionPrimaryColorSuccessActiveBorder = "#a7f3d0";
export const actionPrimaryColorSuccessActiveIcon = "#ffffff";
export const actionPrimaryColorSuccessDisabledText = "#6ee7b7";
export const actionPrimaryColorSuccessDisabledBackground = "#ecfdf5";
export const actionPrimaryColorSuccessDisabledBorder = "#d1fae5";
export const actionPrimaryColorSuccessDisabledIcon = "#a7f3d0";
export const actionPrimaryColorSuccessSelectedText = "#ffffff";
export const actionPrimaryColorSuccessSelectedBackground = "#059669";
export const actionPrimaryColorSuccessSelectedBorder = "#a7f3d0";
export const actionPrimaryColorSuccessSelectedIcon = "#ffffff";
export const actionSecondaryColorAccentDefaultText = "#1d4ed8";
export const actionSecondaryColorAccentDefaultBackground = "#ffffff";
export const actionSecondaryColorAccentDefaultBorder = "#3b82f6";
export const actionSecondaryColorAccentDefaultIcon = "#3b82f6";
export const actionSecondaryColorAccentDefaultBackgroundSubtle = "#eff6ff";
export const actionSecondaryColorAccentDefaultBorderStrong = "#2563eb";
export const actionSecondaryColorAccentHoverText = "#1e3a8a";
export const actionSecondaryColorAccentHoverTextMuted = "#1d4ed8";
export const actionSecondaryColorAccentHoverBackground = "#ffffff";
export const actionSecondaryColorAccentHoverBorder = "#1d4ed8";
export const actionSecondaryColorAccentHoverIcon = "#1d4ed8";
export const actionSecondaryColorAccentHoverBackgroundSubtle = "#dbeafe";
export const actionSecondaryColorAccentHoverBorderSubtle = "#93c5fd";
export const actionSecondaryColorAccentFocusedText = "#1d4ed8";
export const actionSecondaryColorAccentFocusedBackground = "#ffffff";
export const actionSecondaryColorAccentFocusedBorder = "#93c5fd";
export const actionSecondaryColorAccentFocusedIcon = "#3b82f6";
export const actionSecondaryColorAccentFocusedBorderStrong = "#3b82f6";
export const actionSecondaryColorAccentFocusedBackgroundMuted = "#eff6ff";
export const actionSecondaryColorAccentActiveText = "#1d4ed8";
export const actionSecondaryColorAccentActiveBackground = "#ffffff";
export const actionSecondaryColorAccentActiveBorder = "#3b82f6";
export const actionSecondaryColorAccentActiveIcon = "#3b82f6";
export const actionSecondaryColorAccentDisabledText = "#93c5fd";
export const actionSecondaryColorAccentDisabledBackground = "#ffffff";
export const actionSecondaryColorAccentDisabledBorder = "#bfdbfe";
export const actionSecondaryColorAccentDisabledIcon = "#dbeafe";
export const actionSecondaryColorAccentSelectedText = "#1d4ed8";
export const actionSecondaryColorAccentSelectedBackground = "#ffffff";
export const actionSecondaryColorAccentSelectedBorder = "#3b82f6";
export const actionSecondaryColorAccentSelectedIcon = "#3b82f6";
export const actionSecondaryColorDangerDefaultText = "#b91c1c";
export const actionSecondaryColorDangerDefaultBackground = "#ffffff";
export const actionSecondaryColorDangerDefaultBackgroundSubtle = "#fef2f2";
export const actionSecondaryColorDangerDefaultBorder = "#ef4444";
export const actionSecondaryColorDangerDefaultIcon = "#ef4444";
export const actionSecondaryColorDangerDefaultBorderSubtle = "#fca5a5";
export const actionSecondaryColorDangerHoverText = "#991b1b";
export const actionSecondaryColorDangerHoverBackground = "#ffffff";
export const actionSecondaryColorDangerHoverBackgroundSubtle = "#fef2f2";
export const actionSecondaryColorDangerHoverBorder = "#b91c1c";
export const actionSecondaryColorDangerHoverIcon = "#b91c1c";
export const actionSecondaryColorDangerHoverBorderSubtle = "#fca5a5";
export const actionSecondaryColorDangerHoverIconSubtle = "#ef4444";
export const actionSecondaryColorDangerFocusedText = "#b91c1c";
export const actionSecondaryColorDangerFocusedBackground = "#ffffff";
export const actionSecondaryColorDangerFocusedBorder = "#fca5a5";
export const actionSecondaryColorDangerFocusedIcon = "#ef4444";
export const actionSecondaryColorDangerFocusedBorderStrong = "#ef4444";
export const actionSecondaryColorDangerFocusedBackgroundSubtle = "#fef2f2";
export const actionSecondaryColorDangerActiveText = "#b91c1c";
export const actionSecondaryColorDangerActiveBackground = "#ffffff";
export const actionSecondaryColorDangerActiveBorder = "#dc2626";
export const actionSecondaryColorDangerActiveIcon = "#ef4444";
export const actionSecondaryColorDangerDisabledText = "#fca5a5";
export const actionSecondaryColorDangerDisabledBackground = "#ffffff";
export const actionSecondaryColorDangerDisabledBorder = "#fecaca";
export const actionSecondaryColorDangerDisabledIcon = "#fee2e2";
export const actionSecondaryColorDangerSelectedText = "#b91c1c";
export const actionSecondaryColorDangerSelectedBackground = "#ffffff";
export const actionSecondaryColorDangerSelectedBorder = "#dc2626";
export const actionSecondaryColorDangerSelectedIcon = "#ef4444";
export const actionSecondaryColorNeutralDefaultText = "#374151";
export const actionSecondaryColorNeutralDefaultBackground = "#ffffff";
export const actionSecondaryColorNeutralDefaultBorder = "#d1d5db";
export const actionSecondaryColorNeutralDefaultBorderSubtle = "#f3f4f6";
export const actionSecondaryColorNeutralDefaultBorderStrong = "#9ca3af";
export const actionSecondaryColorNeutralDefaultIcon = "#6b7280";
export const actionSecondaryColorNeutralDefaultIconMuted = "#9ca3af";
export const actionSecondaryColorNeutralDefaultBorderMuted = "#e5e7eb";
export const actionSecondaryColorNeutralDefaultBackgroundSubtle = "#f9fafb";
export const actionSecondaryColorNeutralDefaultTextMuted = "#6b7280";
export const actionSecondaryColorNeutralDefaultTextStrong = "#111827";
export const actionSecondaryColorNeutralDefaultBackgroundMuted = "#f3f4f6";
export const actionSecondaryColorNeutralHoverText = "#111827";
export const actionSecondaryColorNeutralHoverBackground = "#f9fafb";
export const actionSecondaryColorNeutralHoverBorder = "#d1d5db";
export const actionSecondaryColorNeutralHoverIcon = "#374151";
export const actionSecondaryColorNeutralHoverBackgroundSubtle = "#e5e7eb";
export const actionSecondaryColorNeutralHoverBackgroundMuted = "#f3f4f6";
export const actionSecondaryColorNeutralFocusedText = "#374151";
export const actionSecondaryColorNeutralFocusedBackground = "#ffffff";
export const actionSecondaryColorNeutralFocusedBorder = "#d1d5db";
export const actionSecondaryColorNeutralFocusedIcon = "#6b7280";
export const actionSecondaryColorNeutralFocusedBorderMuted = "#e5e7eb";
export const actionSecondaryColorNeutralActiveText = "#374151";
export const actionSecondaryColorNeutralActiveBackground = "#ffffff";
export const actionSecondaryColorNeutralActiveBorder = "#d1d5db";
export const actionSecondaryColorNeutralActiveIcon = "#6b7280";
export const actionSecondaryColorNeutralActiveBackgroundStrong = "#f3f4f6";
export const actionSecondaryColorNeutralDisabledText = "#d1d5db";
export const actionSecondaryColorNeutralDisabledBackground = "#ffffff";
export const actionSecondaryColorNeutralDisabledBorder = "#e5e7eb";
export const actionSecondaryColorNeutralDisabledBorderSubtle = "#f3f4f6";
export const actionSecondaryColorNeutralDisabledIcon = "#e5e7eb";
export const actionSecondaryColorNeutralDisabledBackgroundSubtle = "#f9fafb";
export const actionSecondaryColorNeutralSelectedText = "#374151";
export const actionSecondaryColorNeutralSelectedBackground = "#ffffff";
export const actionSecondaryColorNeutralSelectedBorder = "#d1d5db";
export const actionSecondaryColorNeutralSelectedIcon = "#6b7280";
export const actionSecondaryColorNeutralSelectedBackgroundStrong = "#EAECF0";
export const actionSecondaryColorSelectorText = "#374151";
export const actionSecondaryColorSelectorTextMuted = "#6b7280";
export const actionSecondaryColorSelectorBackground = "#ffffff";
export const actionSecondaryColorSelectorBorder = "#e5e7eb";
export const actionSecondaryColorSelectorIcon = "#6b7280";
export const actionSecondaryColorSelectorHoverText = "#111827";
export const actionSecondaryColorSelectorHoverBackground = "#f9fafb";
export const actionSecondaryColorSelectorHoverBorder = "#d1d5db";
export const actionSecondaryColorSelectorHoverIcon = "#374151";
export const actionSecondaryColorSelectorFocusedText = "#374151";
export const actionSecondaryColorSelectorFocusedTextMuted = "#6b7280";
export const actionSecondaryColorSelectorFocusedBackground = "#ffffff";
export const actionSecondaryColorSelectorFocusedBorder = "#e5e7eb";
export const actionSecondaryColorSelectorFocusedIcon = "#4b5563";
export const actionSecondaryColorSelectorActiveText = "#374151";
export const actionSecondaryColorSelectorActiveTextMuted = "#6b7280";
export const actionSecondaryColorSelectorActiveBackground = "#ffffff";
export const actionSecondaryColorSelectorActiveBorder = "#d1d5db";
export const actionSecondaryColorSelectorActiveIcon = "#6b7280";
export const actionSecondaryColorSelectorDisabledText = "#d1d5db";
export const actionSecondaryColorSelectorDisabledBackground = "#ffffff";
export const actionSecondaryColorSelectorDisabledBorder = "#e5e7eb";
export const actionSecondaryColorSelectorDisabledIcon = "#e5e7eb";
export const actionSecondaryColorSelectorSelectedText = "#111827";
export const actionSecondaryColorSelectorSelectedBackground = "#f9fafb";
export const actionSecondaryColorSelectorSelectedBorder = "#d1d5db";
export const actionSecondaryColorSelectorSelectedIcon = "#374151";
export const actionSecondaryColorSuccessDefaultText = "#047857";
export const actionSecondaryColorSuccessDefaultBackground = "#ffffff";
export const actionSecondaryColorSuccessDefaultBorder = "#10b981";
export const actionSecondaryColorSuccessDefaultIcon = "#10b981";
export const actionSecondaryColorSuccessHoverText = "#065f46";
export const actionSecondaryColorSuccessHoverBackground = "#ffffff";
export const actionSecondaryColorSuccessHoverBorder = "#047857";
export const actionSecondaryColorSuccessHoverIcon = "#047857";
export const actionSecondaryColorSuccessFocusedText = "#047857";
export const actionSecondaryColorSuccessFocusedBackground = "#ffffff";
export const actionSecondaryColorSuccessFocusedBorder = "#6ee7b7";
export const actionSecondaryColorSuccessFocusedIcon = "#10b981";
export const actionSecondaryColorSuccessActiveText = "#047857";
export const actionSecondaryColorSuccessActiveBackground = "#ffffff";
export const actionSecondaryColorSuccessActiveBorder = "#059669";
export const actionSecondaryColorSuccessActiveIcon = "#10b981";
export const actionSecondaryColorSuccessDisabledText = "#34d399";
export const actionSecondaryColorSuccessDisabledBackground = "#ffffff";
export const actionSecondaryColorSuccessDisabledBorder = "#a7f3d0";
export const actionSecondaryColorSuccessDisabledIcon = "#a7f3d0";
export const actionSecondaryColorSuccessSelectedText = "#047857";
export const actionSecondaryColorSuccessSelectedBackground = "#ffffff";
export const actionSecondaryColorSuccessSelectedBorder = "#059669";
export const actionSecondaryColorSuccessSelectedIcon = "#10b981";
export const actionTertiaryColorAccentDefaultText = "#1d4ed8";
export const actionTertiaryColorAccentDefaultBackground = "#FFFFFF00";
export const actionTertiaryColorAccentDefaultIcon = "#3b82f6";
export const actionTertiaryColorAccentDefaultBackgroundSubtle = "#eff6ff";
export const actionTertiaryColorAccentHoverText = "#1d4ed8";
export const actionTertiaryColorAccentHoverBackground = "#f3f4f6";
export const actionTertiaryColorAccentHoverIcon = "#3b82f6";
export const actionTertiaryColorAccentHoverTextStrong = "#1e3a8a";
export const actionTertiaryColorAccentFocusedText = "#1d4ed8";
export const actionTertiaryColorAccentFocusedBackground = "#ffffff";
export const actionTertiaryColorAccentFocusedIcon = "#3b82f6";
export const actionTertiaryColorAccentActiveText = "#1d4ed8";
export const actionTertiaryColorAccentActiveBackground = "#FFFFFF00";
export const actionTertiaryColorAccentActiveIcon = "#3b82f6";
export const actionTertiaryColorAccentDisabledText = "#93c5fd";
export const actionTertiaryColorAccentDisabledBackground = "#FFFFFF00";
export const actionTertiaryColorAccentDisabledIcon = "#bfdbfe";
export const actionTertiaryColorAccentSelectedText = "#1d4ed8";
export const actionTertiaryColorAccentSelectedBackground = "#FFFFFF00";
export const actionTertiaryColorAccentSelectedIcon = "#3b82f6";
export const actionTertiaryColorDangerDefaultText = "#b91c1c";
export const actionTertiaryColorDangerDefaultBackground = "#FFFFFF00";
export const actionTertiaryColorDangerDefaultIcon = "#ef4444";
export const actionTertiaryColorDangerHoverText = "#7f1d1d";
export const actionTertiaryColorDangerHoverBackground = "#fee2e2";
export const actionTertiaryColorDangerHoverIcon = "#b91c1c";
export const actionTertiaryColorDangerFocusedText = "#b91c1c";
export const actionTertiaryColorDangerFocusedBackground = "#ffffff";
export const actionTertiaryColorDangerFocusedIcon = "#ef4444";
export const actionTertiaryColorDangerActiveText = "#b91c1c";
export const actionTertiaryColorDangerActiveBackground = "#FFFFFF00";
export const actionTertiaryColorDangerActiveIcon = "#ef4444";
export const actionTertiaryColorDangerDisabledText = "#fca5a5";
export const actionTertiaryColorDangerDisabledBackground = "#FFFFFF00";
export const actionTertiaryColorDangerDisabledIcon = "#fecaca";
export const actionTertiaryColorDangerSelectedText = "#b91c1c";
export const actionTertiaryColorDangerSelectedBackground = "#FFFFFF00";
export const actionTertiaryColorDangerSelectedIcon = "#ef4444";
export const actionTertiaryColorNeutralDefaultText = "#374151";
export const actionTertiaryColorNeutralDefaultBackground = "#FFFFFF00"; // #ffffff 0%
export const actionTertiaryColorNeutralDefaultIcon = "#6b7280";
export const actionTertiaryColorNeutralDefaultTextSubtle = "#6b7280";
export const actionTertiaryColorNeutralHoverText = "#111827";
export const actionTertiaryColorNeutralHoverBackground = "#f3f4f6";
export const actionTertiaryColorNeutralHoverIcon = "#374151";
export const actionTertiaryColorNeutralHoverBackgroundSubtle = "#ffffff";
export const actionTertiaryColorNeutralFocusedText = "#374151";
export const actionTertiaryColorNeutralFocusedBackground = "#ffffff";
export const actionTertiaryColorNeutralFocusedIcon = "#6b7280";
export const actionTertiaryColorNeutralActiveText = "#374151";
export const actionTertiaryColorNeutralActiveBackground = "#FFFFFF00";
export const actionTertiaryColorNeutralActiveIcon = "#6b7280";
export const actionTertiaryColorNeutralDisabledText = "#d1d5db";
export const actionTertiaryColorNeutralDisabledBackground = "#FFFFFF00";
export const actionTertiaryColorNeutralDisabledIcon = "#e5e7eb";
export const actionTertiaryColorNeutralDisabledBackgroundMuted = "#e5e7eb";
export const actionTertiaryColorNeutralSelectedText = "#374151";
export const actionTertiaryColorNeutralSelectedBackground = "#FFFFFF00";
export const actionTertiaryColorNeutralSelectedIcon = "#6b7280";
export const actionTertiaryColorSuccessDefaultText = "#047857";
export const actionTertiaryColorSuccessDefaultBackground = "#FFFFFF00";
export const actionTertiaryColorSuccessDefaultIcon = "#10b981";
export const actionTertiaryColorSuccessHoverText = "#064e3b";
export const actionTertiaryColorSuccessHoverBackground = "#d1fae5";
export const actionTertiaryColorSuccessHoverIcon = "#047857";
export const actionTertiaryColorSuccessFocusedText = "#047857";
export const actionTertiaryColorSuccessFocusedBackground = "#ffffff";
export const actionTertiaryColorSuccessFocusedIcon = "#10b981";
export const actionTertiaryColorSuccessActiveText = "#047857";
export const actionTertiaryColorSuccessActiveBackground = "#FFFFFF00";
export const actionTertiaryColorSuccessActiveIcon = "#10b981";
export const actionTertiaryColorSuccessDisabledText = "#34d399";
export const actionTertiaryColorSuccessDisabledBackground = "#FFFFFF00";
export const actionTertiaryColorSuccessDisabledIcon = "#a7f3d0";
export const actionTertiaryColorSuccessSelectedText = "#047857";
export const actionTertiaryColorSuccessSelectedBackground = "#FFFFFF00";
export const actionTertiaryColorSuccessSelectedIcon = "#10b981";
export const actionLinkColorAccentDefaultText = "#1d4ed8";
export const actionLinkColorAccentDefaultBackground = "#ffffff00";
export const actionLinkColorAccentDefaultIcon = "#3b82f6";
export const actionLinkColorAccentHoverText = "#1e40af";
export const actionLinkColorAccentHoverBackground = "#ffffff00";
export const actionLinkColorAccentHoverIcon = "#1d4ed8";
export const actionLinkColorAccentFocusedText = "#1d4ed8";
export const actionLinkColorAccentFocusedBackground = "#ffffff";
export const actionLinkColorAccentFocusedIcon = "#3b82f6";
export const actionLinkColorAccentActiveText = "#1d4ed8";
export const actionLinkColorAccentActiveBackground = "#ffffff00";
export const actionLinkColorAccentActiveIcon = "#3b82f6";
export const actionLinkColorAccentDisabledText = "#93c5fd";
export const actionLinkColorAccentDisabledBackground = "#ffffff00";
export const actionLinkColorAccentDisabledIcon = "#bfdbfe";
export const actionLinkColorAccentSelectedText = "#1d4ed8";
export const actionLinkColorAccentSelectedBackground = "#ffffff00";
export const actionLinkColorAccentSelectedIcon = "#3b82f6";
export const actionLgFont = "500 16px/24px Inter";
export const actionLgBorderRadiusSquared = "8px";
export const actionLgBorderRadiusNone = "0px";
export const actionLgBorderRadiusFull = "100px";
export const actionLgVerticalPadding = "8px";
export const actionLgHorizontalPadding = "12px";
export const actionLgGap = "8px";
export const actionLgGapZero = "0px";
export const actionLgBorderWidth = "1px";
export const actionLgHeight = "40px";
export const actionLgWidth = "40px";
export const actionLgLinkHeight = "28px";
export const actionMdFont = "500 14px/20px Inter";
export const actionMdBorderRadiusSquared = "6px";
export const actionMdBorderRadiusRound = "8px";
export const actionMdBorderRadiusFull = "100px";
export const actionMdBorderRadiusNone = "0px";
export const actionMdVerticalPadding = "6px";
export const actionMdHorizontalPadding = "12px";
export const actionMdGap = "6px";
export const actionMdGapNull = "0px";
export const actionMdBorderWidth = "1px";
export const actionMdHeight = "32px";
export const actionMdWidth = "32px";
export const actionMdLinkHeight = "24px";
export const actionSmFont = "500 12px/18px Inter";
export const actionSmBorderRadiusSquared = "6px";
export const actionSmBorderRadiusFull = "100px";
export const actionSmVerticalPadding = "4px";
export const actionSmHorizontalPadding = "8px";
export const actionSmGap = "4px";
export const actionSmGapNull = "0px";
export const actionSmBorderWidth = "1px";
export const actionSmHeight = "24px";
export const actionSmWidth = "24px";
export const actionSmLinkHeight = "20px";
export const actionShadowAccentFocusedShadow = "0 1px 2px 0 #B2CCFF, 0 0 0 4px #dbeafe";
export const actionShadowAccentBoxShadow = "0 1px 2px 0 #e5e7eb";
export const actionShadowDangerFocusedShadow = "0 1px 2px 0 #FECDCA, 0 0 0 4px #FEE4E2";
export const actionShadowDangerBoxShadow = "0 1px 2px 0 #e5e7eb";
export const actionShadowNeutralFocusedShadow = "0 1px 2px 0 #e5e7eb, 0 0 0 4px #f3f4f6";
export const actionShadowNeutralBoxShadow = "0 1px 2px 0 #e5e7eb";
export const actionShadowSelectorFocusedShadow = "0 1px 2px 0 #e5e7eb, 0 0 0 4px #f3f4f6";
export const actionShadowSelectorBoxShadow = "0 1px 1px 2px rgba(17,24,38,0.02)";
export const actionShadowSuccessFocusedShadow = "0 1px 2px 0 #AAF0C4, 0 0 0 4px #D3F8DF";
export const actionShadowSuccessBoxShadow = "0 1px 2px 0 #e5e7eb";
export const actionXsFont = "500 12px/18px Inter";
export const actionXsHeight = "16px";
export const actionXsLinkHeight = "20px";
export const actionXsWidth = "16px";
export const actionXsBorderRadiusSquared = "6px";
export const actionXsBorderRadiusRound = "8px";
export const actionXsBorderRadiusFull = "100px";
export const actionXsVerticalPadding = "4px";
export const actionXsHorizontalPadding = "8px";
export const actionXsGap = "4px";
export const actionXsGapZero = "0px";
export const actionXsBorderWidth = "1px";
export const badgeDefaultFont = "500 12px/18px Inter";
export const badgeText = "#1f2937";
export const badgeTextStrong = "#374151";
export const badgeTextHover = "#111827";
export const badgeTextMuted = "#6b7280";
export const badgeBorderSubtle = "#e5e7eb";
export const badgeBorder = "1px solid #374151";
export const badgeBackground = "#e5e7eb";
export const badgeBackgroundWhite = "#ffffff";
export const badgeIcon = "#6b7280";
export const badgeIconHover = "#4b5563";
export const badgeGrayText = "#1f2937";
export const badgeGrayTextHover = "#111827";
export const badgeGrayTextMuted = "#6b7280";
export const badgeGrayBorder = "#374151";
export const badgeGrayBorderSubtle = "#e5e7eb";
export const badgeGrayBackground = "#e5e7eb";
export const badgeGrayBackgroundWhite = "#ffffff";
export const badgeGrayIcon = "#4b5563";
export const badgeGrayDot = "#374151";
export const badgeRedText = "#991b1b";
export const badgeRedTextHover = "#7f1d1d";
export const badgeRedTextMuted = "#b91c1c";
export const badgeRedBorder = "#b91c1c";
export const badgeRedBorderSubtle = "#fecaca";
export const badgeRedBackground = "#fecaca";
export const badgeRedBackgroundWhite = "#ffffff";
export const badgeRedIcon = "#dc2626";
export const badgeRedDot = "#b91c1c";
export const badgeOrangeText = "#9a3412";
export const badgeOrangeTextMuted = "#c2410c";
export const badgeOrangeTextHover = "#7c2d12";
export const badgeOrangeBorder = "#c2410c";
export const badgeOrangeBorderSubtle = "#fed7aa";
export const badgeOrangeBackground = "#fed7aa";
export const badgeOrangeBackgroundWhite = "#ffffff";
export const badgeOrangeIcon = "#ea580c";
export const badgeOrangeDot = "#c2410c";
export const badgeAmberText = "#92400e";
export const badgeAmberTextMuted = "#b45309";
export const badgeAmberTextHover = "#78350f";
export const badgeAmberBorder = "#b45309";
export const badgeAmberBorderSubtle = "#fde68a";
export const badgeAmberBackground = "#fde68a";
export const badgeAmberBackgroundWhite = "#ffffff";
export const badgeAmberIcon = "#d97706";
export const badgeAmberDot = "#b45309";
export const badgeYellowText = "#854d0e";
export const badgeYellowTextMuted = "#a16207";
export const badgeYellowTextHover = "#713f12";
export const badgeYellowBorder = "#a16207";
export const badgeYellowBorderSubtle = "#fef08a";
export const badgeYellowBackground = "#fef08a";
export const badgeYellowBackgroundWhite = "#ffffff";
export const badgeYellowIcon = "#ca8a04";
export const badgeYellowDot = "#a16207";
export const badgeLimeText = "#3f6212";
export const badgeLimeTextMuted = "#4d7c0f";
export const badgeLimeTextHover = "#365314";
export const badgeLimeBorder = "#4d7c0f";
export const badgeLimeBorderSubtle = "#ecfccb";
export const badgeLimeBackground = "#d9f99d";
export const badgeLimeBackgroundWhite = "#ffffff";
export const badgeLimeIcon = "#65a30d";
export const badgeLimeDot = "#4d7c0f";
export const badgeEmeraldText = "#065f46";
export const badgeEmeraldTextMuted = "#047857";
export const badgeEmeraldTextHover = "#064e3b";
export const badgeEmeraldBorder = "#047857";
export const badgeEmeraldBorderSubtle = "#d1fae5";
export const badgeEmeraldBackground = "#a7f3d0";
export const badgeEmeraldBackgroundWhite = "#ffffff";
export const badgeEmeraldIcon = "#059669";
export const badgeEmeraldDot = "#047857";
export const badgeTealText = "#115e59";
export const badgeTealTextMuted = "#0f766e";
export const badgeTealTextHover = "#134e4a";
export const badgeTealBorder = "#0f766e";
export const badgeTealBorderSubtle = "#99f6e4";
export const badgeTealBackground = "#99f6e4";
export const badgeTealBackgroundWhite = "#ffffff";
export const badgeTealIcon = "#0d9488";
export const badgeTealDot = "#0f766e";
export const badgeCyanText = "#155e75";
export const badgeCyanTextMuted = "#0e7490";
export const badgeCyanTextHover = "#164e63";
export const badgeCyanBorder = "#0e7490";
export const badgeCyanBorderSubtle = "#a5f3fc";
export const badgeCyanBackground = "#a5f3fc";
export const badgeCyanBackgroundWhite = "#ffffff";
export const badgeCyanIcon = "#0891b2";
export const badgeCyanDot = "#164e63";
export const badgeSkyText = "#075985";
export const badgeSkyTextMuted = "#0369a1";
export const badgeSkyTextHover = "#0c4a6e";
export const badgeSkyBorder = "#0369a1";
export const badgeSkyBorderSubtle = "#bae6fd";
export const badgeSkyBackground = "#bae6fd";
export const badgeSkyBackgroundWhite = "#ffffff";
export const badgeSkyIcon = "#0284c7";
export const badgeSkyDot = "#0369a1";
export const badgeBlueText = "#1e40af";
export const badgeBlueTextMuted = "#1d4ed8";
export const badgeBlueTextHover = "#1e3a8a";
export const badgeBlueBorder = "#1d4ed8";
export const badgeBlueBorderSubtle = "#bfdbfe";
export const badgeBlueBackground = "#bfdbfe";
export const badgeBlueBackgroundWhite = "#ffffff";
export const badgeBlueIcon = "#2563eb";
export const badgeBlueDot = "#1d4ed8";
export const badgeIndigoText = "#3730a3";
export const badgeIndigoTextMuted = "#4338ca";
export const badgeIndigoTextHover = "#312e81";
export const badgeIndigoBorder = "#4338ca";
export const badgeIndigoBorderSubtle = "#c7d2fe";
export const badgeIndigoBackground = "#c7d2fe";
export const badgeIndigoBackgroundWhite = "#ffffff";
export const badgeIndigoIcon = "#4f46e5";
export const badgeIndigoDot = "#4338ca";
export const badgeVioletText = "#5b21b6";
export const badgeVioletTextMuted = "#6d28d9";
export const badgeVioletTextHover = "#4c1d95";
export const badgeVioletBorder = "#6d28d9";
export const badgeVioletBorderSubtle = "#ddd6fe";
export const badgeVioletBackground = "#ddd6fe";
export const badgeVioletBackgroundWhite = "#ffffff";
export const badgeVioletIcon = "#7c3aed";
export const badgeVioletDot = "#4c1d95";
export const badgePurpleText = "#6b21a8";
export const badgePurpleTextMuted = "#7e22ce";
export const badgePurpleTextHover = "#581c87";
export const badgePurpleBorder = "#7e22ce";
export const badgePurpleBorderSubtle = "#e9d5ff";
export const badgePurpleBackground = "#e9d5ff";
export const badgePurpleBackgroundWhite = "#ffffff";
export const badgePurpleIcon = "#9333ea";
export const badgePurpleDot = "#7e22ce";
export const badgeFuchsiaText = "#86198f";
export const badgeFuchsiaTextMuted = "#a21caf";
export const badgeFuchsiaTextHover = "#701a75";
export const badgeFuchsiaBorder = "#a21caf";
export const badgeFuchsiaBorderSubtle = "#f5d0fe";
export const badgeFuchsiaBackground = "#f5d0fe";
export const badgeFuchsiaBackgroundWhite = "#f5d0fe";
export const badgeFuchsiaIcon = "#c026d3";
export const badgeFuchsiaDot = "#a21caf";
export const badgePinkText = "#9d174d";
export const badgePinkTextMuted = "#be185d";
export const badgePinkTextHover = "#831843";
export const badgePinkBorder = "#be185d";
export const badgePinkBorderSubtle = "#fbcfe8";
export const badgePinkBackground = "#fbcfe8";
export const badgePinkBackgroundWhite = "#ffffff";
export const badgePinkIcon = "#db2777";
export const badgePinkDot = "#be185d";
export const badgeRoseText = "#9f1239";
export const badgeRoseTextMuted = "#be123c";
export const badgeRoseTextHover = "#881337";
export const badgeRoseBorder = "#be123c";
export const badgeRoseBorderSubtle = "#fecdd3";
export const badgeRoseBackground = "#fecdd3";
export const badgeRoseBackgroundWhite = "#ffffff";
export const badgeRoseIcon = "#e11d48";
export const badgeRoseDot = "#be123c";
export const badgeBorderRadius = "100%";
export const badgeHeight = "20px";
export const badgeNoGap = "20px";
export const badgeSmFont = "500 12px/18px Inter";
export const badgeSmBorderRadius = "6px";
export const badgeSmHorizontalPadding = "10px";
export const badgeSmGap = "6px";
export const badgeSmHeight = "24px";
export const badgeMdFont = "500 13px/18px Inter";
export const badgeMdBorderRadius = "6px";
export const badgeMdHorizontalPadding = "12px";
export const badgeMdGap = "8px";
export const badgeMdHeight = "28px";
export const badgeLgFont = "500 14px/20px Inter";
export const badgeLgBorderRadius = "8px";
export const badgeLgHorizontalPadding = "12px";
export const badgeLgGap = "8px";
export const badgeLgHeight = "32px";
export const badgeXsFont = "500 12px/18px Inter";
export const badgeXsBorderRadius = "4px";
export const badgeXsHorizontalPadding = "8px";
export const badgeXsGap = "6px";
export const badgeXsHeight = "20px";
export const tagSmFont = "400 12px/18px Inter";
export const tagSmBorderRadius = "100px";
export const tagSmHeight = "20px";
export const tagMdFont = "400 13px/18px Inter";
export const tagMdBorderRadius = "100px";
export const tagMdHeight = "24px";
export const tagLgFont = "400 13px/18px Inter";
export const tagLgBorderRadius = "100px";
export const tagLgHeight = "28px";
export const tagXlFont = "400 13px/18px Inter";
export const tagXlBorderRadius = "100px";
export const tagXlHeight = "32px";
export const tagXlHorizontalPadding = "12px";
export const componentColorBrightGrayText = "#1f2937";
export const componentColorBrightGrayBorder = "#374151";
export const componentColorBrightGrayBackground = "#e5e7eb";
export const componentColorBrightGrayBackgroundWhite = "#ffffff";
export const componentColorBrightGrayIcon = "#374151";
export const componentColorBrightGrayDot = "#374151";
export const componentColorBrightRedText = "#991b1b";
export const componentColorBrightRedBorder = "#b91c1c";
export const componentColorBrightRedBackground = "#fecaca";
export const componentColorBrightRedBackgroundWhite = "#ffffff";
export const componentColorBrightRedIcon = "#b91c1c";
export const componentColorBrightRedDot = "#b91c1c";
export const componentColorBrightOrangeText = "#9a3412";
export const componentColorBrightOrangeBorder = "#c2410c";
export const componentColorBrightOrangeBackground = "#fed7aa";
export const componentColorBrightOrangeBackgroundWhite = "#ffffff";
export const componentColorBrightOrangeIcon = "#c2410c";
export const componentColorBrightOrangeDot = "#c2410c";
export const componentColorBrightAmberText = "#92400e";
export const componentColorBrightAmberBorder = "#b45309";
export const componentColorBrightAmberBackground = "#fde68a";
export const componentColorBrightAmberBackgroundWhite = "#ffffff";
export const componentColorBrightAmberIcon = "#b45309";
export const componentColorBrightAmberDot = "#b45309";
export const componentColorBrightYellowText = "#854d0e";
export const componentColorBrightYellowBorder = "#a16207";
export const componentColorBrightYellowBackground = "#fef08a";
export const componentColorBrightYellowBackgroundWhite = "#ffffff";
export const componentColorBrightYellowIcon = "#a16207";
export const componentColorBrightYellowDot = "#a16207";
export const componentColorBrightLimeText = "#3f6212";
export const componentColorBrightLimeBorder = "#4d7c0f";
export const componentColorBrightLimeBackground = "#d9f99d";
export const componentColorBrightLimeBackgroundWhite = "#ffffff";
export const componentColorBrightLimeIcon = "#4d7c0f";
export const componentColorBrightLimeDot = "#4d7c0f";
export const componentColorBrightEmeraldText = "#065f46";
export const componentColorBrightEmeraldBorder = "#047857";
export const componentColorBrightEmeraldBackground = "#a7f3d0";
export const componentColorBrightEmeraldBackgroundWhite = "#ffffff";
export const componentColorBrightEmeraldIcon = "#047857";
export const componentColorBrightEmeraldDot = "#047857";
export const componentColorBrightTealText = "#115e59";
export const componentColorBrightTealBorder = "#0f766e";
export const componentColorBrightTealBackground = "#99f6e4";
export const componentColorBrightTealBackgroundWhite = "#ffffff";
export const componentColorBrightTealIcon = "#0f766e";
export const componentColorBrightTealDot = "#0f766e";
export const componentColorBrightCyanText = "#155e75";
export const componentColorBrightCyanBorder = "#0e7490";
export const componentColorBrightCyanBackground = "#a5f3fc";
export const componentColorBrightCyanBackgroundWhite = "#ffffff";
export const componentColorBrightCyanIcon = "#164e63";
export const componentColorBrightCyanDot = "#164e63";
export const componentColorBrightSkyText = "#075985";
export const componentColorBrightSkyBorder = "#0369a1";
export const componentColorBrightSkyBackground = "#bae6fd";
export const componentColorBrightSkyBackgroundWhite = "#ffffff";
export const componentColorBrightSkyIcon = "#0369a1";
export const componentColorBrightSkyDot = "#0369a1";
export const componentColorBrightBlueText = "#1e40af";
export const componentColorBrightBlueBorder = "#1d4ed8";
export const componentColorBrightBlueBackground = "#bfdbfe";
export const componentColorBrightBlueBackgroundWhite = "#ffffff";
export const componentColorBrightBlueIcon = "#1d4ed8";
export const componentColorBrightBlueDot = "#1d4ed8";
export const componentColorBrightIndigoText = "#3730a3";
export const componentColorBrightIndigoBorder = "#4338ca";
export const componentColorBrightIndigoBackground = "#c7d2fe";
export const componentColorBrightIndigoBackgroundWhite = "#ffffff";
export const componentColorBrightIndigoIcon = "#4338ca";
export const componentColorBrightIndigoDot = "#4338ca";
export const componentColorBrightVioletText = "#5b21b6";
export const componentColorBrightVioletBorder = "#6d28d9";
export const componentColorBrightVioletBackground = "#ddd6fe";
export const componentColorBrightVioletBackgroundWhite = "#ffffff";
export const componentColorBrightVioletIcon = "#4c1d95";
export const componentColorBrightVioletDot = "#4c1d95";
export const componentColorBrightPurpleText = "#6b21a8";
export const componentColorBrightPurpleBorder = "#7e22ce";
export const componentColorBrightPurpleBackground = "#e9d5ff";
export const componentColorBrightPurpleBackgroundWhite = "#ffffff";
export const componentColorBrightPurpleIcon = "#7e22ce";
export const componentColorBrightPurpleDot = "#7e22ce";
export const componentColorBrightFuchsiaText = "#86198f";
export const componentColorBrightFuchsiaBorder = "#a21caf";
export const componentColorBrightFuchsiaBackground = "#f5d0fe";
export const componentColorBrightFuchsiaBackgroundWhite = "#ffffff";
export const componentColorBrightFuchsiaIcon = "#a21caf";
export const componentColorBrightFuchsiaDot = "#a21caf";
export const componentColorBrightPinkText = "#9d174d";
export const componentColorBrightPinkBorder = "#be185d";
export const componentColorBrightPinkBackground = "#fbcfe8";
export const componentColorBrightPinkBackgroundWhite = "#ffffff";
export const componentColorBrightPinkIcon = "#be185d";
export const componentColorBrightPinkDot = "#be185d";
export const componentColorBrightRoseText = "#9f1239";
export const componentColorBrightRoseBorder = "#be123c";
export const componentColorBrightRoseBackground = "#fecdd3";
export const componentColorBrightRoseBackgroundWhite = "#ffffff";
export const componentColorBrightRoseIcon = "#be123c";
export const componentColorBrightRoseDot = "#be123c";
export const componentColorStrongGrayText = "#ffffff";
export const componentColorStrongGrayBorder = "#6b7280";
export const componentColorStrongGrayBackground = "#4b5563";
export const componentColorStrongRedText = "#ffffff";
export const componentColorStrongRedBorder = "#ef4444";
export const componentColorStrongRedBackground = "#dc2626";
export const componentColorStrongOrangeText = "#ffffff";
export const componentColorStrongOrangeBorder = "#f97316";
export const componentColorStrongOrangeBackground = "#ea580c";
export const componentColorStrongAmberText = "#ffffff";
export const componentColorStrongAmberBorder = "#f59e0b";
export const componentColorStrongAmberBackground = "#d97706";
export const componentColorStrongYellowText = "#ffffff";
export const componentColorStrongYellowBorder = "#eab308";
export const componentColorStrongYellowBackground = "#ca8a04";
export const componentColorStrongLimeText = "#ffffff";
export const componentColorStrongLimeBorder = "#84cc16";
export const componentColorStrongLimeBackground = "#4d7c0f";
export const componentColorStrongEmeraldText = "#ffffff";
export const componentColorStrongEmeraldBorder = "#10b981";
export const componentColorStrongEmeraldBackground = "#059669";
export const componentColorStrongTealText = "#ffffff";
export const componentColorStrongTealBorder = "#14b8a6";
export const componentColorStrongTealBackground = "#0d9488";
export const componentColorStrongCyanText = "#ffffff";
export const componentColorStrongCyanBorder = "#06b6d4";
export const componentColorStrongCyanBackground = "#0891b2";
export const componentColorStrongSkyText = "#ffffff";
export const componentColorStrongSkyBorder = "#0ea5e9";
export const componentColorStrongSkyBackground = "#0284c7";
export const componentColorStrongBlueText = "#ffffff";
export const componentColorStrongBlueBorder = "#3b82f6";
export const componentColorStrongBlueBackground = "#2563eb";
export const componentColorStrongIndigoText = "#ffffff";
export const componentColorStrongIndigoBorder = "#6366f1";
export const componentColorStrongIndigoBackground = "#4f46e5";
export const componentColorStrongVioletText = "#ffffff";
export const componentColorStrongVioletBorder = "#8b5cf6";
export const componentColorStrongVioletBackground = "#7c3aed";
export const componentColorStrongPurpleText = "#ffffff";
export const componentColorStrongPurpleBorder = "#a855f7";
export const componentColorStrongPurpleBackground = "#9333ea";
export const componentColorStrongFuchsiaText = "#ffffff";
export const componentColorStrongFuchsiaBorder = "#a21caf";
export const componentColorStrongFuchsiaBackground = "#a21caf";
export const componentColorStrongPinkText = "#ffffff";
export const componentColorStrongPinkBorder = "#ec4899";
export const componentColorStrongPinkBackground = "#db2777";
export const componentColorStrongRoseText = "#ffffff";
export const componentColorStrongRoseBorder = "#f43f5e";
export const componentColorStrongRoseBackground = "#e11d48";
export const componentColorSubtleGrayText = "#374151";
export const componentColorSubtleGrayBorder = "#6b7280";
export const componentColorSubtleGrayBackground = "#f9fafb";
export const componentColorSubtleGrayIcon = "#6b7280";
export const componentColorSubtleRedText = "#b91c1c";
export const componentColorSubtleRedBorder = "#ef4444";
export const componentColorSubtleRedBackground = "#fef2f2";
export const componentColorSubtleRedIcon = "#ef4444";
export const componentColorSubtleOrangeText = "#c2410c";
export const componentColorSubtleOrangeBorder = "#f97316";
export const componentColorSubtleOrangeBackground = "#fff7ed";
export const componentColorSubtleOrangeIcon = "#f97316";
export const componentColorSubtleAmberText = "#b45309";
export const componentColorSubtleAmberBorder = "#f59e0b";
export const componentColorSubtleAmberBackground = "#fffbeb";
export const componentColorSubtleAmberIcon = "#f59e0b";
export const componentColorSubtleYellowText = "#a16207";
export const componentColorSubtleYellowBorder = "#eab308";
export const componentColorSubtleYellowBackground = "#fefce8";
export const componentColorSubtleYellowIcon = "#eab308";
export const componentColorSubtleLimeText = "#4d7c0f";
export const componentColorSubtleLimeBorder = "#84cc16";
export const componentColorSubtleLimeBackground = "#f7fee7";
export const componentColorSubtleLimeIcon = "#84cc16";
export const componentColorSubtleEmeraldText = "#047857";
export const componentColorSubtleEmeraldBorder = "#10b981";
export const componentColorSubtleEmeraldBackground = "#ecfdf5";
export const componentColorSubtleEmeraldIcon = "#10b981";
export const componentColorSubtleTealText = "#0f766e";
export const componentColorSubtleTealBorder = "#14b8a6";
export const componentColorSubtleTealBackground = "#f0fdfa";
export const componentColorSubtleTealIcon = "#14b8a6";
export const componentColorSubtleCyanText = "#0e7490";
export const componentColorSubtleCyanBorder = "#06b6d4";
export const componentColorSubtleCyanBackground = "#ecfeff";
export const componentColorSubtleCyanIcon = "#06b6d4";
export const componentColorSubtleSkyText = "#0369a1";
export const componentColorSubtleSkyBorder = "#0ea5e9";
export const componentColorSubtleSkyBackground = "#f0f9ff";
export const componentColorSubtleSkyIcon = "#0ea5e9";
export const componentColorSubtleBlueText = "#1d4ed8";
export const componentColorSubtleBlueBorder = "#3b82f6";
export const componentColorSubtleBlueBackground = "#eff6ff";
export const componentColorSubtleBlueIcon = "#3b82f6";
export const componentColorSubtleIndigoText = "#4338ca";
export const componentColorSubtleIndigoBorder = "#6366f1";
export const componentColorSubtleIndigoBackground = "#eef2ff";
export const componentColorSubtleIndigoIcon = "#6366f1";
export const componentColorSubtleVioletText = "#6d28d9";
export const componentColorSubtleVioletBorder = "#8b5cf6";
export const componentColorSubtleVioletBackground = "#f5f3ff";
export const componentColorSubtleVioletIcon = "#8b5cf6";
export const componentColorSubtlePurpleText = "#7e22ce";
export const componentColorSubtlePurpleBorder = "#a855f7";
export const componentColorSubtlePurpleBackground = "#faf5ff";
export const componentColorSubtlePurpleIcon = "#a855f7";
export const componentColorSubtleFuchsiaText = "#a21caf";
export const componentColorSubtleFuchsiaBorder = "#a21caf";
export const componentColorSubtleFuchsiaBackground = "#fdf4ff";
export const componentColorSubtleFuchsiaIcon = "#d946ef";
export const componentColorSubtlePinkText = "#be185d";
export const componentColorSubtlePinkBorder = "#ec4899";
export const componentColorSubtlePinkBackground = "#fdf2f8";
export const componentColorSubtlePinkIcon = "#ec4899";
export const componentColorSubtleRoseText = "#be123c";
export const componentColorSubtleRoseBorder = "#f43f5e";
export const componentColorSubtleRoseBackground = "#fff1f2";
export const componentColorSubtleRoseIcon = "#f43f5e";
export const componentColorTagText = "#1f2937";
export const componentColorTagTextMuted = "#6b7280";
export const componentColorTagBorder = "#e5e7eb";
export const componentColorTagBackground = "#ffffff";
export const componentColorTagIcon = "#4b5563";
export const componentColorTagDot = "#374151";
export const componentColorTagHoverText = "#111827";
export const componentColorTagHoverBorder = "#d1d5db";
export const componentColorTagHoverBackground = "#f9fafb";
export const componentColorTagHoverIcon = "#374151";
export const componentColorTagHoverDot = "#374151";
export const componentColorTagActiveText = "#111827";
export const componentColorTagActiveBorder = "#d1d5db";
export const componentColorTagActiveBackground = "#f3f4f6";
export const componentColorTagActiveIcon = "#374151";
export const componentColorTagActiveDot = "#374151";
export const componentColorTagFocusText = "#111827";
export const componentColorTagFocusBorder = "#d1d5db";
export const componentColorTagFocusBackground = "#f3f4f6";
export const componentColorTagFocusIcon = "#374151";
export const componentColorTagFocusDot = "#374151";
export const componentColorTagSelectedText = "#111827";
export const componentColorTagSelectedBorder = "#d1d5db";
export const componentColorTagSelectedBackground = "#f9fafb";
export const componentColorTagSelectedIcon = "#374151";
export const componentColorTagSelectedDot = "#374151";
export const componentColorTagDisabledText = "#d1d5db";
export const componentColorTagDisabledBorder = "#e5e7eb";
export const componentColorTagDisabledBackground = "#ffffff";
export const componentColorTagDisabledIcon = "#e5e7eb";
export const componentColorTagDisabledDot = "#e5e7eb";
export const componentColorTagGrayText = "#1f2937";
export const componentColorTagGrayTextMuted = "#6b7280";
export const componentColorTagGrayBorder = "#e5e7eb";
export const componentColorTagGrayBackground = "#ffffff";
export const componentColorTagGrayIcon = "#4b5563";
export const componentColorTagGrayDot = "#374151";
export const componentColorTagGrayHoverText = "#111827";
export const componentColorTagGrayHoverBorder = "#d1d5db";
export const componentColorTagGrayHoverBackground = "#f9fafb";
export const componentColorTagGrayHoverIcon = "#374151";
export const componentColorTagGrayHoverDot = "#374151";
export const componentColorTagGrayActiveText = "#111827";
export const componentColorTagGrayActiveBorder = "#d1d5db";
export const componentColorTagGrayActiveBackground = "#f3f4f6";
export const componentColorTagGrayActiveIcon = "#374151";
export const componentColorTagGrayActiveDot = "#374151";
export const componentColorTagGrayFocusText = "#111827";
export const componentColorTagGrayFocusBorder = "#d1d5db";
export const componentColorTagGrayFocusBackground = "#f3f4f6";
export const componentColorTagGrayFocusIcon = "#374151";
export const componentColorTagGrayFocusDot = "#374151";
export const componentColorTagGraySelectedText = "#111827";
export const componentColorTagGraySelectedBorder = "#d1d5db";
export const componentColorTagGraySelectedBackground = "#f9fafb";
export const componentColorTagGraySelectedIcon = "#374151";
export const componentColorTagGraySelectedDot = "#374151";
export const componentColorTagGrayDisabledText = "#d1d5db";
export const componentColorTagGrayDisabledBorder = "#e5e7eb";
export const componentColorTagGrayDisabledBackground = "#ffffff";
export const componentColorTagGrayDisabledIcon = "#e5e7eb";
export const componentColorTagGrayDisabledDot = "#e5e7eb";
export const componentColorTagRedDot = "#b91c1c";
export const componentColorTagRedHoverDot = "#b91c1c";
export const componentColorTagRedActiveDot = "#b91c1c";
export const componentColorTagRedFocusDot = "#b91c1c";
export const componentColorTagRedSelectedDot = "#b91c1c";
export const componentColorTagRedDisabledDot = "#fecaca";
export const componentColorTagOrangeDot = "#c2410c";
export const componentColorTagOrangeHoverDot = "#c2410c";
export const componentColorTagOrangeActiveDot = "#c2410c";
export const componentColorTagOrangeFocusDot = "#c2410c";
export const componentColorTagOrangeSelectedDot = "#c2410c";
export const componentColorTagOrangeDisabledDot = "#fed7aa";
export const componentColorTagAmberDot = "#b45309";
export const componentColorTagAmberHoverDot = "#b45309";
export const componentColorTagAmberActiveDot = "#b45309";
export const componentColorTagAmberFocusDot = "#b45309";
export const componentColorTagAmberSelectedDot = "#b45309";
export const componentColorTagAmberDisabledDot = "#fde68a";
export const componentColorTagYellowDot = "#a16207";
export const componentColorTagYellowHoverDot = "#a16207";
export const componentColorTagYellowActiveDot = "#a16207";
export const componentColorTagYellowFocusDot = "#a16207";
export const componentColorTagYellowSelectedDot = "#a16207";
export const componentColorTagYellowDisabledDot = "#fef08a";
export const componentColorTagLimeDot = "#4d7c0f";
export const componentColorTagLimeHoverDot = "#4d7c0f";
export const componentColorTagLimeActiveDot = "#4d7c0f";
export const componentColorTagLimeFocusDot = "#4d7c0f";
export const componentColorTagLimeSelectedDot = "#4d7c0f";
export const componentColorTagLimeDisabledDot = "#d9f99d";
export const componentColorTagEmeraldDot = "#047857";
export const componentColorTagEmeraldHoverDot = "#047857";
export const componentColorTagEmeraldActiveDot = "#047857";
export const componentColorTagEmeraldFocusDot = "#047857";
export const componentColorTagEmeraldSelectedDot = "#047857";
export const componentColorTagEmeraldDisabledDot = "#a7f3d0";
export const componentColorTagTealDot = "#0f766e";
export const componentColorTagTealHoverDot = "#0f766e";
export const componentColorTagTealActiveDot = "#0f766e";
export const componentColorTagTealFocusDot = "#0f766e";
export const componentColorTagTealSelectedDot = "#0f766e";
export const componentColorTagTealDisabledDot = "#99f6e4";
export const componentColorTagCyanDot = "#164e63";
export const componentColorTagCyanHoverDot = "#164e63";
export const componentColorTagCyanActiveDot = "#164e63";
export const componentColorTagCyanFocusDot = "#164e63";
export const componentColorTagCyanSelectedDot = "#164e63";
export const componentColorTagCyanDisabledDot = "#a5f3fc";
export const componentColorTagSkyDot = "#0369a1";
export const componentColorTagSkyHoverDot = "#0369a1";
export const componentColorTagSkyActiveDot = "#0369a1";
export const componentColorTagSkyFocusDot = "#0369a1";
export const componentColorTagSkySelectedDot = "#0369a1";
export const componentColorTagSkyDisabledDot = "#bae6fd";
export const componentColorTagBlueDot = "#1d4ed8";
export const componentColorTagBlueHoverDot = "#1d4ed8";
export const componentColorTagBlueActiveDot = "#1d4ed8";
export const componentColorTagBlueFocusDot = "#1d4ed8";
export const componentColorTagBlueSelectedDot = "#1d4ed8";
export const componentColorTagBlueDisabledDot = "#bfdbfe";
export const componentColorTagIndigoDot = "#4338ca";
export const componentColorTagIndigoHoverDot = "#4338ca";
export const componentColorTagIndigoActiveDot = "#4338ca";
export const componentColorTagIndigoFocusDot = "#4338ca";
export const componentColorTagIndigoSelectedDot = "#4338ca";
export const componentColorTagIndigoDisabledDot = "#c7d2fe";
export const componentColorTagVioletDot = "#4c1d95";
export const componentColorTagVioletHoverDot = "#4c1d95";
export const componentColorTagVioletActiveDot = "#4c1d95";
export const componentColorTagVioletFocusDot = "#4c1d95";
export const componentColorTagVioletSelectedDot = "#4c1d95";
export const componentColorTagVioletDisabledDot = "#ddd6fe";
export const componentColorTagPurpleDot = "#7e22ce";
export const componentColorTagPurpleHoverDot = "#7e22ce";
export const componentColorTagPurpleActiveDot = "#7e22ce";
export const componentColorTagPurpleFocusDot = "#7e22ce";
export const componentColorTagPurpleSelectedDot = "#4c1d95";
export const componentColorTagPurpleDisabledDot = "#e9d5ff";
export const componentColorTagFuchsiaDot = "#a21caf";
export const componentColorTagFuchsiaHoverDot = "#a21caf";
export const componentColorTagFuchsiaActiveDot = "#a21caf";
export const componentColorTagFuchsiaFocusDot = "#a21caf";
export const componentColorTagFuchsiaSelectedDot = "#a21caf";
export const componentColorTagFuchsiaDisabledDot = "#f5d0fe";
export const componentColorTagPinkDot = "#be185d";
export const componentColorTagPinkHoverDot = "#be185d";
export const componentColorTagPinkActiveDot = "#be185d";
export const componentColorTagPinkFocusDot = "#be185d";
export const componentColorTagPinkSelectedDot = "#be185d";
export const componentColorTagPinkDisabledDot = "#fbcfe8";
export const componentColorTagRoseDot = "#be123c";
export const componentColorTagRoseHoverDot = "#be123c";
export const componentColorTagRoseActiveDot = "#be123c";
export const componentColorTagRoseFocusDot = "#be123c";
export const componentColorTagRoseSelectedDot = "#be123c";
export const componentColorTagRoseDisabledDot = "#fecdd3";
export const componentColorTag1abc9cDot = "#0F705D";
export const componentColorTag1abc9cHoverDot = "#0F705D";
export const componentColorTag1abc9cActiveDot = "#0F705D";
export const componentColorTag1abc9cFocusDot = "#0F705D";
export const componentColorTag1abc9cSelectedDot = "#0F705D";
export const componentColorTag1abc9cDisabledDot = "#D2F9F1";
export const componentColorTag16a085Dot = "#D2F9F1";
export const componentColorTag16a085HoverDot = "#0F705D";
export const componentColorTag16a085ActiveDot = "#0F705D";
export const componentColorTag16a085FocusDot = "#0F705D";
export const componentColorTag16a085SelectedDot = "#0F705D";
export const componentColorTag16a085DisabledDot = "#A5F3E4";
export const componentColorTagF1c40fDot = "#786207";
export const componentColorTagF1c40fHoverDot = "#786207";
export const componentColorTagF1c40fActiveDot = "#786207";
export const componentColorTagF1c40fFocusDot = "#786207";
export const componentColorTagF1c40fSelectedDot = "#786207";
export const componentColorTagF1c40fDisabledDot = "#FCF3CF";
export const componentColorTagF39c12Dot = "#794D06";
export const componentColorTagF39c12HoverDot = "#794D06";
export const componentColorTagF39c12ActiveDot = "#794D06";
export const componentColorTagF39c12FocusDot = "#794D06";
export const componentColorTagF39c12SelectedDot = "#794D06";
export const componentColorTagF39c12DisabledDot = "#FDEBCE";
export const componentColorTag2ecc71Dot = "#17683A";
export const componentColorTag2ecc71HoverDot = "#17683A";
export const componentColorTag2ecc71ActiveDot = "#17683A";
export const componentColorTag2ecc71FocusDot = "#17683A";
export const componentColorTag2ecc71SelectedDot = "#17683A";
export const componentColorTag2ecc71DisabledDot = "#D5F6E3";
export const componentColorTag27ae60Dot = "#176839";
export const componentColorTag27ae60HoverDot = "#176839";
export const componentColorTag27ae60ActiveDot = "#176839";
export const componentColorTag27ae60FocusDot = "#176839";
export const componentColorTag27ae60SelectedDot = "#176839";
export const componentColorTag27ae60DisabledDot = "#D5F6E3";
export const componentColorTagE67e22Dot = "#733D0D";
export const componentColorTagE67e22HoverDot = "#733D0D";
export const componentColorTagE67e22ActiveDot = "#733D0D";
export const componentColorTagE67e22FocusDot = "#733D0D";
export const componentColorTagE67e22SelectedDot = "#733D0D";
export const componentColorTagE67e22DisabledDot = "#FAE4D1";
export const componentColorTagD35400Dot = "#803300";
export const componentColorTagD35400HoverDot = "#803300";
export const componentColorTagD35400ActiveDot = "#803300";
export const componentColorTagD35400FocusDot = "#803300";
export const componentColorTagD35400SelectedDot = "#803300";
export const componentColorTagD35400DisabledDot = "#FFE0CC";
export const componentColorTag3498dbDot = "#13496C";
export const componentColorTag3498dbHoverDot = "#13496C";
export const componentColorTag3498dbActiveDot = "#13496C";
export const componentColorTag3498dbFocusDot = "#13496C";
export const componentColorTag3498dbSelectedDot = "#13496C";
export const componentColorTag3498dbDisabledDot = "#D4E9F7";
export const componentColorTag2980b9Dot = "#174868";
export const componentColorTag2980b9HoverDot = "#174868";
export const componentColorTag2980b9ActiveDot = "#174868";
export const componentColorTag2980b9FocusDot = "#174868";
export const componentColorTag2980b9SelectedDot = "#174868";
export const componentColorTag2980b9DisabledDot = "#D5E9F6";
export const componentColorTagE74c3cDot = "#72170E";
export const componentColorTagE74c3cHoverDot = "#72170E";
export const componentColorTagE74c3cActiveDot = "#72170E";
export const componentColorTagE74c3cFocusDot = "#72170E";
export const componentColorTagE74c3cSelectedDot = "#72170E";
export const componentColorTagE74c3cDisabledDot = "#F9D5D2";
export const componentColorTagC0392bDot = "#681F17";
export const componentColorTagC0392bHoverDot = "#681F17";
export const componentColorTagC0392bActiveDot = "#681F17";
export const componentColorTagC0392bFocusDot = "#681F17";
export const componentColorTagC0392bSelectedDot = "#681F17";
export const componentColorTagC0392bDisabledDot = "#F6D8D5";
export const componentColorTag9b59b6Dot = "#4A2759";
export const componentColorTag9b59b6HoverDot = "#4A2759";
export const componentColorTag9b59b6ActiveDot = "#4A2759";
export const componentColorTag9b59b6FocusDot = "#4A2759";
export const componentColorTag9b59b6SelectedDot = "#4A2759";
export const componentColorTag9b59b6DisabledDot = "#E9DCEF";
export const componentColorTag8e44adDot = "#4B245C";
export const componentColorTag8e44adHoverDot = "#4B245C";
export const componentColorTag8e44adActiveDot = "#4B245C";
export const componentColorTag8e44adFocusDot = "#4B245C";
export const componentColorTag8e44adSelectedDot = "#4B245C";
export const componentColorTag8e44adDisabledDot = "#EADAF1";
export const componentColorTagBdc3c7Dot = "#3B4145";
export const componentColorTagBdc3c7HoverDot = "#3B4145";
export const componentColorTagBdc3c7ActiveDot = "#3B4145";
export const componentColorTagBdc3c7FocusDot = "#3B4145";
export const componentColorTagBdc3c7SelectedDot = "#3B4145";
export const componentColorTagBdc3c7DisabledDot = "#E4E6E7";
export const componentColorTag34495eDot = "#2D4052";
export const componentColorTag34495eHoverDot = "#2D4052";
export const componentColorTag34495eActiveDot = "#2D4052";
export const componentColorTag34495eFocusDot = "#2D4052";
export const componentColorTag34495eSelectedDot = "#2D4052";
export const componentColorTag34495eDisabledDot = "#DEE6ED";
export const componentColorTag2c3e50Dot = "#2D4052";
export const componentColorTag2c3e50HoverDot = "#2D4052";
export const componentColorTag2c3e50ActiveDot = "#2D4052";
export const componentColorTag2c3e50FocusDot = "#2D4052";
export const componentColorTag2c3e50SelectedDot = "#2D4052";
export const componentColorTag2c3e50DisabledDot = "#DEE6ED";
export const componentColorTag95a5a6Dot = "#3A4545";
export const componentColorTag95a5a6HoverDot = "#3A4545";
export const componentColorTag95a5a6ActiveDot = "#3A4545";
export const componentColorTag95a5a6FocusDot = "#3A4545";
export const componentColorTag95a5a6SelectedDot = "#3A4545";
export const componentColorTag95a5a6DisabledDot = "#E3E8E8";
export const componentColorTag7f8c8dDot = "#3C4343";
export const componentColorTag7f8c8dHoverDot = "#3C4343";
export const componentColorTag7f8c8dActiveDot = "#3C4343";
export const componentColorTag7f8c8dFocusDot = "#3C4343";
export const componentColorTag7f8c8dSelectedDot = "#3C4343";
export const componentColorTag7f8c8dDisabledDot = "#E4E7E7";
export const componentColorTagEc87bfDot = "#6E1145";
export const componentColorTagEc87bfHoverDot = "#6E1145";
export const componentColorTagEc87bfActiveDot = "#6E1145";
export const componentColorTagEc87bfFocusDot = "#6E1145";
export const componentColorTagEc87bfSelectedDot = "#6E1145";
export const componentColorTagEc87bfDisabledDot = "#F8D3E8";
export const componentColorTagD870adDot = "#641B46";
export const componentColorTagD870adHoverDot = "#641B46";
export const componentColorTagD870adActiveDot = "#641B46";
export const componentColorTagD870adFocusDot = "#641B46";
export const componentColorTagD870adSelectedDot = "#641B46";
export const componentColorTagD870adDisabledDot = "#F4D7E8";
export const componentColorTagF69785Dot = "#771A09";
export const componentColorTagF69785HoverDot = "#771A09";
export const componentColorTagF69785ActiveDot = "#771A09";
export const componentColorTagF69785FocusDot = "#771A09";
export const componentColorTagF69785SelectedDot = "#771A09";
export const componentColorTagF69785DisabledDot = "#FBD6D0";
export const componentColorTag9ba37eDot = "#464A35";
export const componentColorTag9ba37eHoverDot = "#464A35";
export const componentColorTag9ba37eActiveDot = "#464A35";
export const componentColorTag9ba37eFocusDot = "#464A35";
export const componentColorTag9ba37eSelectedDot = "#464A35";
export const componentColorTag9ba37eDisabledDot = "#E8EAE1";
export const componentColorTagB49255Dot = "#584727";
export const componentColorTagB49255HoverDot = "#584727";
export const componentColorTagB49255ActiveDot = "#584727";
export const componentColorTagB49255FocusDot = "#584727";
export const componentColorTagB49255SelectedDot = "#584727";
export const componentColorTagB49255DisabledDot = "#EFE8DC";
export const componentColorTagA94136Dot = "#61251F";
export const componentColorTagA94136HoverDot = "#61251F";
export const componentColorTagA94136ActiveDot = "#61251F";
export const componentColorTagA94136FocusDot = "#61251F";
export const componentColorTagA94136SelectedDot = "#61251F";
export const componentColorTagA94136DisabledDot = "#F3DBD8";
export const componentColorTagE61919Dot = "#730D0D";
export const componentColorTagE61919HoverDot = "#730D0D";
export const componentColorTagE61919ActiveDot = "#730D0D";
export const componentColorTagE61919FocusDot = "#730D0D";
export const componentColorTagE61919SelectedDot = "#730D0D";
export const componentColorTagE61919DisabledDot = "#FAD1D1";
export const componentColorTagDc2127Dot = "#6F1114";
export const componentColorTagDc2127HoverDot = "#6F1114";
export const componentColorTagDc2127ActiveDot = "#6F1114";
export const componentColorTagDc2127FocusDot = "#6F1114";
export const componentColorTagDc2127SelectedDot = "#6F1114";
export const componentColorTagDc2127DisabledDot = "#F8D3D4";
export const componentColorTagFf887cDot = "#800C00";
export const componentColorTagFf887cHoverDot = "#800C00";
export const componentColorTagFf887cActiveDot = "#800C00";
export const componentColorTagFf887cFocusDot = "#800C00";
export const componentColorTagFf887cSelectedDot = "#800C00";
export const componentColorTagFf887cDisabledDot = "#FFD1CC";
export const componentColorTagFbd75bDot = "#7C6103";
export const componentColorTagFbd75bHoverDot = "#7C6103";
export const componentColorTagFbd75bActiveDot = "#7C6103";
export const componentColorTagFbd75bFocusDot = "#7C6103";
export const componentColorTagFbd75bSelectedDot = "#7C6103";
export const componentColorTagFbd75bDisabledDot = "#FEF3CD";
export const componentColorTag51b749Dot = "#285B24";
export const componentColorTag51b749HoverDot = "#285B24";
export const componentColorTag51b749ActiveDot = "#285B24";
export const componentColorTag51b749FocusDot = "#285B24";
export const componentColorTag51b749SelectedDot = "#285B24";
export const componentColorTag51b749DisabledDot = "#DCF1DA";
export const componentColorTag5484edDot = "#0C2D73";
export const componentColorTag5484edHoverDot = "#0C2D73";
export const componentColorTag5484edActiveDot = "#0C2D73";
export const componentColorTag5484edFocusDot = "#0C2D73";
export const componentColorTag5484edSelectedDot = "#0C2D73";
export const componentColorTag5484edDisabledDot = "#D1DEFA";
export const componentColorActivitySystemText = "#4b5563";
export const componentColorActivitySystemBorder = "#6b7280";
export const componentColorActivitySystemBackground = "#f9fafb";
export const componentColorActivityNoteText = "#7c3aed";
export const componentColorActivityNoteBorder = "#8b5cf6";
export const componentColorActivityNoteBackground = "#f5f3ff";
export const componentColorActivityIntegrationText = "#e11d48";
export const componentColorActivityIntegrationBorder = "#f43f5e";
export const componentColorActivityIntegrationBackground = "#fff1f2";
export const componentColorActivityEmailText = "#ca8a04";
export const componentColorActivityEmailBorder = "#eab308";
export const componentColorActivityEmailBackground = "#fefce8";
export const componentColorActivitySmsText = "#0284c7";
export const componentColorActivitySmsBorder = "#0ea5e9";
export const componentColorActivitySmsBackground = "#f0f9ff";
export const componentColorActivityPhoneText = "#2563eb";
export const componentColorActivityPhoneBorder = "#3b82f6";
export const componentColorActivityPhoneBackground = "#2563eb";
export const componentColorActivityFormText = "#059669";
export const componentColorActivityFormBorder = "#10b981";
export const componentColorActivityFormBackground = "#059669";
export const componentColorToggleNeutralDefaultIcon = "#ffffff";
export const componentColorToggleNeutralDefaultBackground = "#f3f4f6";
export const componentColorToggleNeutralHoverIcon = "#ffffff";
export const componentColorToggleNeutralHoverBackground = "#e5e7eb";
export const componentColorToggleNeutralFocusedIcon = "#ffffff";
export const componentColorToggleNeutralFocusedBackground = "#f9fafb";
export const componentColorToggleNeutralDisabledIcon = "#FFFFFFD9";
export const componentColorToggleNeutralDisabledBackground = "#f3f4f6";
export const componentColorToggleAccentDefaultIcon = "#ffffff";
export const componentColorToggleAccentDefaultBackgroundStrong = "#2563eb";
export const componentColorToggleAccentDefaultBackgroundSubtle = "#eff6ff";
export const componentColorToggleAccentDefaultBackgroundMuted = "#bfdbfe";
export const componentColorToggleAccentHoverIcon = "#ffffff";
export const componentColorToggleAccentHoverBackgroundStrong = "#1d4ed8";
export const componentColorToggleAccentHoverBackgroundSubtle = "#dbeafe";
export const componentColorToggleAccentHoverBackgroundMuted = "#93c5fd";
export const componentColorToggleAccentFocusedIcon = "#ffffff";
export const componentColorToggleAccentFocusedBackground = "#2563eb";
export const componentColorToggleAccentFocusedBackgroundSubtle = "#eff6ff";
export const componentColorToggleAccentFocusedBackgroundMuted = "#bfdbfe";
export const componentColorToggleAccentDisabledIcon = "#FFFFFFD9";
export const componentColorToggleAccentDisabledBackground = "#eff6ff";
export const componentColorBreadcrumText = "#4b5563";
export const componentColorBreadcrumDivider = "#6b7280";
export const componentColorBreadcrumOverflowText = "#6b7280";
export const componentColorBreadcrumHoverText = "#111827";
export const componentColorBreadcrumHoverDivider = "#111827";
export const componentColorBreadcrumHoverOverflowText = "#111827";
export const componentColorBreadcrumHoverOverflowBackground = "#ffffff";
export const componentColorBreadcrumActiveOverflowText = "#111827";
export const componentColorBreadcrumActiveOverflowBackground = "#ffffff";
export const componentColorBreadcrumCurrentPageText = "#111827";
export const componentColorBreadcrumCurrentPageDivider = "#6b7280";
export const componentColorBreadcrumCurrentPageOverflowText = "#111827";
export const componentColorCardBorder = "lch(89.6 2.46 261)";
export const componentColorCardBackground = "#ffffff";
export const componentColorCardHoverBorder = "#3b82f6";
export const componentColorCardHoverBackground = "hsl(221 83.2% 97.2%)";
export const componentColorCardSelectedBorder = "#3b82f6";
export const componentColorCardSelectedBackground = "#ffffff";
export const componentColorCardOverdueBorder = "#ef4444";
export const componentColorCardOverdueBackground = "#fef2f2";
export const componentColorCardOverdueHoverBorder = "#ef4444";
export const componentColorCardOverdueHoverBackground = "hsl(0 96.3% 95.8%)";
export const componentColorCardOverdueSelectedBorder = "#ef4444";
export const componentColorCardOverdueSelectedBackground = "#ffffff";
export const componentColorChipText = "#374151";
export const componentColorChipIcon = "#6b7280";
export const componentColorChipBorder = "#e5e7eb";
export const componentColorChipBackground = "#ffffff";
export const componentColorChipHoverText = "#111827";
export const componentColorChipHoverIcon = "#374151";
export const componentColorChipHoverBorder = "#d1d5db";
export const componentColorChipHoverBackground = "#f9fafb";
export const componentColorChipSelectedText = "#374151";
export const componentColorChipSelectedIcon = "#6b7280";
export const componentColorChipSelectedBorder = "#d1d5db";
export const componentColorChipSelectedBackground = "#ffffff";
export const componentColorChipActiveText = "#374151";
export const componentColorChipActiveIcon = "#6b7280";
export const componentColorChipActiveBorder = "#3b82f6";
export const componentColorChipActiveBackground = "#ffffff";
export const componentColorChipFocusedText = "#374151";
export const componentColorChipFocusedIcon = "#6b7280";
export const componentColorChipFocusedBorder = "#93c5fd";
export const componentColorChipFocusedBackground = "#ffffff";
export const componentColorChipDisabledText = "#d1d5db";
export const componentColorChipDisabledIcon = "#e5e7eb";
export const componentColorChipDisabledBorder = "#e5e7eb";
export const componentColorChipDisabledBackground = "#ffffff";
export const componentColorControlHeaderBackground = "rgba(255,255,255,0)";
export const componentColorControlHeaderText = "#111827";
export const componentColorControlHeaderBadgeText = "#5b21b6";
export const componentColorControlHeaderBadgeBackground = "#ddd6fe";
export const componentColorControlHeaderLineBorder = "#e5e7eb";
export const componentColorControlHeaderArrowIcon = "#6b7280";
export const componentColorControlHeaderArrowHoverIcon = "#111827";
export const componentColorDropdownMenuItemBackground = "rgba(255,255,255,0)";
export const componentColorDropdownMenuItemBackgroundMuted = "#f3f4f6";
export const componentColorDropdownMenuItemText = "#374151";
export const componentColorDropdownMenuItemTextDanger = "#b91c1c";
export const componentColorDropdownMenuItemSupportingText = "#6b7280";
export const componentColorDropdownMenuItemIcon = "#6b7280";
export const componentColorDropdownMenuItemIconDanger = "#b91c1c";
export const componentColorDropdownMenuItemCheckmark = "#2563eb";
export const componentColorDropdownMenuItemHoverText = "#111827";
export const componentColorDropdownMenuItemHoverSupportingText = "#374151";
export const componentColorDropdownMenuItemHoverIcon = "#374151";
export const componentColorDropdownMenuItemDisabledText = "#d1d5db";
export const componentColorDropdownMenuItemDisabledIcon = "#e5e7eb";
export const componentColorDropdownMenuItemTagCountBackground = "#f5f3ff";
export const componentColorDropdownMenuItemTagCountNumber = "#6d28d9";
export const componentColorModalText = "#111827";
export const componentColorModalSubtext = "#374151";
export const componentColorModalBackground = "#ffffff";
export const componentColorModalIconAccent = "#2563eb";
export const componentColorModalIconSuccess = "#059669";
export const componentColorModalIconInfo = "#0284c7";
export const componentColorModalIconDanger = "#dc2626";
export const componentColorModalIconWarning = "#d97706";
export const componentColorModalIconNeutral = "#4b5563";
export const componentColorModalIconBackgroundAccentMuted = "#dbeafe";
export const componentColorModalIconBackgroundAccentSubtle = "#eff6ff";
export const componentColorModalIconBackgroundNeutralMuted = "#f3f4f6";
export const componentColorModalIconBackgroundNeutralSubtle = "#f9fafb";
export const componentColorModalIconBackgroundInfoMuted = "#e0f2fe";
export const componentColorModalIconBackgroundInfoSubtle = "#f0f9ff";
export const componentColorModalIconBackgroundDangerMuted = "#fee2e2";
export const componentColorModalIconBackgroundDangerSubtle = "#fef2f2";
export const componentColorModalIconBackgroundWarningMuted = "#fef3c7";
export const componentColorModalIconBackgroundWarningSubtle = "#fffbeb";
export const componentColorModalIconBackgroundSuccessMuted = "#d1fae5";
export const componentColorModalIconBackgroundSuccessSubtle = "#ecfdf5";
export const componentColorSideNavContainerDefaultBackground = "#111827";
export const componentColorSideNavContainerDefaultBorder = "#334155";
export const componentColorSideNavContainerDefaultText = "#9ca3af";
export const componentColorSideNavContainerDefaultDivider = "#374151";
export const componentColorSideNavContainerInverseBackground = "#EAECF0";
export const componentColorSideNavContainerInverseBorder = "#D0D5DD";
export const componentColorSideNavContainerInverseText = "#111827";
export const componentColorSideNavItemsDefaultText = "#CDD5DF";
export const componentColorSideNavItemsDefaultSubtext = "#94a3b8";
export const componentColorSideNavItemsDefaultIcon = "#94a3b8";
export const componentColorSideNavItemsDefaultIconSubtle = "#697586";
export const componentColorSideNavItemsDefaultTextSubtle = "#9AA4B2";
export const componentColorSideNavItemsDefaultHoverText = "#CDD5DF";
export const componentColorSideNavItemsDefaultHoverSubtext = "#94a3b8";
export const componentColorSideNavItemsDefaultHoverBackground = "#6b728033";
export const componentColorSideNavItemsDefaultHoverIcon = "#94a3b8";
export const componentColorSideNavItemsDefaultHoverIconSubtle = "#d1d5db";
export const componentColorSideNavItemsDefaultHoverTextSubtle = "#9AA4B2";
export const componentColorSideNavItemsDefaultSelectedText = "#F8FAFC";
export const componentColorSideNavItemsDefaultSelectedSubtext = "#94a3b8";
export const componentColorSideNavItemsDefaultSelectedBackground = "#6b728033";
export const componentColorSideNavItemsDefaultSelectedIcon = "#cbd5e1";
export const componentColorSideNavItemsInverseText = "#374151";
export const componentColorSideNavItemsInverseSubtext = "#94a3b8";
export const componentColorSideNavItemsInverseIcon = "#6b7280";
export const componentColorSideNavItemsInverseHoverText = "#111827";
export const componentColorSideNavItemsInverseHoverSubtext = "#94a3b8";
export const componentColorSideNavItemsInverseHoverBackground = "#f3f4f6";
export const componentColorSideNavItemsInverseHoverIcon = "#374151";
export const componentColorSideNavItemsInverseFocusedText = "#374151";
export const componentColorSideNavItemsInverseFocusedSubtext = "#94a3b8";
export const componentColorSideNavItemsInverseFocusedBackground = "#ffffff";
export const componentColorSideNavItemsInverseFocusedIcon = "#6b7280";
export const componentColorSideNavItemsInverseFocusedBackgroundSubtle = "#f9fafb";
export const componentColorSideNavTooltipText = "#CDD5DF";
export const componentColorSideNavTooltipBackground = "#1f2937";
export const componentColorSideNavTooltipIcon = "#94a3b8";
export const componentColorSideNavTooltipTextSubtle = "#9AA4B2";
export const componentColorSideNavTooltipHoverText = "#CDD5DF";
export const componentColorSideNavTooltipHoverSubtext = "#94a3b8";
export const componentColorSideNavTooltipHoverBackground = "#6b728033";
export const componentColorSideNavTooltipHoverIcon = "#94a3b8";
export const componentColorSideNavTooltipHoverIconSubtle = "#d1d5db";
export const componentColorSideNavTooltipHoverTextSubtle = "#9AA4B2";
export const componentColorSideNavTooltipSelectedText = "#f3f4f6";
export const componentColorSideNavTooltipSelectedSubtext = "#94a3b8";
export const componentColorSideNavTooltipSelectedBackground = "#6b728033";
export const componentColorSideNavTooltipSelectedIcon = "#cbd5e1";
export const componentColorSideNavNotificationText = "#CDD5DF";
export const componentColorSideNavNotificationBackground = "#202939";
export const componentColorSideNavNotificationBorder = "#30374F";
export const componentColorSideNavNotificationIcon = "#8b5cf6";
export const componentColorSideNavNotificationSubtext = "#697586";
export const componentColorSideNavNotificationButtonDefaultText = "#8b5cf6";
export const componentColorSideNavNotificationButtonDefaultIcon = "#8b5cf6";
export const componentColorSideNavNotificationButtonHoverText = "#6d28d9";
export const componentColorSideNavNotificationButtonHoverIcon = "#7c3aed";
export const componentColorSideNavSearchDefaultText = "#9AA4B2";
export const componentColorSideNavSearchDefaultIcon = "#94a3b8";
export const componentColorSideNavSearchDefaultIconSubtle = "#94a3b8";
export const componentColorSideNavSearchDefaultBackground = "#1F2A37";
export const componentColorSideNavSearchDefaultBorder = "#30374F";
export const componentColorSideNavSearchDefaultHoverSelectedText = "#CDD5DF";
export const componentColorSideNavSearchDefaultHoverSelectedSubtext = "#94a3b8";
export const componentColorSideNavSearchDefaultHoverSelectedBackground = "#6b728033";
export const componentColorSideNavSearchDefaultHoverSelectedIcon = "#94a3b8";
export const componentColorSideNavSearchDefaultHoverSelectedIconSubtle = "#d1d5db";
export const componentColorSideNavSearchDefaultHoverSelectedTextSubtle = "#9AA4B2";
export const componentColorDotGrayIcon = "#374151";
export const componentColorDotRedIcon = "#b91c1c";
export const componentColorDotOrangeIcon = "#c2410c";
export const componentColorDotAmberIcon = "#b45309";
export const componentColorDotYellowIcon = "#a16207";
export const componentColorDotLimeIcon = "#4d7c0f";
export const componentColorDotEmeraldIcon = "#047857";
export const componentColorDotTealIcon = "#0f766e";
export const componentColorDotCyanIcon = "#164e63";
export const componentColorDotSkyIcon = "#0369a1";
export const componentColorDotBlueIcon = "#1d4ed8";
export const componentColorDotIndigoIcon = "#4338ca";
export const componentColorDotVioletIcon = "#4c1d95";
export const componentColorDotPurpleIcon = "#7e22ce";
export const componentColorDotFuchsiaIcon = "#a21caf";
export const componentColorDotPinkIcon = "#be185d";
export const componentColorDotRoseIcon = "#be123c";
export const componentColorStatusBadgeOpenText = "#ffffff";
export const componentColorStatusBadgeOpenBackground = "#059669";
export const componentColorStatusBadgeInProgressText = "#ffffff";
export const componentColorStatusBadgeInProgressBackground = "#ea580c";
export const componentColorStatusBadgeOnHoldText = "#ffffff";
export const componentColorStatusBadgeOnHoldBackground = "#dc2626";
export const componentColorStatusBadgeCompletedText = "#ffffff";
export const componentColorStatusBadgeCompletedBackground = "#0284c7";
export const componentColorStatusBadgeFinalisedText = "#ffffff";
export const componentColorStatusBadgeFinalisedBackground = "#2563eb";
export const componentColorStatusBadgeClosedText = "#ffffff";
export const componentColorStatusBadgeClosedBackground = "#ca8a04";
export const componentColorStatusBadgeDraftText = "#64748b";
export const componentColorStatusBadgeDraftIcon = "#64748b";
export const componentColorStatusBadgeDraftBackground = "#e2e8f0";
export const componentColorStatusBadgeNeutralText = "lch(48 6.6 264)";
export const componentColorStatusBadgeNeutralIcon = "lch(54.8 6.92 265)";
export const componentColorStatusBadgeNeutralBackground = "#e5e7eb";
export const componentColorPriorityBadgeP1Text = "#991b1b";
export const componentColorPriorityBadgeP1TextHover = "#7f1d1d";
export const componentColorPriorityBadgeP1Background = "#fecaca";
export const componentColorPriorityBadgeP1Icon = "lch(63.3 46 36.2)";
export const componentColorPriorityBadgeP1IconHover = "#b91c1c";
export const componentColorPriorityBadgeP2Text = "#9a3412";
export const componentColorPriorityBadgeP2TextHover = "#7c2d12";
export const componentColorPriorityBadgeP2Icon = "lch(67 46.6 47.3)";
export const componentColorPriorityBadgeP2IconHover = "#c2410c";
export const componentColorPriorityBadgeP2Background = "#fed7aa";
export const componentColorPriorityBadgeP3Text = "#854d0e";
export const componentColorPriorityBadgeP3TextHover = "#713f12";
export const componentColorPriorityBadgeP3Background = "#fef08a";
export const componentColorPriorityBadgeP3Icon = "lch(67.7 36.1 67.8)";
export const componentColorPriorityBadgeP3IconHover = "#a16207";
export const componentColorPriorityBadgeP4Text = "#1e40af";
export const componentColorPriorityBadgeP4TextHover = "#1e3a8a";
export const componentColorPriorityBadgeP4Background = "#bfdbfe";
export const componentColorPriorityBadgeP4Icon = "lch(61.3 50.3 289)";
export const componentColorPriorityBadgeP4IconHover = "#1d4ed8";
export const componentColorPriorityBadgeP5Text = "#065f46";
export const componentColorPriorityBadgeP5TextHover = "#064e3b";
export const componentColorPriorityBadgeP5Background = "#a7f3d0";
export const componentColorPriorityBadgeP5Icon = "lch(65.5 23.3 165)";
export const componentColorPriorityBadgeP5IconHover = "#047857";
export const componentColorPriorityBadgeP6Text = "#1f2937";
export const componentColorPriorityBadgeP6TextSubtle = "lch(48 6.6 264)";
export const componentColorPriorityBadgeP6TextHover = "#111827";
export const componentColorPriorityBadgeP6Background = "#e5e7eb";
export const componentColorPriorityBadgeP6Icon = "lch(54.8 6.92 265)";
export const componentColorPriorityBadgeP6IconHover = "#374151";
export const componentColorBadgeGrayText = "#1f2937";
export const componentColorBadgeGrayTextHover = "#111827";
export const componentColorBadgeGrayTextMuted = "#6b7280";
export const componentColorBadgeGrayBorder = "#374151";
export const componentColorBadgeGrayBorderSubtle = "#e5e7eb";
export const componentColorBadgeGrayBackground = "#e5e7eb";
export const componentColorBadgeGrayBackgroundWhite = "#ffffff";
export const componentColorBadgeGrayIcon = "#4b5563";
export const componentColorBadgeGrayDot = "#374151";
export const componentColorBadgeRedText = "#991b1b";
export const componentColorBadgeRedTextHover = "#7f1d1d";
export const componentColorBadgeRedTextMuted = "#b91c1c";
export const componentColorBadgeRedBorder = "#b91c1c";
export const componentColorBadgeRedBorderSubtle = "#fecaca";
export const componentColorBadgeRedBackground = "#fecaca";
export const componentColorBadgeRedBackgroundWhite = "#ffffff";
export const componentColorBadgeRedIcon = "#dc2626";
export const componentColorBadgeRedDot = "#b91c1c";
export const componentColorBadgeOrangeText = "#9a3412";
export const componentColorBadgeOrangeTextMuted = "#c2410c";
export const componentColorBadgeOrangeTextHover = "#7c2d12";
export const componentColorBadgeOrangeBorder = "#c2410c";
export const componentColorBadgeOrangeBorderSubtle = "#fed7aa";
export const componentColorBadgeOrangeBackground = "#fed7aa";
export const componentColorBadgeOrangeBackgroundWhite = "#ffffff";
export const componentColorBadgeOrangeIcon = "#ea580c";
export const componentColorBadgeOrangeDot = "#c2410c";
export const componentColorBadgeAmberText = "#92400e";
export const componentColorBadgeAmberTextMuted = "#b45309";
export const componentColorBadgeAmberTextHover = "#78350f";
export const componentColorBadgeAmberBorder = "#b45309";
export const componentColorBadgeAmberBorderSubtle = "#fde68a";
export const componentColorBadgeAmberBackground = "#fde68a";
export const componentColorBadgeAmberBackgroundWhite = "#ffffff";
export const componentColorBadgeAmberIcon = "#d97706";
export const componentColorBadgeAmberDot = "#b45309";
export const componentColorBadgeYellowText = "#854d0e";
export const componentColorBadgeYellowTextMuted = "#a16207";
export const componentColorBadgeYellowTextHover = "#713f12";
export const componentColorBadgeYellowBorder = "#a16207";
export const componentColorBadgeYellowBorderSubtle = "#fef08a";
export const componentColorBadgeYellowBackground = "#fef08a";
export const componentColorBadgeYellowBackgroundWhite = "#ffffff";
export const componentColorBadgeYellowIcon = "#ca8a04";
export const componentColorBadgeYellowDot = "#a16207";
export const componentColorBadgeLimeText = "#3f6212";
export const componentColorBadgeLimeTextMuted = "#4d7c0f";
export const componentColorBadgeLimeTextHover = "#365314";
export const componentColorBadgeLimeBorder = "#4d7c0f";
export const componentColorBadgeLimeBorderSubtle = "#ecfccb";
export const componentColorBadgeLimeBackground = "#d9f99d";
export const componentColorBadgeLimeBackgroundWhite = "#ffffff";
export const componentColorBadgeLimeIcon = "#65a30d";
export const componentColorBadgeLimeDot = "#4d7c0f";
export const componentColorBadgeEmeraldText = "#065f46";
export const componentColorBadgeEmeraldTextMuted = "#047857";
export const componentColorBadgeEmeraldTextHover = "#064e3b";
export const componentColorBadgeEmeraldBorder = "#047857";
export const componentColorBadgeEmeraldBorderSubtle = "#d1fae5";
export const componentColorBadgeEmeraldBackground = "#a7f3d0";
export const componentColorBadgeEmeraldBackgroundWhite = "#ffffff";
export const componentColorBadgeEmeraldIcon = "#059669";
export const componentColorBadgeEmeraldDot = "#047857";
export const componentColorBadgeTealText = "#115e59";
export const componentColorBadgeTealTextMuted = "#0f766e";
export const componentColorBadgeTealTextHover = "#134e4a";
export const componentColorBadgeTealBorder = "#0f766e";
export const componentColorBadgeTealBorderSubtle = "#99f6e4";
export const componentColorBadgeTealBackground = "#99f6e4";
export const componentColorBadgeTealBackgroundWhite = "#ffffff";
export const componentColorBadgeTealIcon = "#0d9488";
export const componentColorBadgeTealDot = "#0f766e";
export const componentColorBadgeCyanText = "#155e75";
export const componentColorBadgeCyanTextMuted = "#0e7490";
export const componentColorBadgeCyanTextHover = "#164e63";
export const componentColorBadgeCyanBorder = "#0e7490";
export const componentColorBadgeCyanBorderSubtle = "#a5f3fc";
export const componentColorBadgeCyanBackground = "#a5f3fc";
export const componentColorBadgeCyanBackgroundWhite = "#ffffff";
export const componentColorBadgeCyanIcon = "#0891b2";
export const componentColorBadgeCyanDot = "#164e63";
export const componentColorBadgeSkyText = "#075985";
export const componentColorBadgeSkyTextMuted = "#0369a1";
export const componentColorBadgeSkyTextHover = "#0c4a6e";
export const componentColorBadgeSkyBorder = "#0369a1";
export const componentColorBadgeSkyBorderSubtle = "#bae6fd";
export const componentColorBadgeSkyBackground = "#bae6fd";
export const componentColorBadgeSkyBackgroundWhite = "#ffffff";
export const componentColorBadgeSkyIcon = "#0284c7";
export const componentColorBadgeSkyDot = "#0369a1";
export const componentColorBadgeBlueText = "#1e40af";
export const componentColorBadgeBlueTextMuted = "#1d4ed8";
export const componentColorBadgeBlueTextHover = "#1e3a8a";
export const componentColorBadgeBlueBorder = "#1d4ed8";
export const componentColorBadgeBlueBorderSubtle = "#bfdbfe";
export const componentColorBadgeBlueBackground = "#bfdbfe";
export const componentColorBadgeBlueBackgroundWhite = "#ffffff";
export const componentColorBadgeBlueIcon = "#2563eb";
export const componentColorBadgeBlueDot = "#1d4ed8";
export const componentColorBadgeIndigoText = "#3730a3";
export const componentColorBadgeIndigoTextMuted = "#4338ca";
export const componentColorBadgeIndigoTextHover = "#312e81";
export const componentColorBadgeIndigoBorder = "#4338ca";
export const componentColorBadgeIndigoBorderSubtle = "#c7d2fe";
export const componentColorBadgeIndigoBackground = "#c7d2fe";
export const componentColorBadgeIndigoBackgroundWhite = "#ffffff";
export const componentColorBadgeIndigoIcon = "#4f46e5";
export const componentColorBadgeIndigoDot = "#4338ca";
export const componentColorBadgeVioletText = "#5b21b6";
export const componentColorBadgeVioletTextMuted = "#6d28d9";
export const componentColorBadgeVioletTextHover = "#4c1d95";
export const componentColorBadgeVioletBorder = "#6d28d9";
export const componentColorBadgeVioletBorderSubtle = "#ddd6fe";
export const componentColorBadgeVioletBackground = "#ddd6fe";
export const componentColorBadgeVioletBackgroundWhite = "#ffffff";
export const componentColorBadgeVioletIcon = "#7c3aed";
export const componentColorBadgeVioletDot = "#4c1d95";
export const componentColorBadgePurpleText = "#6b21a8";
export const componentColorBadgePurpleTextMuted = "#7e22ce";
export const componentColorBadgePurpleTextHover = "#581c87";
export const componentColorBadgePurpleBorder = "#7e22ce";
export const componentColorBadgePurpleBorderSubtle = "#e9d5ff";
export const componentColorBadgePurpleBackground = "#e9d5ff";
export const componentColorBadgePurpleBackgroundWhite = "#ffffff";
export const componentColorBadgePurpleIcon = "#9333ea";
export const componentColorBadgePurpleDot = "#7e22ce";
export const componentColorBadgeFuchsiaText = "#86198f";
export const componentColorBadgeFuchsiaTextMuted = "#a21caf";
export const componentColorBadgeFuchsiaTextHover = "#701a75";
export const componentColorBadgeFuchsiaBorder = "#a21caf";
export const componentColorBadgeFuchsiaBorderSubtle = "#f5d0fe";
export const componentColorBadgeFuchsiaBackground = "#f5d0fe";
export const componentColorBadgeFuchsiaBackgroundWhite = "#f5d0fe";
export const componentColorBadgeFuchsiaIcon = "#c026d3";
export const componentColorBadgeFuchsiaDot = "#a21caf";
export const componentColorBadgePinkText = "#9d174d";
export const componentColorBadgePinkTextMuted = "#be185d";
export const componentColorBadgePinkTextHover = "#831843";
export const componentColorBadgePinkBorder = "#be185d";
export const componentColorBadgePinkBorderSubtle = "#fbcfe8";
export const componentColorBadgePinkBackground = "#fbcfe8";
export const componentColorBadgePinkBackgroundWhite = "#ffffff";
export const componentColorBadgePinkIcon = "#db2777";
export const componentColorBadgePinkDot = "#be185d";
export const componentColorBadgeRoseText = "#9f1239";
export const componentColorBadgeRoseTextMuted = "#be123c";
export const componentColorBadgeRoseTextHover = "#881337";
export const componentColorBadgeRoseBorder = "#be123c";
export const componentColorBadgeRoseBorderSubtle = "#fecdd3";
export const componentColorBadgeRoseBackground = "#fecdd3";
export const componentColorBadgeRoseBackgroundWhite = "#ffffff";
export const componentColorBadgeRoseIcon = "#e11d48";
export const componentColorBadgeRoseDot = "#be123c";
export const componentColorBadge1abc9cText = "#0F705D";
export const componentColorBadge1abc9cBorder = "#A5F3E3";
export const componentColorBadge1abc9cBackground = "#EDFDF9";
export const componentColorBadge1abc9cIcon = "#A5F3E3";
export const componentColorBadge1abc9cDot = "#0F705D";
export const componentColorBadge16a085Text = "#0F705D";
export const componentColorBadge16a085Border = "#A5F3E4";
export const componentColorBadge16a085Background = "#EDFDFA";
export const componentColorBadge16a085Icon = "#A5F3E4";
export const componentColorBadge16a085Dot = "#0F705D";
export const componentColorBadgeF1c40fText = "#786207";
export const componentColorBadgeF1c40fBorder = "#F9E79F";
export const componentColorBadgeF1c40fBackground = "#FEFAEC";
export const componentColorBadgeF1c40fIcon = "#F9E79F";
export const componentColorBadgeF1c40fDot = "#786207";
export const componentColorBadgeF39c12Text = "#794D06";
export const componentColorBadgeF39c12Border = "#FAD69E";
export const componentColorBadgeF39c12Background = "#FEF7EC";
export const componentColorBadgeF39c12Icon = "#FAD69E";
export const componentColorBadgeF39c12Dot = "#794D06";
export const componentColorBadge2ecc71Text = "#17683A";
export const componentColorBadge2ecc71Border = "#ACECC7";
export const componentColorBadge2ecc71Background = "#EEFBF4";
export const componentColorBadge2ecc71Icon = "#ACECC7";
export const componentColorBadge2ecc71Dot = "#17683A";
export const componentColorBadge27ae60Text = "#176839";
export const componentColorBadge27ae60Border = "#ACECC7";
export const componentColorBadge27ae60Background = "#EEFBF4";
export const componentColorBadge27ae60Icon = "#ACECC7";
export const componentColorBadge27ae60Dot = "#176839";
export const componentColorBadgeE67e22Text = "#733D0D";
export const componentColorBadgeE67e22Border = "#F5CAA3";
export const componentColorBadgeE67e22Background = "#FDF4ED";
export const componentColorBadgeE67e22Icon = "#F5CAA3";
export const componentColorBadgeE67e22Dot = "#733D0D";
export const componentColorBadgeD35400Text = "#803300";
export const componentColorBadgeD35400Border = "#FFC299";
export const componentColorBadgeD35400Background = "#FFF3EB";
export const componentColorBadgeD35400Icon = "#FFC299";
export const componentColorBadgeD35400Dot = "#803300";
export const componentColorBadge3498dbText = "#13496C";
export const componentColorBadge3498dbBorder = "#A8D3F0";
export const componentColorBadge3498dbBackground = "#EEF6FC";
export const componentColorBadge3498dbIcon = "#A8D3F0";
export const componentColorBadge3498dbDot = "#13496C";
export const componentColorBadge2980b9Text = "#174868";
export const componentColorBadge2980b9Border = "#ACD3EC";
export const componentColorBadge2980b9Background = "#EEF6FB";
export const componentColorBadge2980b9Icon = "#ACD3EC";
export const componentColorBadge2980b9Dot = "#174868";
export const componentColorBadgeE74c3cText = "#72170E";
export const componentColorBadgeE74c3cBorder = "#F4ACA4";
export const componentColorBadgeE74c3cBackground = "#FDEEED";
export const componentColorBadgeE74c3cIcon = "#F4ACA4";
export const componentColorBadgeE74c3cDot = "#72170E";
export const componentColorBadgeC0392bText = "#681F17";
export const componentColorBadgeC0392bBorder = "#ECB2AC";
export const componentColorBadgeC0392bBackground = "#FBF0EE";
export const componentColorBadgeC0392bIcon = "#ECB2AC";
export const componentColorBadgeC0392bDot = "#681F17";
export const componentColorBadge9b59b6Text = "#4A2759";
export const componentColorBadge9b59b6Border = "#D4B8E0";
export const componentColorBadge9b59b6Background = "#F6F1F9";
export const componentColorBadge9b59b6Icon = "#D4B8E0";
export const componentColorBadge9b59b6Dot = "#4A2759";
export const componentColorBadge8e44adText = "#4B245C";
export const componentColorBadge8e44adBorder = "#D5B6E2";
export const componentColorBadge8e44adBackground = "#F7F0F9";
export const componentColorBadge8e44adIcon = "#D5B6E2";
export const componentColorBadge8e44adDot = "#4B245C";
export const componentColorBadgeBdc3c7Text = "#3B4145";
export const componentColorBadgeBdc3c7Border = "#C8CDD0";
export const componentColorBadgeBdc3c7Background = "#F4F5F6";
export const componentColorBadgeBdc3c7Icon = "#C8CDD0";
export const componentColorBadgeBdc3c7Dot = "#3B4145";
export const componentColorBadge34495eText = "#2D4052";
export const componentColorBadge34495eBorder = "#BDCCDB";
export const componentColorBadge34495eBackground = "#F2F5F8";
export const componentColorBadge34495eIcon = "#BDCCDB";
export const componentColorBadge34495eDot = "#2D4052";
export const componentColorBadge2c3e50Text = "#2D4052";
export const componentColorBadge2c3e50Border = "#BDCCDB";
export const componentColorBadge2c3e50Background = "#F2F5F8";
export const componentColorBadge2c3e50Icon = "#BDCCDB";
export const componentColorBadge2c3e50Dot = "#2D4052";
export const componentColorBadge95a5a6Text = "#3A4545";
export const componentColorBadge95a5a6Border = "#C8D0D0";
export const componentColorBadge95a5a6Background = "#F4F6F6";
export const componentColorBadge95a5a6Icon = "#C8D0D0";
export const componentColorBadge95a5a6Dot = "#3A4545";
export const componentColorBadge7f8c8dText = "#3C4343";
export const componentColorBadge7f8c8dBorder = "#C9CFCF";
export const componentColorBadge7f8c8dBackground = "#F4F5F5";
export const componentColorBadge7f8c8dIcon = "#C9CFCF";
export const componentColorBadge7f8c8dDot = "#3C4343";
export const componentColorBadgeEc87bfText = "#6E1145";
export const componentColorBadgeEc87bfBorder = "#F1A7D0";
export const componentColorBadgeEc87bfBackground = "#FCEDF6";
export const componentColorBadgeEc87bfIcon = "#F1A7D0";
export const componentColorBadgeEc87bfDot = "#6E1145";
export const componentColorBadgeD870adText = "#641B46";
export const componentColorBadgeD870adBorder = "#E9AFD1";
export const componentColorBadgeD870adBackground = "#FBEFF6";
export const componentColorBadgeD870adIcon = "#E9AFD1";
export const componentColorBadgeD870adDot = "#641B46";
export const componentColorBadgeF69785Text = "#771A09";
export const componentColorBadgeF69785Border = "#F8AEA0";
export const componentColorBadgeF69785Background = "#FEEFEC";
export const componentColorBadgeF69785Icon = "#F8AEA0";
export const componentColorBadgeF69785Dot = "#771A09";
export const componentColorBadge9ba37eText = "#464A35";
export const componentColorBadge9ba37eBorder = "#D1D5C3";
export const componentColorBadge9ba37eBackground = "#F6F7F3";
export const componentColorBadge9ba37eIcon = "#D1D5C3";
export const componentColorBadge9ba37eDot = "#464A35";
export const componentColorBadgeB49255Text = "#584727";
export const componentColorBadgeB49255Border = "#E0D2B8";
export const componentColorBadgeB49255Background = "#F9F6F1";
export const componentColorBadgeB49255Icon = "#E0D2B8";
export const componentColorBadgeB49255Dot = "lch(31.4 22.3 79.4)";
export const componentColorBadgeA94136Text = "#61251F";
export const componentColorBadgeA94136Border = "#E6B7B2";
export const componentColorBadgeA94136Background = "#FAF1F0";
export const componentColorBadgeA94136Icon = "#E6B7B2";
export const componentColorBadgeA94136Dot = "#61251F";
export const componentColorBadgeE61919Text = "#730D0D";
export const componentColorBadgeE61919Border = "#F5A3A3";
export const componentColorBadgeE61919Background = "#FDEDED";
export const componentColorBadgeE61919Icon = "#F5A3A3";
export const componentColorBadgeE61919Dot = "#730D0D";
export const componentColorBadgeDc2127Text = "#6F1114";
export const componentColorBadgeDc2127Border = "#F2A6A9";
export const componentColorBadgeDc2127Background = "#FCEDEE";
export const componentColorBadgeDc2127Icon = "#F2A6A9";
export const componentColorBadgeDc2127Dot = "#6F1114";
export const componentColorBadgeFf887cText = "#800C00";
export const componentColorBadgeFf887cBorder = "#FFA299";
export const componentColorBadgeFf887cBackground = "#FFECEB";
export const componentColorBadgeFf887cIcon = "#FFA299";
export const componentColorBadgeFf887cDot = "#800C00";
export const componentColorBadgeFbd75bText = "#7C6103";
export const componentColorBadgeFbd75bBorder = "#FDE79B";
export const componentColorBadgeFbd75bBackground = "#FFFAEB";
export const componentColorBadgeFbd75bIcon = "#FDE79B";
export const componentColorBadgeFbd75bDot = "#7C6103";
export const componentColorBadge51b749Text = "#285B24";
export const componentColorBadge51b749Border = "#B9E2B6";
export const componentColorBadge51b749Background = "#F1F9F0";
export const componentColorBadge51b749Icon = "#B9E2B6";
export const componentColorBadge51b749Dot = "#285B24";
export const componentColorBadge5484edText = "#0C2D73";
export const componentColorBadge5484edBorder = "#A3BDF5";
export const componentColorBadge5484edBackground = "#EDF2FD";
export const componentColorBadge5484edIcon = "#A3BDF5";
export const componentColorBadge5484edDot = "#0C2D73";
export const componentColorAlertNeutralBackground = "#f9fafb";
export const componentColorAlertNeutralBorder = "#9ca3af";
export const componentColorAlertNeutralIcon = "#4b5563";
export const componentColorAlertNeutralIconMuted = "#6b7280";
export const componentColorAlertNeutralText = "#374151";
export const componentColorAlertPrimaryBackground = "#eef2ff";
export const componentColorAlertPrimaryBorder = "#818cf8";
export const componentColorAlertPrimaryIcon = "#4f46e5";
export const componentColorAlertPrimaryIconMuted = "#6366f1";
export const componentColorAlertPrimaryText = "#4338ca";
export const componentColorAlertInfoBackground = "#f0f9ff";
export const componentColorAlertInfoBorder = "#38bdf8";
export const componentColorAlertInfoIcon = "#2563eb";
export const componentColorAlertInfoIconMuted = "#3b82f6";
export const componentColorAlertInfoText = "#1d4ed8";
export const componentColorAlertSuccessBackground = "#ecfdf5";
export const componentColorAlertSuccessBorder = "#34d399";
export const componentColorAlertSuccessIcon = "#059669";
export const componentColorAlertSuccessIconMuted = "#10b981";
export const componentColorAlertSuccessText = "#047857";
export const componentColorAlertWarningBackground = "lch(98.7 3.31 75.4)";
export const componentColorAlertWarningBorder = "#fb923c";
export const componentColorAlertWarningIcon = "#ea580c";
export const componentColorAlertWarningIconMuted = "#f97316";
export const componentColorAlertWarningText = "#c2410c";
export const componentColorAlertDangerBackground = "#fef2f2";
export const componentColorAlertDangerBorder = "#f87171";
export const componentColorAlertDangerIcon = "#dc2626";
export const componentColorAlertDangerIconMuted = "#ef4444";
export const componentColorAlertDangerText = "#b91c1c";
export const componentColorAlert1abc9cBackground = "#EDFDF9";
export const componentColorAlert1abc9cBorder = "#A5F3E3";
export const componentColorAlert1abc9cIcon = "#A5F3E3";
export const componentColorAlert1abc9cText = "#0F705D";
export const componentColorAlert16a085Background = "#EDFDFA";
export const componentColorAlert16a085Border = "#A5F3E4";
export const componentColorAlert16a085Icon = "#A5F3E4";
export const componentColorAlert16a085Text = "#0F705D";
export const componentColorAlertF1c40fBackground = "#FEFAEC";
export const componentColorAlertF1c40fBorder = "#F9E79F";
export const componentColorAlertF1c40fIcon = "#F9E79F";
export const componentColorAlertF1c40fText = "#786207";
export const componentColorAlertF39c12Background = "#FEF7EC";
export const componentColorAlertF39c12Border = "#FAD69E";
export const componentColorAlertF39c12Icon = "#FAD69E";
export const componentColorAlertF39c12Text = "#794D06";
export const componentColorAlert2ecc71Background = "#EEFBF4";
export const componentColorAlert2ecc71Border = "#ACECC7";
export const componentColorAlert2ecc71Icon = "#ACECC7";
export const componentColorAlert2ecc71Text = "#17683A";
export const componentColorAlert27ae60Background = "#EEFBF4";
export const componentColorAlert27ae60Border = "#ACECC7";
export const componentColorAlert27ae60Icon = "#ACECC7";
export const componentColorAlert27ae60Text = "#176839";
export const componentColorAlertE67e22Background = "#FDF4ED";
export const componentColorAlertE67e22Border = "#F5CAA3";
export const componentColorAlertE67e22Icon = "#F5CAA3";
export const componentColorAlertE67e22Text = "#733D0D";
export const componentColorAlertD35400Background = "#FFF3EB";
export const componentColorAlertD35400Border = "#FFC299";
export const componentColorAlertD35400Icon = "#FFC299";
export const componentColorAlertD35400Text = "#803300";
export const componentColorAlert3498dbBackground = "#EEF6FC";
export const componentColorAlert3498dbBorder = "#A8D3F0";
export const componentColorAlert3498dbIcon = "#A8D3F0";
export const componentColorAlert3498dbText = "#13496C";
export const componentColorAlert2980b9Background = "#EEF6FB";
export const componentColorAlert2980b9Border = "#ACD3EC";
export const componentColorAlert2980b9Icon = "#ACD3EC";
export const componentColorAlert2980b9Text = "#174868";
export const componentColorAlertE74c3cBackground = "#FDEEED";
export const componentColorAlertE74c3cBorder = "#F4ACA4";
export const componentColorAlertE74c3cIcon = "#F4ACA4";
export const componentColorAlertE74c3cText = "#72170E";
export const componentColorAlertC0392bBackground = "#FBF0EE";
export const componentColorAlertC0392bBorder = "#ECB2AC";
export const componentColorAlertC0392bIcon = "#ECB2AC";
export const componentColorAlertC0392bText = "#681F17";
export const componentColorAlert9b59b6Background = "#F6F1F9";
export const componentColorAlert9b59b6Border = "#D4B8E0";
export const componentColorAlert9b59b6Icon = "#D4B8E0";
export const componentColorAlert9b59b6Text = "#4A2759";
export const componentColorAlert8e44adBackground = "#F7F0F9";
export const componentColorAlert8e44adBorder = "#D5B6E2";
export const componentColorAlert8e44adIcon = "#D5B6E2";
export const componentColorAlert8e44adText = "#4B245C";
export const componentColorAlertBdc3c7Background = "#F4F5F6";
export const componentColorAlertBdc3c7Border = "#C8CDD0";
export const componentColorAlertBdc3c7Icon = "#C8CDD0";
export const componentColorAlertBdc3c7Text = "#3B4145";
export const componentColorAlert34495eBackground = "#F2F5F8";
export const componentColorAlert34495eBorder = "#BDCCDB";
export const componentColorAlert34495eIcon = "#BDCCDB";
export const componentColorAlert34495eText = "#2D4052";
export const componentColorAlert2c3e50Background = "#F2F5F8";
export const componentColorAlert2c3e50Border = "#BDCCDB";
export const componentColorAlert2c3e50Icon = "#BDCCDB";
export const componentColorAlert2c3e50Text = "#2D4052";
export const componentColorAlert95a5a6Background = "#F4F6F6";
export const componentColorAlert95a5a6Border = "#C8D0D0";
export const componentColorAlert95a5a6Icon = "#C8D0D0";
export const componentColorAlert95a5a6Text = "#3A4545";
export const componentColorAlert7f8c8dBackground = "#F4F5F5";
export const componentColorAlert7f8c8dBorder = "#C9CFCF";
export const componentColorAlert7f8c8dIcon = "#C9CFCF";
export const componentColorAlert7f8c8dText = "#3C4343";
export const componentColorAlertEc87bfBackground = "#FCEDF6";
export const componentColorAlertEc87bfBorder = "#F1A7D0";
export const componentColorAlertEc87bfIcon = "#F1A7D0";
export const componentColorAlertEc87bfText = "#6E1145";
export const componentColorAlertD870adBackground = "#FBEFF6";
export const componentColorAlertD870adBorder = "#E9AFD1";
export const componentColorAlertD870adIcon = "#E9AFD1";
export const componentColorAlertD870adText = "#641B46";
export const componentColorAlertF69785Background = "#FEEFEC";
export const componentColorAlertF69785Border = "#F8AEA0";
export const componentColorAlertF69785Icon = "#F8AEA0";
export const componentColorAlertF69785Text = "#771A09";
export const componentColorAlert9ba37eBackground = "#F6F7F3";
export const componentColorAlert9ba37eBorder = "#D1D5C3";
export const componentColorAlert9ba37eIcon = "#D1D5C3";
export const componentColorAlert9ba37eText = "#464A35";
export const componentColorAlertB49255Background = "#F9F6F1";
export const componentColorAlertB49255Border = "#E0D2B8";
export const componentColorAlertB49255Icon = "#E0D2B8";
export const componentColorAlertB49255Text = "#584727";
export const componentColorAlertA94136Background = "#FAF1F0";
export const componentColorAlertA94136Border = "#E6B7B2";
export const componentColorAlertA94136Icon = "#E6B7B2";
export const componentColorAlertA94136Text = "#61251F";
export const componentColorAlertE61919Background = "#FDEDED";
export const componentColorAlertE61919Border = "#F5A3A3";
export const componentColorAlertE61919Icon = "#F5A3A3";
export const componentColorAlertE61919Text = "#730D0D";
export const componentColorAlertDc2127Background = "#FCEDEE";
export const componentColorAlertDc2127Border = "#F2A6A9";
export const componentColorAlertDc2127Icon = "#F2A6A9";
export const componentColorAlertDc2127Text = "#6F1114";
export const componentColorAlertFf887cBackground = "#FFECEB";
export const componentColorAlertFf887cBorder = "#FFA299";
export const componentColorAlertFf887cIcon = "#FFA299";
export const componentColorAlertFf887cText = "#800C00";
export const componentColorAlertFbd75bBackground = "#FFFAEB";
export const componentColorAlertFbd75bBorder = "#FDE79B";
export const componentColorAlertFbd75bIcon = "#FDE79B";
export const componentColorAlertFbd75bText = "#7C6103";
export const componentColorAlert51b749Background = "#F1F9F0";
export const componentColorAlert51b749Border = "#B9E2B6";
export const componentColorAlert51b749Icon = "#B9E2B6";
export const componentColorAlert51b749Text = "#285B24";
export const componentColorAlert5484edBackground = "#EDF2FD";
export const componentColorAlert5484edBorder = "#A3BDF5";
export const componentColorAlert5484edIcon = "#A3BDF5";
export const componentColorAlert5484edText = "#0C2D73";
export const componentColorNotificationNeutralText = "#374151";
export const componentColorNotificationNeutralBackground = "#f9fafb";
export const componentColorNotificationNeutralIcon = "#4b5563";
export const componentColorNotificationNeutralIconMuted = "#6b7280";
export const componentColorNotificationPrimaryText = "#4338ca";
export const componentColorNotificationPrimaryBackground = "#eef2ff";
export const componentColorNotificationPrimaryIcon = "#4f46e5";
export const componentColorNotificationPrimaryIconMuted = "#6366f1";
export const componentColorNotificationDangerText = "#b91c1c";
export const componentColorNotificationDangerBackground = "#fef2f2";
export const componentColorNotificationDangerIcon = "#dc2626";
export const componentColorNotificationDangerIconMuted = "#ef4444";
export const componentColorNotificationWarningText = "#c2410c";
export const componentColorNotificationWarningBackground = "lch(98.7 3.31 75.4)";
export const componentColorNotificationWarningIcon = "#ea580c";
export const componentColorNotificationWarningIconMuted = "#f97316";
export const componentColorNotificationSuccessText = "#047857";
export const componentColorNotificationSuccessBackground = "#ecfdf5";
export const componentColorNotificationSuccessIcon = "#059669";
export const componentColorNotificationSuccessIconMuted = "#10b981";
export const componentColorNotificationInfoText = "#1d4ed8";
export const componentColorNotificationInfoBackground = "#eff6ff";
export const componentColorNotificationInfoIcon = "#2563eb";
export const componentColorNotificationInfoIconMuted = "#3b82f6";
export const componentColorAvatarPlaceholderIcon = "#6b7280";
export const componentColorAvatarPlaceholderBackground = "#ffffff";
export const componentColorAvatarPlaceholderBorder = "#d1d5db";
export const componentColorAvatarGrayText = "#293138";
export const componentColorAvatarGrayBackground = "#DEE3E7";
export const componentColorAvatarBorder = "#ffffff";
export const componentColorAvatarAText = "#094338";
export const componentColorAvatarABackground = "#1ABC9C";
export const componentColorAvatarADisabledText = "#A5F3E3"; // original color: #1ABC9C
export const componentColorAvatarADisabledBackground = "#D2F9F1";
export const componentColorAvatarBText = "#062D25";
export const componentColorAvatarBBackground = "#16A085";
export const componentColorAvatarBDisabledText = "#A5F3E4";
export const componentColorAvatarBDisabledBackground = "#D2F9F1";
export const componentColorAvatarCText = "#604E06";
export const componentColorAvatarCBackground = "#F1C40F";
export const componentColorAvatarCDisabledText = "#F9E79F";
export const componentColorAvatarCDisabledBackground = "#FCF3CF";
export const componentColorAvatarDText = "#5C3A05";
export const componentColorAvatarDBackground = "#F39C12";
export const componentColorAvatarDDisabledText = "#FAD69E";
export const componentColorAvatarDDisabledBackground = "#FDEBCE";
export const componentColorAvatarEText = "#124F2C";
export const componentColorAvatarEBackground = "#2ECC71";
export const componentColorAvatarEDisabledText = "#ACECC7";
export const componentColorAvatarEDisabledBackground = "#D5F6E3";
export const componentColorAvatarFText = "#0C361E";
export const componentColorAvatarFBackground = "#27AE60";
export const componentColorAvatarFDisabledText = "#ACECC7";
export const componentColorAvatarFDisabledBackground = "#D5F6E3";
export const componentColorAvatarGText = "#492708";
export const componentColorAvatarGBackground = "#E67E22";
export const componentColorAvatarGDisabledText = "#F5CAA3";
export const componentColorAvatarGDisabledBackground = "#FAE4D1";
export const componentColorAvatarHText = "#1F0C00";
export const componentColorAvatarHBackground = "#D35400";
export const componentColorAvatarHDisabledText = "#FFC299";
export const componentColorAvatarHDisabledBackground = "#FFE0CC";
export const componentColorAvatarIText = "#0C2C41";
export const componentColorAvatarIBackground = "#3498DB";
export const componentColorAvatarIDisabledText = "#A8D3F0";
export const componentColorAvatarIDisabledBackground = "#D4E9F7";
export const componentColorAvatarJText = "#050E15";
export const componentColorAvatarJBackground = "#2980B9";
export const componentColorAvatarJDisabledText = "#ACD3EC";
export const componentColorAvatarJDisabledBackground = "#D5E9F6";
export const componentColorAvatarKText = "#360B07";
export const componentColorAvatarKBackground = "#E74C3C";
export const componentColorAvatarKDisabledText = "#F4ACA4";
export const componentColorAvatarKDisabledBackground = "#F9D5D2";
export const componentColorAvatarLText = "#ffffff";
export const componentColorAvatarLBackground = "#C0392B";
export const componentColorAvatarLDisabledText = "#ECB2AC";
export const componentColorAvatarLDisabledBackground = "#F6D8D5";
export const componentColorAvatarMText = "#ffffff";
export const componentColorAvatarMBackground = "#9B59B6";
export const componentColorAvatarMDisabledText = "#D4B8E0";
export const componentColorAvatarMDisabledBackground = "#E9DCEF";
export const componentColorAvatarNText = "#ffffff";
export const componentColorAvatarNBackground = "#8E44AD";
export const componentColorAvatarNDisabledText = "#D5B6E2";
export const componentColorAvatarNDisabledBackground = "#EADAF1";
export const componentColorAvatarOText = "#2C3134";
export const componentColorAvatarOBackground = "#BDC3C7";
export const componentColorAvatarODisabledText = "#C8CDD0";
export const componentColorAvatarODisabledBackground = "#E4E6E7";
export const componentColorAvatarPText = "#ffffff";
export const componentColorAvatarPBackground = "#34495E";
export const componentColorAvatarPDisabledText = "#BDCCDB";
export const componentColorAvatarPDisabledBackground = "#DEE6ED";
export const componentColorAvatarQText = "#ffffff";
export const componentColorAvatarQBackground = "#2C3E50";
export const componentColorAvatarQDisabledText = "#BDCCDB";
export const componentColorAvatarQDisabledBackground = "#DEE6ED";
export const componentColorAvatarRText = "#171B1C";
export const componentColorAvatarRBackground = "#95A5A6";
export const componentColorAvatarRDisabledText = "#C8D0D0";
export const componentColorAvatarRDisabledBackground = "#E3E8E8";
export const componentColorAvatarSText = "#ffffff";
export const componentColorAvatarSBackground = "#7F8C8D";
export const componentColorAvatarSDisabledText = "#C9CFCF";
export const componentColorAvatarSDisabledBackground = "#E4E7E7";
export const componentColorAvatarTText = "#540D34";
export const componentColorAvatarTBackground = "#EC87BF";
export const componentColorAvatarTDisabledText = "#F1A7D0";
export const componentColorAvatarTDisabledBackground = "#F8D3E8";
export const componentColorAvatarUText = "#4C1535";
export const componentColorAvatarUBackground = "#D870AD";
export const componentColorAvatarUDisabledText = "#E9AFD1";
export const componentColorAvatarUDisabledBackground = "#F4D7E8";
export const componentColorAvatarVText = "#5A1407";
export const componentColorAvatarVBackground = "#F69785";
export const componentColorAvatarVDisabledText = "#F8AEA0";
export const componentColorAvatarVDisabledBackground = "#FBD6D0";
export const componentColorAvatarWText = "#353928";
export const componentColorAvatarWBackground = "#9BA37E";
export const componentColorAvatarWDisabledText = "#D1D5C3";
export const componentColorAvatarWDisabledBackground = "#E8EAE1";
export const componentColorAvatarXText = "#392D19";
export const componentColorAvatarXBackground = "#B49255";
export const componentColorAvatarXDisabledText = "#E0D2B8";
export const componentColorAvatarXDisabledBackground = "#EFE8DC";
export const componentColorAvatarYText = "#ffffff";
export const componentColorAvatarYBackground = "#A94136";
export const componentColorAvatarYDisabledText = "#E6B7B2";
export const componentColorAvatarYDisabledBackground = "#F3DBD8";
export const componentColorAvatarZText = "#ffffff";
export const componentColorAvatarZBackground = "#E61919";
export const componentColorAvatarZDisabledText = "#F5A3A3";
export const componentColorAvatarZDisabledBackground = "#FAD1D1";
export const componentColorCheckboxBackground = "#ffffff";
export const componentColorCheckboxBackgroundIndeterminate = "#eff6ff";
export const componentColorCheckboxBackgroundChecked = "#2563eb";
export const componentColorCheckboxBorder = "#d1d5db";
export const componentColorCheckboxBorderChecked = "#3b82f6";
export const componentColorCheckboxBorderDanger = "#ef4444";
export const componentColorCheckboxIcon = "#ffffff";
export const componentColorCheckboxIconIndeterminate = "#3b82f6";
export const componentColorCheckboxHoverBackground = "#dbeafe";
export const componentColorCheckboxHoverBackgroundChecked = "#1e40af";
export const componentColorCheckboxHoverBorder = "#1d4ed8";
export const componentColorCheckboxHoverIcon = "#ffffff";
export const componentColorCheckboxHoverIconIndeterminate = "#1d4ed8";
export const componentColorCheckboxFocusedBackground = "#ffffff";
export const componentColorCheckboxFocusedBackgroundChecked = "#2563eb";
export const componentColorCheckboxFocusedBorder = "#3b82f6";
export const componentColorCheckboxFocusedBorderDanger = "#fca5a5";
export const componentColorCheckboxFocusedIcon = "#ffffff";
export const componentColorCheckboxFocusedIconIndeterminate = "#3b82f6";
export const componentColorCheckboxDisabledBackground = "#f9fafb";
export const componentColorCheckboxDisabledBackgroundSubtle = "#e5e7eb";
export const componentColorCheckboxDisabledBorder = "#e5e7eb";
export const componentColorCheckboxDisabledIcon = "#e5e7eb";
export const componentColorCheckboxDisabledIconSubtle = "#ffffff";
export const componentColorRadioButtonBackground = "#ffffff";
export const componentColorRadioButtonIcon = "#2563eb";
export const componentColorRadioButtonBorder = "#d1d5db";
export const componentColorRadioButtonBorderChecked = "#3b82f6";
export const componentColorRadioButtonBorderDanger = "#ef4444";
export const componentColorRadioButtonHoverBackground = "#dbeafe";
export const componentColorRadioButtonHoverBorder = "#1d4ed8";
export const componentColorRadioButtonHoverIcon = "#1d4ed8";
export const componentColorRadioButtonFocusedBackground = "#ffffff";
export const componentColorRadioButtonFocusedIcon = "#2563eb";
export const componentColorRadioButtonFocusedBorder = "#3b82f6";
export const componentColorRadioButtonFocusedBorderDanger = "#fca5a5";
export const componentColorRadioButtonDisabledBackground = "#f9fafb";
export const componentColorRadioButtonDisabledBorder = "#e5e7eb";
export const componentColorRadioButtonDisabledIcon = "#e5e7eb";
export const componentColorTableCellTextStrong = "#111827";
export const componentColorTableCellTextMuted = "#374151";
export const componentColorTableCellTextDisabled = "#d1d5db";
export const componentColorTableCellSubtext = "#6b7280";
export const componentColorTableCellIcon = "#6b7280";
export const componentColorTableCellBackgroundWhite = "#ffffff";
export const componentColorTableCellBackgroundGray = "#f9fafb";
export const componentColorTableCellBackgroundHover = "hsl(221 83.2% 97.2%)";
export const componentColorTableCellBackgroundSelected = "hsl(221 83.2% 97.2%)";
export const componentColorTableCellBackgroundSelectedHover = "hsl(221 83.2% 97.2%)";
export const componentColorTableCellBorder = "#e5e7eb";
export const componentColorTableCellDangerBackground = "#fef2f2";
export const componentColorTableCellDangerSubtext = "#b91c1c";
export const componentColorTableCellDangerIcon = "#ef4444";
export const componentColorTableCellHeaderText = "#9ca3af";
export const componentColorTableCellHeaderIcon = "#9ca3af";
export const componentColorTableCellHeaderBackgroundGray = "#f9fafb";
export const componentColorTableCellHeaderBackgroundWhite = "#ffffff";
export const componentColorTableCellHeaderBorder = "#e5e7eb";
export const componentColorTableCellHeaderHoverText = "#111827";
export const componentColorTableCellHeaderHoverIcon = "#374151";
export const componentColorTableCellHeaderDisabledText = "#d1d5db";
export const componentColorTableCellHeaderDisabledIcon = "#e5e7eb";
export const componentColorTableCellEditableTextStrong = "#111827";
export const componentColorTableCellEditableTextMuted = "#374151";
export const componentColorTableCellEditableTextDisabled = "#d1d5db";
export const componentColorTableCellEditableSubtext = "#6b7280";
export const componentColorTableCellEditableIcon = "#6b7280";
export const componentColorTableCellEditableBackgroundWhite = "#ffffff";
export const componentColorTableCellEditableBackgroundGray = "#f9fafb";
export const componentColorTableCellEditableBackgroundSelected = "hsl(221 83.2% 97.2%)";
export const componentColorTableCellEditableBackgroundSelectedHover = "hsl(221 83.2% 97.2%)";
export const componentColorTableCellEditableBorder = "#e5e7eb";
export const componentColorTableCellEditableHoverBorder = "#93c5fd";
export const componentColorTableCellEditableFocusedBackground = "#eff6ff";
export const componentColorTableCellEditableFocusedBorder = "#93c5fd";
export const componentColorTableCellEditableDangerBackground = "#fef2f2";
export const componentColorTableCellEditableDangerSubtext = "#b91c1c";
export const componentColorTableCellEditableDangerIcon = "#ef4444";
export const componentColorTableCellEditableDangerBorder = "#fca5a5";
export const fontFamiliesInter = "Inter";
export const lineHeights72px = "90px";
export const lineHeights60px = "72px";
export const lineHeights48px = "60px";
export const lineHeights36px = "44px";
export const lineHeights30px = "38px";
export const lineHeights28px = "43px";
export const lineHeights26px = "40px";
export const lineHeights24px = "36px";
export const lineHeights20px = "30px";
export const lineHeights18px = "28px";
export const lineHeights16px = "24px";
export const lineHeights14px = "20px";
export const lineHeights13px = "18px";
export const lineHeights12px = "18px";
export const lineHeights10px = "14px";
export const fontWeightsRegular = "400";
export const fontWeightsMedium = "500";
export const fontWeightsSemibold = "600";
export const fontWeightsBold = "700";
export const fontSize10px = "10px";
export const fontSize12px = "12px";
export const fontSize13px = "13px";
export const fontSize14px = "14px";
export const fontSize16px = "16px";
export const fontSize18px = "18px";
export const fontSize20px = "20px";
export const fontSize24px = "24px";
export const fontSize26px = "26px";
export const fontSize28px = "28px";
export const fontSize30px = "30px";
export const fontSize36px = "36px";
export const fontSize48px = "48px";
export const fontSize60px = "60px";
export const fontSize72px = "72px";
export const letterSpacing2 = "-0.02em";
export const letterSpacing0 = "0em";
export const paragraphSpacing12px = "10px";
export const paragraphSpacing13px = "16px";
export const paragraphSpacing14px = "20px";
export const paragraphSpacing16px = "24px";
export const paragraphSpacing18px = "28px";
export const paragraphSpacing20px = "30px";
export const paragraphSpacing24px = "36px";
export const paragraphSpacing30px = "38px";
export const paragraphSpacing36px = "44px";
export const paragraphSpacing48px = "59.2px";
export const paragraphSpacing60px = "72px";
export const paragraphSpacing72px = "90px";
export const fontsDisplay2xlReg = "400 72px/90px Inter";
export const fontsDisplay2xlMed = "500 72px/90px Inter";
export const fontsDisplay2xlSmbld = "600 72px/90px Inter";
export const fontsDisplay2xlBold = "700 72px/90px Inter";
export const fontsDisplayXlReg = "400 60px/72px Inter";
export const fontsDisplayXlMed = "500 60px/72px Inter";
export const fontsDisplayXlSmbld = "600 60px/72px Inter";
export const fontsDisplayXlBold = "700 60px/72px Inter";
export const fontsDisplayLgReg = "400 48px/60px Inter";
export const fontsDisplayLgMed = "500 48px/60px Inter";
export const fontsDisplayLgSmbld = "600 48px/60px Inter";
export const fontsDisplayLgBold = "700 48px/60px Inter";
export const fontsDisplayMdReg = "400 36px/44px Inter";
export const fontsDisplayMdMed = "500 36px/44px Inter";
export const fontsDisplayMdSmbld = "600 36px/44px Inter";
export const fontsDisplayMdBold = "700 36px/44px Inter";
export const fontsDisplaySmReg = "400 30px/38px Inter";
export const fontsDisplaySmMed = "500 30px/38px Inter";
export const fontsDisplaySmSmbld = "600 30px/38px Inter";
export const fontsDisplaySmBold = "700 30px/38px Inter";
export const fontsDisplayXsReg = "400 24px/36px Inter";
export const fontsDisplayXsMed = "500 24px/36px Inter";
export const fontsDisplayXsSmbld = "600 24px/36px Inter";
export const fontsDisplayXsBold = "700 24px/36px Inter";
export const fontsDescriptionLgReg = "600 30px/38px Inter";
export const fontsDescriptionLgMed = "700 30px/38px Inter";
export const fontsDescriptionLgSmbld = "400 30px/38px Inter";
export const fontsDescriptionLgBold = "500 30px/38px Inter";
export const fontsDescriptionMdReg = "400 28px/43px Inter";
export const fontsDescriptionMdMed = "500 28px/43px Inter";
export const fontsDescriptionMdSmbld = "600 28px/43px Inter";
export const fontsDescriptionMdBold = "700 28px/43px Inter";
export const fontsDescriptionSmReg = "400 26px/40px Inter";
export const fontsDescriptionSmMed = "500 26px/40px Inter";
export const fontsDescriptionSmSmbld = "600 26px/40px Inter";
export const fontsDescriptionSmBold = "700 26px/40px Inter";
export const fontsText2xlReg = "400 24px/36px Inter";
export const fontsText2xlMed = "500 24px/36px Inter";
export const fontsText2xlSmbld = "600 24px/36px Inter";
export const fontsText2xlBold = "700 24px/36px Inter";
export const fontsTextXlReg = "400 20px/30px Inter";
export const fontsTextXlMed = "500 20px/30px Inter";
export const fontsTextXlSmbld = "600 20px/30px Inter";
export const fontsTextXlBold = "700 20px/30px Inter";
export const fontsTextLgReg = "400 18px/28px Inter";
export const fontsTextLgMed = "500 18px/28px Inter";
export const fontsTextLgSmbld = "600 18px/28px Inter";
export const fontsTextLgBold = "700 18px/28px Inter";
export const fontsTextMdReg = "400 16px/24px Inter";
export const fontsTextMdMed = "500 16px/24px Inter";
export const fontsTextMdSmbld = "600 16px/24px Inter";
export const fontsTextMdBold = "700 16px/24px Inter";
export const fontsTextSmReg = "400 14px/20px Inter";
export const fontsTextSmMed = "500 14px/20px Inter";
export const fontsTextSmSmbld = "600 14px/20px Inter";
export const fontsTextSmBold = "700 14px/20px Inter";
export const fontsTextXsReg = "400 12px/18px Inter";
export const fontsTextXsMed = "500 12px/18px Inter";
export const fontsTextXsSmbld = "600 12px/18px Inter";
export const fontsTextXsBold = "700 12px/18px Inter";
export const fontsTextMicroReg = "400 10px/14px Inter";
export const fontsTextMicroMed = "500 10px/14px Inter";
export const fontsTextMicroSmbld = "600 10px/14px Inter";
export const fontsTextMicroBold = "700 10px/14px Inter";
export const fontsLinksDisplay2xlReg = "400 72px/90px Inter";
export const fontsLinksDisplay2xlMed = "500 72px/90px Inter";
export const fontsLinksDisplay2xlSmbld = "600 72px/90px Inter";
export const fontsLinksDisplay2xlBold = "700 72px/90px Inter";
export const fontsLinksDisplayXlReg = "400 60px/72px Inter";
export const fontsLinksDisplayXlMed = "500 60px/72px Inter";
export const fontsLinksDisplayXlSmbld = "600 60px/72px Inter";
export const fontsLinksDisplayXlBold = "700 60px/72px Inter";
export const fontsLinksDisplayLgReg = "400 48px/60px Inter";
export const fontsLinksDisplayLgMed = "500 48px/60px Inter";
export const fontsLinksDisplayLgSmbld = "600 48px/60px Inter";
export const fontsLinksDisplayLgBold = "700 48px/60px Inter";
export const fontsLinksDisplayMdReg = "400 36px/44px Inter";
export const fontsLinksDisplayMdMed = "500 36px/44px Inter";
export const fontsLinksDisplayMdSmbld = "600 36px/44px Inter";
export const fontsLinksDisplayMdBold = "700 36px/44px Inter";
export const fontsLinksDisplaySmReg = "400 30px/38px Inter";
export const fontsLinksDisplaySmMed = "500 30px/38px Inter";
export const fontsLinksDisplaySmSmbld = "600 30px/38px Inter";
export const fontsLinksDisplaySmBold = "700 30px/38px Inter";
export const fontsLinksDescriptionMdReg = "400 28px/43px Inter";
export const fontsLinksDescriptionMdMed = "500 28px/43px Inter";
export const fontsLinksDescriptionMdSmbld = "600 28px/43px Inter";
export const fontsLinksDescriptionMdBold = "700 28px/43px Inter";
export const fontsLinksDescriptionSmReg = "400 26px/40px Inter";
export const fontsLinksDescriptionSmMed = "500 26px/40px Inter";
export const fontsLinksDescriptionSmSmbld = "600 26px/40px Inter";
export const fontsLinksDescriptionSmBold = "700 26px/40px Inter";
export const fontsLinksText2xlReg = "400 24px/36px Inter";
export const fontsLinksText2xlMed = "500 24px/36px Inter";
export const fontsLinksText2xlSmbld = "600 24px/36px Inter";
export const fontsLinksText2xlBold = "700 24px/36px Inter";
export const fontsLinksTextXlReg = "400 20px/30px Inter";
export const fontsLinksTextXlMed = "500 20px/30px Inter";
export const fontsLinksTextXlSmbld = "600 20px/30px Inter";
export const fontsLinksTextXlBold = "700 20px/30px Inter";
export const fontsLinksTextLgReg = "400 18px/28px Inter";
export const fontsLinksTextLgMed = "500 18px/28px Inter";
export const fontsLinksTextLgSmbld = "600 18px/28px Inter";
export const fontsLinksTextLgBold = "700 18px/28px Inter";
export const fontsLinksTextMdReg = "400 16px/24px Inter";
export const fontsLinksTextMdMed = "500 16px/24px Inter";
export const fontsLinksTextMdSmbld = "600 16px/24px Inter";
export const fontsLinksTextMdBold = "700 16px/24px Inter";
export const fontsLinksTextSmReg = "400 14px/20px Inter";
export const fontsLinksTextSmMed = "500 14px/20px Inter";
export const fontsLinksTextSmSmbld = "600 14px/20px Inter";
export const fontsLinksTextSmBold = "700 14px/20px Inter";
export const fontsLinksTextXsReg = "400 12px/18px Inter";
export const fontsLinksTextXsMed = "500 12px/18px Inter";
export const fontsLinksTextXsSmbld = "600 12px/18px Inter";
export const fontsLinksTextXsBold = "700 12px/18px Inter";
export const fontsLinksTextMicroReg = "400 10px/14px Inter";
export const fontsLinksTextMicroMed = "500 10px/14px Inter";
export const fontsLinksTextMicroSmbld = "600 10px/14px Inter";
export const fontsLinksTextMicroBold = "700 10px/14px Inter";
export const fontsLinksTextBaseReg = "400 13px/18px Inter";
export const fontsLinksTextBaseMed = "500 13px/18px Inter";
export const fontsLinksTextBaseSmbld = "600 13px/18px Inter";
export const fontsLinksTextBaseBold = "700 13px/18px Inter";
export const fontsTextBaseReg = "400 13px/18px Inter";
export const fontsTextBaseMed = "500 13px/18px Inter";
export const fontsTextBaseSmbld = "600 13px/18px Inter";
export const fontsTextBaseBold = "700 13px/18px Inter";
export const textCaseNone = "none";
export const textDecorationNone = "none";
export const textDecorationUnderline = "underline";
export const paragraphIndent0 = "0px";
export const colorsBrandLogoBlue = "#045dd1";
export const colorsBrandLogoOrange = "#f5870a";
export const colorsGray50 = "#f9fafb";
export const colorsGray100 = "#f3f4f6";
export const colorsGray200 = "#e5e7eb";
export const colorsGray300 = "#d1d5db";
export const colorsGray400 = "#9ca3af";
export const colorsGray500 = "#6b7280";
export const colorsGray600 = "#4b5563";
export const colorsGray700 = "#374151";
export const colorsGray800 = "#1f2937";
export const colorsGray900 = "#111827";
export const colorsSlate50 = "#f8fafc";
export const colorsSlate100 = "#f1f5f9";
export const colorsSlate200 = "#e2e8f0";
export const colorsSlate300 = "#cbd5e1";
export const colorsSlate400 = "#94a3b8";
export const colorsSlate500 = "#64748b";
export const colorsSlate600 = "#475569";
export const colorsSlate700 = "#334155";
export const colorsSlate800 = "#1e293b";
export const colorsSlate900 = "#0f172a";
export const colorsRed50 = "#fef2f2";
export const colorsRed100 = "#fee2e2";
export const colorsRed200 = "#fecaca";
export const colorsRed300 = "#fca5a5";
export const colorsRed400 = "#f87171";
export const colorsRed500 = "#ef4444";
export const colorsRed600 = "#dc2626";
export const colorsRed700 = "#b91c1c";
export const colorsRed800 = "#991b1b";
export const colorsRed900 = "#7f1d1d";
export const colorsOrange50 = "#fff7ed";
export const colorsOrange100 = "#ffedd5";
export const colorsOrange200 = "#fed7aa";
export const colorsOrange300 = "#fdba74";
export const colorsOrange400 = "#fb923c";
export const colorsOrange500 = "#f97316";
export const colorsOrange600 = "#ea580c";
export const colorsOrange700 = "#c2410c";
export const colorsOrange800 = "#9a3412";
export const colorsOrange900 = "#7c2d12";
export const colorsAmber50 = "#fffbeb";
export const colorsAmber100 = "#fef3c7";
export const colorsAmber200 = "#fde68a";
export const colorsAmber300 = "#fcd34d";
export const colorsAmber400 = "#fbbf24";
export const colorsAmber500 = "#f59e0b";
export const colorsAmber600 = "#d97706";
export const colorsAmber700 = "#b45309";
export const colorsAmber800 = "#92400e";
export const colorsAmber900 = "#78350f";
export const colorsYellow50 = "#fefce8";
export const colorsYellow100 = "#fef9c3";
export const colorsYellow200 = "#fef08a";
export const colorsYellow300 = "#fde047";
export const colorsYellow400 = "#facc15";
export const colorsYellow500 = "#eab308";
export const colorsYellow600 = "#ca8a04";
export const colorsYellow700 = "#a16207";
export const colorsYellow800 = "#854d0e";
export const colorsYellow900 = "#713f12";
export const colorsLime50 = "#f7fee7";
export const colorsLime100 = "#ecfccb";
export const colorsLime200 = "#d9f99d";
export const colorsLime300 = "#bef264";
export const colorsLime400 = "#a3e635";
export const colorsLime500 = "#84cc16";
export const colorsLime600 = "#65a30d";
export const colorsLime700 = "#4d7c0f";
export const colorsLime800 = "#3f6212";
export const colorsLime900 = "#365314";
export const colorsEmerald50 = "#ecfdf5";
export const colorsEmerald100 = "#d1fae5";
export const colorsEmerald200 = "#a7f3d0";
export const colorsEmerald300 = "#6ee7b7";
export const colorsEmerald400 = "#34d399";
export const colorsEmerald500 = "#10b981";
export const colorsEmerald600 = "#059669";
export const colorsEmerald700 = "#047857";
export const colorsEmerald800 = "#065f46";
export const colorsEmerald900 = "#064e3b";
export const colorsTeal50 = "#f0fdfa";
export const colorsTeal100 = "#ccfbf1";
export const colorsTeal200 = "#99f6e4";
export const colorsTeal300 = "#5eead4";
export const colorsTeal400 = "#2dd4bf";
export const colorsTeal500 = "#14b8a6";
export const colorsTeal600 = "#0d9488";
export const colorsTeal700 = "#0f766e";
export const colorsTeal800 = "#115e59";
export const colorsTeal900 = "#134e4a";
export const colorsCyan50 = "#ecfeff";
export const colorsCyan100 = "#cffafe";
export const colorsCyan200 = "#a5f3fc";
export const colorsCyan300 = "#67e8f9";
export const colorsCyan400 = "#22d3ee";
export const colorsCyan500 = "#06b6d4";
export const colorsCyan600 = "#0891b2";
export const colorsCyan700 = "#0e7490";
export const colorsCyan800 = "#155e75";
export const colorsCyan900 = "#164e63";
export const colorsSky50 = "#f0f9ff";
export const colorsSky100 = "#e0f2fe";
export const colorsSky200 = "#bae6fd";
export const colorsSky300 = "#7dd3fc";
export const colorsSky400 = "#38bdf8";
export const colorsSky500 = "#0ea5e9";
export const colorsSky600 = "#0284c7";
export const colorsSky700 = "#0369a1";
export const colorsSky800 = "#075985";
export const colorsSky900 = "#0c4a6e";
export const colorsBlue50 = "#eff6ff";
export const colorsBlue100 = "#dbeafe";
export const colorsBlue200 = "#bfdbfe";
export const colorsBlue300 = "#93c5fd";
export const colorsBlue400 = "#60a5fa";
export const colorsBlue500 = "#3b82f6";
export const colorsBlue600 = "#2563eb";
export const colorsBlue700 = "#1d4ed8";
export const colorsBlue800 = "#1e40af";
export const colorsBlue900 = "#1e3a8a";
export const colorsIndigo50 = "#eef2ff";
export const colorsIndigo100 = "#e0e7ff";
export const colorsIndigo200 = "#c7d2fe";
export const colorsIndigo300 = "#a5b4fc";
export const colorsIndigo400 = "#818cf8";
export const colorsIndigo500 = "#6366f1";
export const colorsIndigo600 = "#4f46e5";
export const colorsIndigo700 = "#4338ca";
export const colorsIndigo800 = "#3730a3";
export const colorsIndigo900 = "#312e81";
export const colorsViolet50 = "#f5f3ff";
export const colorsViolet100 = "#ede9fe";
export const colorsViolet200 = "#ddd6fe";
export const colorsViolet300 = "#c4b5fd";
export const colorsViolet400 = "#a78bfa";
export const colorsViolet500 = "#8b5cf6";
export const colorsViolet600 = "#7c3aed";
export const colorsViolet700 = "#6d28d9";
export const colorsViolet800 = "#5b21b6";
export const colorsViolet900 = "#4c1d95";
export const colorsPurple50 = "#faf5ff";
export const colorsPurple100 = "#f3e8ff";
export const colorsPurple200 = "#e9d5ff";
export const colorsPurple300 = "#d8b4fe";
export const colorsPurple400 = "#c084fc";
export const colorsPurple500 = "#a855f7";
export const colorsPurple600 = "#9333ea";
export const colorsPurple700 = "#7e22ce";
export const colorsPurple800 = "#6b21a8";
export const colorsPurple900 = "#581c87";
export const colorsFuchsia50 = "#fdf4ff";
export const colorsFuchsia100 = "#fae8ff";
export const colorsFuchsia200 = "#f5d0fe";
export const colorsFuchsia300 = "#f0abfc";
export const colorsFuchsia400 = "#e879f9";
export const colorsFuchsia500 = "#d946ef";
export const colorsFuchsia600 = "#c026d3";
export const colorsFuchsia700 = "#a21caf";
export const colorsFuchsia800 = "#86198f";
export const colorsFuchsia900 = "#701a75";
export const colorsPink50 = "#fdf2f8";
export const colorsPink100 = "#fce7f3";
export const colorsPink200 = "#fbcfe8";
export const colorsPink300 = "#f9a8d4";
export const colorsPink400 = "#f472b6";
export const colorsPink500 = "#ec4899";
export const colorsPink600 = "#db2777";
export const colorsPink700 = "#be185d";
export const colorsPink800 = "#9d174d";
export const colorsPink900 = "#831843";
export const colorsRose50 = "#fff1f2";
export const colorsRose100 = "#ffe4e6";
export const colorsRose200 = "#fecdd3";
export const colorsRose300 = "#fda4af";
export const colorsRose400 = "#fb7185";
export const colorsRose500 = "#f43f5e";
export const colorsRose600 = "#e11d48";
export const colorsRose700 = "#be123c";
export const colorsRose800 = "#9f1239";
export const colorsRose900 = "#881337";
export const colorsWhite = "#ffffff";
export const colorsBlack = "#000000";
export const colorsTextPrimary = "#111827";
export const colorsTextSupporting = "#374151";
export const colorsTextMuted = "#6b7280";
export const colorsTextSubtle = "#9ca3af";
export const colorsTextOnPrimary = "#ffffff";
export const colorsTextAccent = "#1d4ed8";
export const colorsTextSuccess = "#047857";
export const colorsTextWarning = "#c2410c";
export const colorsTextDanger = "#b91c1c";
export const colorsTextInfo = "#0369a1";
export const colorsTextLink = "#4338ca";
export const colorsTextAccentDisabled = "#bfdbfe";
export const colorsTextDisabled = "#d1d5db";
export const colorsTextOnPrimaryDisabled = "#f9fafb";
export const colorsTextSuccessDisabled = "#a7f3d0";
export const colorsTextWarningDisabled = "#fed7aa";
export const colorsTextDangerDisabled = "#fecaca";
export const colorsTextInfoDisabled = "#bae6fd";
export const colorsTextLinkDisabled = "#c7d2fe";
export const colorsBackgroundPrimary = "#ffffff";
export const colorsBackgroundOverlay = "#FFFFFFB3";
export const colorsBackgroundInteractive = "#ffffff";
export const colorsBackgroundInteractiveHover = "#bfdbfe";
export const colorsBackgroundInteractiveMutedHover = "#dbeafe";
export const colorsBackgroundAccent = "#2563eb";
export const colorsBackgroundAccentMuted = "#eff6ff";
export const colorsBackgroundSuccess = "#059669";
export const colorsBackgroundSuccessMuted = "#ecfdf5";
export const colorsBackgroundWarning = "#ea580c";
export const colorsBackgroundWarningMuted = "#fff7ed";
export const colorsBackgroundDanger = "#dc2626";
export const colorsBackgroundDangerMuted = "#fef2f2";
export const colorsBackgroundInfo = "#0284c7";
export const colorsBackgroundInfoMuted = "#f0f9ff";
export const colorsBackgroundDisabled = "#f3f4f6";
export const colorsBackgroundPrimaryDisabled = "#eff6ff";
export const colorsBackgroundSuccessDisabled = "#ecfdf5";
export const colorsBackgroundWarningDisabled = "#fff7ed";
export const colorsBackgroundDangerDisabled = "#ecfdf5";
export const colorsBackgroundInfoDisabled = "#f0f9ff";
export const colorsBackgroundSecondary = "lch(96.5 0.98 266)";
export const colorsBackgroundTertiary = "#e5e7eb";
export const colorsBackgroundAccentDisabled = "#eff6ff";
export const colorsBackgroundTooltipStrong = "#374151";
export const colorsBackgroundTooltipSubtle = "#ffffff";
export const colorsBackgroundCardSection = "lch(96.5 0.98 266)";
export const colorsBorderPrimary = "#e5e7eb";
export const colorsBorderSecondary = "#d1d5db";
export const colorsBorderMuted = "#f9fafb";
export const colorsBorderDropdown = "#d1d5db";
export const colorsBorderAccent = "#2563eb";
export const colorsBorderSuccess = "#059669";
export const colorsBorderWarning = "#ea580c";
export const colorsBorderDanger = "#dc2626";
export const colorsBorderInfo = "#0284c7";
export const colorsBorderDisabled = "#f3f4f6";
export const colorsBorderAccentDisabled = "#bfdbfe";
export const colorsBorderSuccessDisabled = "#a7f3d0";
export const colorsBorderWarningDisabled = "#fed7aa";
export const colorsBorderDangerDisabled = "#fecaca";
export const colorsBorderInfoDisabled = "#bae6fd";
export const colorsDividerPrimary = "#e5e7eb";
export const colorsDividerSecondary = "#d1d5db";
export const colorsUtilityBackgroundBaseWhite = "#ffffff";
export const colorsUtilityBackgroundBaseBlack = "#000000";
export const colorsUtilityBackgroundGrayStrong = "#4b5563";
export const colorsUtilityBackgroundGrayMuted = "#f3f4f6";
export const colorsUtilityBackgroundGraySubtle = "#f9fafb";
export const colorsUtilityBackgroundGrayBright = "#e5e7eb";
export const colorsUtilityBackgroundRedStrong = "#dc2626";
export const colorsUtilityBackgroundRedMuted = "#fee2e2";
export const colorsUtilityBackgroundRedSubtle = "#fef2f2";
export const colorsUtilityBackgroundRedBright = "#fecaca";
export const colorsUtilityBackgroundOrangeStrong = "#ea580c";
export const colorsUtilityBackgroundOrangeMuted = "#ffedd5";
export const colorsUtilityBackgroundOrangeSubtle = "#fff7ed";
export const colorsUtilityBackgroundOrangeBright = "#fed7aa";
export const colorsUtilityBackgroundAmberStrong = "#d97706";
export const colorsUtilityBackgroundAmberMuted = "#fef3c7";
export const colorsUtilityBackgroundAmberSubtle = "#fffbeb";
export const colorsUtilityBackgroundAmberBright = "#fde68a";
export const colorsUtilityBackgroundYellowStrong = "#ca8a04";
export const colorsUtilityBackgroundYellowMuted = "#fef9c3";
export const colorsUtilityBackgroundYellowSubtle = "#fefce8";
export const colorsUtilityBackgroundYellowBright = "#fef08a";
export const colorsUtilityBackgroundLimeStrong = "#4d7c0f";
export const colorsUtilityBackgroundLimeMuted = "#ecfccb";
export const colorsUtilityBackgroundLimeSubtle = "#f7fee7";
export const colorsUtilityBackgroundLimeBright = "#d9f99d";
export const colorsUtilityBackgroundEmeraldStrong = "#059669";
export const colorsUtilityBackgroundEmeraldMuted = "#d1fae5";
export const colorsUtilityBackgroundEmeraldSubtle = "#ecfdf5";
export const colorsUtilityBackgroundEmeraldBright = "#a7f3d0";
export const colorsUtilityBackgroundTealStrong = "#0d9488";
export const colorsUtilityBackgroundTealMuted = "#ccfbf1";
export const colorsUtilityBackgroundTealSubtle = "#f0fdfa";
export const colorsUtilityBackgroundTealBright = "#99f6e4";
export const colorsUtilityBackgroundCyanStrong = "#0891b2";
export const colorsUtilityBackgroundCyanMuted = "#cffafe";
export const colorsUtilityBackgroundCyanSubtle = "#ecfeff";
export const colorsUtilityBackgroundCyanBright = "#a5f3fc";
export const colorsUtilityBackgroundSkyStrong = "#0284c7";
export const colorsUtilityBackgroundSkyMuted = "#e0f2fe";
export const colorsUtilityBackgroundSkySubtle = "#f0f9ff";
export const colorsUtilityBackgroundSkyBright = "#bae6fd";
export const colorsUtilityBackgroundBlueStrong = "#2563eb";
export const colorsUtilityBackgroundBlueMuted = "#dbeafe";
export const colorsUtilityBackgroundBlueSubtle = "#eff6ff";
export const colorsUtilityBackgroundBlueBright = "#bfdbfe";
export const colorsUtilityBackgroundIndigoStrong = "#4f46e5";
export const colorsUtilityBackgroundIndigoMuted = "#e0e7ff";
export const colorsUtilityBackgroundIndigoSubtle = "#eef2ff";
export const colorsUtilityBackgroundIndigoBright = "#c7d2fe";
export const colorsUtilityBackgroundVioletStrong = "#7c3aed";
export const colorsUtilityBackgroundVioletMuted = "#ede9fe";
export const colorsUtilityBackgroundVioletSubtle = "#f5f3ff";
export const colorsUtilityBackgroundVioletBright = "#ddd6fe";
export const colorsUtilityBackgroundPurpleStrong = "#9333ea";
export const colorsUtilityBackgroundPurpleMuted = "#f3e8ff";
export const colorsUtilityBackgroundPurpleSubtle = "#faf5ff";
export const colorsUtilityBackgroundPurpleBright = "#e9d5ff";
export const colorsUtilityBackgroundFuchsiaStrong = "#a21caf";
export const colorsUtilityBackgroundFuchsiaMuted = "#fae8ff";
export const colorsUtilityBackgroundFuchsiaSubtle = "#fdf4ff";
export const colorsUtilityBackgroundFuchsiaBright = "#f5d0fe";
export const colorsUtilityBackgroundPinkStrong = "#db2777";
export const colorsUtilityBackgroundPinkMuted = "#fce7f3";
export const colorsUtilityBackgroundPinkSubtle = "#fdf2f8";
export const colorsUtilityBackgroundPinkBright = "#fbcfe8";
export const colorsUtilityBackgroundRoseStrong = "#e11d48";
export const colorsUtilityBackgroundRoseMuted = "#ffe4e6";
export const colorsUtilityBackgroundRoseSubtle = "#fff1f2";
export const colorsUtilityBackgroundRoseBright = "#fecdd3";
export const colorsUtilityBackgroundWhiteStrong = "#ffffff";
export const colorsUtilityBackgroundWhiteTransparent = "#FFFFFF00";
export const colorsUtilityTextBaseWhite = "#ffffff";
export const colorsUtilityTextBaseBlack = "#000000";
export const colorsUtilityTextGrayStrong = "#374151";
export const colorsUtilityTextGrayMuted = "#f3f4f6";
export const colorsUtilityTextGraySubtle = "#f9fafb";
export const colorsUtilityTextGrayBright = "#1f2937";
export const colorsUtilityTextGrayBrighter = "#111827";
export const colorsUtilityTextRedStrong = "#b91c1c";
export const colorsUtilityTextRedMuted = "#fee2e2";
export const colorsUtilityTextRedSubtle = "#fef2f2";
export const colorsUtilityTextRedBright = "#991b1b";
export const colorsUtilityTextRedBrighter = "#7f1d1d";
export const colorsUtilityTextOrangeStrong = "#c2410c";
export const colorsUtilityTextOrangeMuted = "#ffedd5";
export const colorsUtilityTextOrangeSubtle = "#fff7ed";
export const colorsUtilityTextOrangeBright = "#9a3412";
export const colorsUtilityTextOrangeBrighter = "#7c2d12";
export const colorsUtilityTextAmberStrong = "#b45309";
export const colorsUtilityTextAmberMuted = "#fef3c7";
export const colorsUtilityTextAmberSubtle = "#fffbeb";
export const colorsUtilityTextAmberBright = "#92400e";
export const colorsUtilityTextAmberBrighter = "#78350f";
export const colorsUtilityTextYellowStrong = "#a16207";
export const colorsUtilityTextYellowMuted = "#fef9c3";
export const colorsUtilityTextYellowSubtle = "#fefce8";
export const colorsUtilityTextYellowBright = "#854d0e";
export const colorsUtilityTextYellowBrighter = "#713f12";
export const colorsUtilityTextLimeStrong = "#4d7c0f";
export const colorsUtilityTextLimeMuted = "#ecfccb";
export const colorsUtilityTextLimeSubtle = "#f7fee7";
export const colorsUtilityTextLimeBright = "#3f6212";
export const colorsUtilityTextLimeBrighter = "#365314";
export const colorsUtilityTextEmeraldStrong = "#047857";
export const colorsUtilityTextEmeraldMuted = "#d1fae5";
export const colorsUtilityTextEmeraldSubtle = "#ecfdf5";
export const colorsUtilityTextEmeraldBright = "#065f46";
export const colorsUtilityTextEmeraldBrighter = "#064e3b";
export const colorsUtilityTextTealStrong = "#0f766e";
export const colorsUtilityTextTealMuted = "#ccfbf1";
export const colorsUtilityTextTealSubtle = "#f0fdfa";
export const colorsUtilityTextTealBright = "#115e59";
export const colorsUtilityTextTealBrighter = "#134e4a";
export const colorsUtilityTextCyanStrong = "#0e7490";
export const colorsUtilityTextCyanMuted = "#cffafe";
export const colorsUtilityTextCyanSubtle = "#ecfeff";
export const colorsUtilityTextCyanBright = "#155e75";
export const colorsUtilityTextCyanBrighter = "#164e63";
export const colorsUtilityTextSkyStrong = "#0369a1";
export const colorsUtilityTextSkyMuted = "#e0f2fe";
export const colorsUtilityTextSkySubtle = "#f0f9ff";
export const colorsUtilityTextSkyBright = "#075985";
export const colorsUtilityTextSkyBrighter = "#0c4a6e";
export const colorsUtilityTextBlueStrong = "#1d4ed8";
export const colorsUtilityTextBlueMuted = "#dbeafe";
export const colorsUtilityTextBlueSubtle = "#eff6ff";
export const colorsUtilityTextBlueBright = "#1e40af";
export const colorsUtilityTextBlueBrighter = "#1e3a8a";
export const colorsUtilityTextIndigoStrong = "#4338ca";
export const colorsUtilityTextIndigoMuted = "#e0e7ff";
export const colorsUtilityTextIndigoSubtle = "#eef2ff";
export const colorsUtilityTextIndigoBright = "#3730a3";
export const colorsUtilityTextIndigoBrighter = "#312e81";
export const colorsUtilityTextVioletStrong = "#6d28d9";
export const colorsUtilityTextVioletMuted = "#ede9fe";
export const colorsUtilityTextVioletSubtle = "#f5f3ff";
export const colorsUtilityTextVioletBright = "#5b21b6";
export const colorsUtilityTextVioletBrighter = "#4c1d95";
export const colorsUtilityTextPurpleStrong = "#7e22ce";
export const colorsUtilityTextPurpleMuted = "#f3e8ff";
export const colorsUtilityTextPurpleSubtle = "#faf5ff";
export const colorsUtilityTextPurpleBright = "#6b21a8";
export const colorsUtilityTextPurpleBrighter = "#581c87";
export const colorsUtilityTextFuchsiaStrong = "#a21caf";
export const colorsUtilityTextFuchsiaMuted = "#fae8ff";
export const colorsUtilityTextFuchsiaSubtle = "#fdf4ff";
export const colorsUtilityTextFuchsiaBright = "#86198f";
export const colorsUtilityTextFuchsiaBrighter = "#701a75";
export const colorsUtilityTextPinkStrong = "#be185d";
export const colorsUtilityTextPinkMuted = "#fce7f3";
export const colorsUtilityTextPinkSubtle = "#fdf2f8";
export const colorsUtilityTextPinkBright = "#9d174d";
export const colorsUtilityTextPinkBrighter = "#831843";
export const colorsUtilityTextRoseStrong = "#be123c";
export const colorsUtilityTextRoseMuted = "#ffe4e6";
export const colorsUtilityTextRoseSubtle = "#fff1f2";
export const colorsUtilityTextRoseBright = "#9f1239";
export const colorsUtilityTextRoseBrighter = "#881337";
export const colorsUtilityIconBaseWhite = "#ffffff";
export const colorsUtilityIconBaseBlack = "#000000";
export const colorsUtilityIconWhiteStrong = "#ffffff";
export const colorsUtilityIconWhiteMuted = "#FFFFFFD9"; // #ffffff 85%
export const colorsUtilityIconWhiteSubtle = "#FFFFFFA6"; // #ffffff 65%
export const colorsUtilityIconGrayBright = "#374151";
export const colorsUtilityIconGrayStrong = "#4b5563";
export const colorsUtilityIconGraySubtle = "#6b7280";
export const colorsUtilityIconRedBright = "#b91c1c";
export const colorsUtilityIconRedStrong = "#dc2626";
export const colorsUtilityIconRedMuted = "#ef4444";
export const colorsUtilityIconOrangeBright = "#c2410c";
export const colorsUtilityIconOrangeStrong = "#ea580c";
export const colorsUtilityIconOrangeMuted = "#f97316";
export const colorsUtilityIconAmberBright = "#b45309";
export const colorsUtilityIconAmberStrong = "#d97706";
export const colorsUtilityIconAmberMuted = "#f59e0b";
export const colorsUtilityIconYellowBright = "#a16207";
export const colorsUtilityIconYellowStrong = "#ca8a04";
export const colorsUtilityIconYellowMuted = "#eab308";
export const colorsUtilityIconLimeBright = "#4d7c0f";
export const colorsUtilityIconLimeStrong = "#65a30d";
export const colorsUtilityIconLimeMuted = "#84cc16";
export const colorsUtilityIconEmeraldBright = "#047857";
export const colorsUtilityIconEmeraldStrong = "#059669";
export const colorsUtilityIconEmeraldMuted = "#10b981";
export const colorsUtilityIconTealBright = "#0f766e";
export const colorsUtilityIconTealStrong = "#0d9488";
export const colorsUtilityIconTealMuted = "#14b8a6";
export const colorsUtilityIconCyanBright = "#164e63";
export const colorsUtilityIconCyanStrong = "#0891b2";
export const colorsUtilityIconCyanMuted = "#06b6d4";
export const colorsUtilityIconSkyBright = "#0369a1";
export const colorsUtilityIconSkyStrong = "#0284c7";
export const colorsUtilityIconSkyMuted = "#0ea5e9";
export const colorsUtilityIconBlueBright = "#1d4ed8";
export const colorsUtilityIconBlueStrong = "#2563eb";
export const colorsUtilityIconBlueMuted = "#3b82f6";
export const colorsUtilityIconIndigoBright = "#4338ca";
export const colorsUtilityIconIndigoStrong = "#4f46e5";
export const colorsUtilityIconIndigoMuted = "#6366f1";
export const colorsUtilityIconVioletBright = "#4c1d95";
export const colorsUtilityIconVioletStrong = "#7c3aed";
export const colorsUtilityIconVioletMuted = "#8b5cf6";
export const colorsUtilityIconPurpleBright = "#7e22ce";
export const colorsUtilityIconPurpleStrong = "#9333ea";
export const colorsUtilityIconPurpleMuted = "#a855f7";
export const colorsUtilityIconFuchsiaBright = "#a21caf";
export const colorsUtilityIconFuchsiaStrong = "#c026d3";
export const colorsUtilityIconFuchsiaMuted = "#d946ef";
export const colorsUtilityIconPinkBright = "#be185d";
export const colorsUtilityIconPinkStrong = "#db2777";
export const colorsUtilityIconPinkMuted = "#ec4899";
export const colorsUtilityIconRoseBright = "#be123c";
export const colorsUtilityIconRoseStrong = "#e11d48";
export const colorsUtilityIconRoseMuted = "#f43f5e";
export const colorsUtilityBorderBaseWhite = "#ffffff";
export const colorsUtilityBorderBaseBlack = "#000000";
export const colorsUtilityBorderGrayStrong = "#6b7280";
export const colorsUtilityBorderGrayMuted = "#d1d5db";
export const colorsUtilityBorderGraySubtle = "#e5e7eb";
export const colorsUtilityBorderGrayBright = "#374151";
export const colorsUtilityBorderRedStrong = "#ef4444";
export const colorsUtilityBorderRedMuted = "#fca5a5";
export const colorsUtilityBorderRedSubtle = "#fecaca";
export const colorsUtilityBorderRedBright = "#b91c1c";
export const colorsUtilityBorderOrangeStrong = "#f97316";
export const colorsUtilityBorderOrangeMuted = "#fdba74";
export const colorsUtilityBorderOrangeSubtle = "#fed7aa";
export const colorsUtilityBorderOrangeBright = "#c2410c";
export const colorsUtilityBorderAmberStrong = "#f59e0b";
export const colorsUtilityBorderAmberMuted = "#fcd34d";
export const colorsUtilityBorderAmberSubtle = "#fde68a";
export const colorsUtilityBorderAmberBright = "#b45309";
export const colorsUtilityBorderYellowStrong = "#eab308";
export const colorsUtilityBorderYellowMuted = "#fde047";
export const colorsUtilityBorderYellowSubtle = "#fef08a";
export const colorsUtilityBorderYellowBright = "#a16207";
export const colorsUtilityBorderLimeStrong = "#84cc16";
export const colorsUtilityBorderLimeMuted = "#bef264";
export const colorsUtilityBorderLimeSubtle = "#ecfccb";
export const colorsUtilityBorderLimeBright = "#4d7c0f";
export const colorsUtilityBorderEmeraldStrong = "#10b981";
export const colorsUtilityBorderEmeraldMuted = "#6ee7b7";
export const colorsUtilityBorderEmeraldSubtle = "#d1fae5";
export const colorsUtilityBorderEmeraldBright = "#047857";
export const colorsUtilityBorderTealStrong = "#14b8a6";
export const colorsUtilityBorderTealMuted = "#5eead4";
export const colorsUtilityBorderTealSubtle = "#99f6e4";
export const colorsUtilityBorderTealBright = "#0f766e";
export const colorsUtilityBorderCyanStrong = "#06b6d4";
export const colorsUtilityBorderCyanMuted = "#67e8f9";
export const colorsUtilityBorderCyanSubtle = "#a5f3fc";
export const colorsUtilityBorderCyanBright = "#0e7490";
export const colorsUtilityBorderSkyStrong = "#0ea5e9";
export const colorsUtilityBorderSkyMuted = "#7dd3fc";
export const colorsUtilityBorderSkySubtle = "#bae6fd";
export const colorsUtilityBorderSkyBright = "#0369a1";
export const colorsUtilityBorderBlueStrong = "#3b82f6";
export const colorsUtilityBorderBlueMuted = "#93c5fd";
export const colorsUtilityBorderBlueSubtle = "#bfdbfe";
export const colorsUtilityBorderBlueBright = "#1d4ed8";
export const colorsUtilityBorderIndigoStrong = "#6366f1";
export const colorsUtilityBorderIndigoMuted = "#a5b4fc";
export const colorsUtilityBorderIndigoSubtle = "#c7d2fe";
export const colorsUtilityBorderIndigoBright = "#4338ca";
export const colorsUtilityBorderVioletStrong = "#8b5cf6";
export const colorsUtilityBorderVioletMuted = "#c4b5fd";
export const colorsUtilityBorderVioletSubtle = "#ddd6fe";
export const colorsUtilityBorderVioletBright = "#6d28d9";
export const colorsUtilityBorderPurpleStrong = "#a855f7";
export const colorsUtilityBorderPurpleMuted = "#d8b4fe";
export const colorsUtilityBorderPurpleSubtle = "#e9d5ff";
export const colorsUtilityBorderPurpleBright = "#7e22ce";
export const colorsUtilityBorderFuchsiaStrong = "#a21caf";
export const colorsUtilityBorderFuchsiaMuted = "#fae8ff";
export const colorsUtilityBorderFuchsiaSubtle = "#f5d0fe";
export const colorsUtilityBorderFuchsiaBright = "#a21caf";
export const colorsUtilityBorderPinkStrong = "#ec4899";
export const colorsUtilityBorderPinkMuted = "#f9a8d4";
export const colorsUtilityBorderPinkSubtle = "#fbcfe8";
export const colorsUtilityBorderPinkBright = "#be185d";
export const colorsUtilityBorderRoseStrong = "#f43f5e";
export const colorsUtilityBorderRoseMuted = "#fda4af";
export const colorsUtilityBorderRoseSubtle = "#fecdd3";
export const colorsUtilityBorderRoseBright = "#be123c";
export const colorsUtilityDotBaseWhite = "#ffffff";
export const colorsUtilityDotBaseBlack = "#000000";
export const colorsUtilityDotWhiteStrong = "#ffffff";
export const colorsUtilityDotWhiteMuted = "#FFFFFFD9"; // #ffffff 85%
export const colorsUtilityDotWhiteBlack = "#FFFFFFA6"; // #ffffff 65%
export const colorsUtilityDotGrayBright = "#374151";
export const colorsUtilityDotGrayStrong = "#4b5563";
export const colorsUtilityDotGraySubtle = "#6b7280";
export const colorsUtilityDotRedBright = "#b91c1c";
export const colorsUtilityDotRedStrong = "#dc2626";
export const colorsUtilityDotRedMuted = "#ef4444";
export const colorsUtilityDotOrangeBright = "#c2410c";
export const colorsUtilityDotOrangeStrong = "#ea580c";
export const colorsUtilityDotOrangeMuted = "#f97316";
export const colorsUtilityDotAmberBright = "#b45309";
export const colorsUtilityDotAmberStrong = "#d97706";
export const colorsUtilityDotAmberMuted = "#f59e0b";
export const colorsUtilityDotYellowBright = "#a16207";
export const colorsUtilityDotYellowStrong = "#ca8a04";
export const colorsUtilityDotYellowMuted = "#eab308";
export const colorsUtilityDotLimeBright = "#4d7c0f";
export const colorsUtilityDotLimeStrong = "#65a30d";
export const colorsUtilityDotLimeMuted = "#84cc16";
export const colorsUtilityDotEmeraldBright = "#047857";
export const colorsUtilityDotEmeraldStrong = "#059669";
export const colorsUtilityDotEmeraldMuted = "#10b981";
export const colorsUtilityDotTealBright = "#0f766e";
export const colorsUtilityDotTealStrong = "#0d9488";
export const colorsUtilityDotTealMuted = "#14b8a6";
export const colorsUtilityDotCyanBright = "#164e63";
export const colorsUtilityDotCyanStrong = "#0891b2";
export const colorsUtilityDotCyanMuted = "#06b6d4";
export const colorsUtilityDotSkyBright = "#0369a1";
export const colorsUtilityDotSkyStrong = "#0284c7";
export const colorsUtilityDotSkyMuted = "#0ea5e9";
export const colorsUtilityDotBlueBright = "#1d4ed8";
export const colorsUtilityDotBlueStrong = "#2563eb";
export const colorsUtilityDotBlueMuted = "#3b82f6";
export const colorsUtilityDotIndigoBright = "#4338ca";
export const colorsUtilityDotIndigoStrong = "#4f46e5";
export const colorsUtilityDotIndigoMuted = "#6366f1";
export const colorsUtilityDotVioletBright = "#4c1d95";
export const colorsUtilityDotVioletStrong = "#7c3aed";
export const colorsUtilityDotVioletMuted = "#8b5cf6";
export const colorsUtilityDotPurpleBright = "#7e22ce";
export const colorsUtilityDotPurpleStrong = "#9333ea";
export const colorsUtilityDotPurpleMuted = "#a855f7";
export const colorsUtilityDotFuchsiaBright = "#a21caf";
export const colorsUtilityDotFuchsiaStrong = "#c026d3";
export const colorsUtilityDotFuchsiaMuted = "#d946ef";
export const colorsUtilityDotPinkBright = "#be185d";
export const colorsUtilityDotPinkStrong = "#db2777";
export const colorsUtilityDotPinkMuted = "#ec4899";
export const colorsUtilityDotRoseBright = "#be123c";
export const colorsUtilityDotRoseStrong = "#e11d48";
export const colorsUtilityDotRoseMuted = "#f43f5e";
export const colorsSecondaryGray50 = "#F9FAFB";
export const colorsSecondaryGray100 = "#F2F4F7";
export const colorsSecondaryGray200 = "#EAECF0";
export const colorsSecondaryGray300 = "#D0D5DD";
export const colorsSecondaryGray400 = "#98A2B3";
export const colorsSecondaryGray500 = "#667085";
export const colorsSecondaryGray600 = "#475467";
export const colorsSecondaryGray700 = "#344054";
export const colorsSecondaryGray800 = "#1D2939";
export const colorsSecondaryGray900 = "#101828";
export const colorsSecondaryGrayCool50 = "#F9F9FB";
export const colorsSecondaryGrayCool100 = "#EFF1F5";
export const colorsSecondaryGrayCool200 = "#DCDFEA";
export const colorsSecondaryGrayCool300 = "#B9C0D4";
export const colorsSecondaryGrayCool400 = "#7D89B0";
export const colorsSecondaryGrayCool500 = "#5D6B98";
export const colorsSecondaryGrayCool600 = "#4A5578";
export const colorsSecondaryGrayCool700 = "#404968";
export const colorsSecondaryGrayCool800 = "#30374F";
export const colorsSecondaryGrayCool900 = "#111322";
export const colorsSecondaryGrayModern50 = "#F8FAFC";
export const colorsSecondaryGrayModern100 = "#EEF2F6";
export const colorsSecondaryGrayModern200 = "#E3E8EF";
export const colorsSecondaryGrayModern300 = "#CDD5DF";
export const colorsSecondaryGrayModern400 = "#9AA4B2";
export const colorsSecondaryGrayModern500 = "#697586";
export const colorsSecondaryGrayModern600 = "#4B5565";
export const colorsSecondaryGrayModern700 = "#364152";
export const colorsSecondaryGrayModern800 = "#202939";
export const colorsSecondaryGrayModern900 = "#121926";
export const colorsSecondaryGrayNeutral50 = "#F9FAFB";
export const colorsSecondaryGrayNeutral100 = "#F3F4F6";
export const colorsSecondaryGrayNeutral200 = "#E5E7EB";
export const colorsSecondaryGrayNeutral300 = "#D2D6DB";
export const colorsSecondaryGrayNeutral400 = "#9DA4AE";
export const colorsSecondaryGrayNeutral500 = "#6C737F";
export const colorsSecondaryGrayNeutral600 = "#4D5761";
export const colorsSecondaryGrayNeutral700 = "#384250";
export const colorsSecondaryGrayNeutral800 = "#1F2A37";
export const colorsSecondaryGrayNeutral900 = "#111927";
export const colorsSecondaryGrayWarm50 = "#FAFAF9";
export const colorsSecondaryGrayWarm100 = "#F5F5F4";
export const colorsSecondaryGrayWarm200 = "#E7E5E4";
export const colorsSecondaryGrayWarm300 = "#D7D3D0";
export const colorsSecondaryGrayWarm400 = "#A9A29D";
export const colorsSecondaryGrayWarm500 = "#79716B";
export const colorsSecondaryGrayWarm600 = "#57534E";
export const colorsSecondaryGrayWarm700 = "#44403C";
export const colorsSecondaryGrayWarm800 = "#292524";
export const colorsSecondaryGrayWarm900 = "#1C1917";
export const colorsSecondaryRed50 = "#FEF3F2";
export const colorsSecondaryRed100 = "#FEE4E2";
export const colorsSecondaryRed200 = "#FECDCA";
export const colorsSecondaryRed300 = "#FDA29B";
export const colorsSecondaryRed400 = "#F97066";
export const colorsSecondaryRed500 = "#F04438";
export const colorsSecondaryRed600 = "#D92D20";
export const colorsSecondaryRed700 = "#B42318";
export const colorsSecondaryRed800 = "#912018";
export const colorsSecondaryRed900 = "#7A271A";
export const colorsSecondaryOrange50 = "#FFF4ED";
export const colorsSecondaryOrange100 = "#FFE6D5";
export const colorsSecondaryOrange200 = "#FFD6AE";
export const colorsSecondaryOrange300 = "#FF9C66";
export const colorsSecondaryOrange400 = "#FF692E";
export const colorsSecondaryOrange500 = "#FF4405";
export const colorsSecondaryOrange600 = "#E62E05";
export const colorsSecondaryOrange700 = "#BC1B06";
export const colorsSecondaryOrange800 = "#97180C";
export const colorsSecondaryOrange900 = "#771A0D";
export const colorsSecondaryOrangeDark50 = "#FFF4ED";
export const colorsSecondaryOrangeDark100 = "#FFE6D5";
export const colorsSecondaryOrangeDark200 = "#FFD6AE";
export const colorsSecondaryOrangeDark300 = "#FF9C66";
export const colorsSecondaryOrangeDark400 = "#FF692E";
export const colorsSecondaryOrangeDark500 = "#FF4405";
export const colorsSecondaryOrangeDark600 = "#E62E05";
export const colorsSecondaryOrangeDark700 = "#BC1B06";
export const colorsSecondaryOrangeDark800 = "#97180C";
export const colorsSecondaryOrangeDark900 = "#771A0D";
export const colorsSecondaryYellow50 = "#fefce8";
export const colorsSecondaryYellow100 = "#fef9c3";
export const colorsSecondaryYellow200 = "#fef08a";
export const colorsSecondaryYellow300 = "#fde047";
export const colorsSecondaryYellow400 = "#facc15";
export const colorsSecondaryYellow500 = "#eab308";
export const colorsSecondaryYellow600 = "#ca8a04";
export const colorsSecondaryYellow700 = "#a16207";
export const colorsSecondaryYellow800 = "#854d0e";
export const colorsSecondaryYellow900 = "#713f12";
export const colorsSecondaryMoss50 = "#F5FBEE";
export const colorsSecondaryMoss100 = "#E6F4D7";
export const colorsSecondaryMoss200 = "#CEEAB0";
export const colorsSecondaryMoss300 = "#ACDC79";
export const colorsSecondaryMoss400 = "#86CB3C";
export const colorsSecondaryMoss500 = "#669F2A";
export const colorsSecondaryMoss600 = "#4F7A21";
export const colorsSecondaryMoss700 = "#3F621A";
export const colorsSecondaryMoss800 = "#335015";
export const colorsSecondaryMoss900 = "#2B4212";
export const colorsSecondaryGreenLight50 = "#F3FEE7";
export const colorsSecondaryGreenLight100 = "#E4FBCC";
export const colorsSecondaryGreenLight200 = "#D0F8AB";
export const colorsSecondaryGreenLight300 = "#A6EF67";
export const colorsSecondaryGreenLight400 = "#85E13A";
export const colorsSecondaryGreenLight500 = "#66C61C";
export const colorsSecondaryGreenLight600 = "#4CA30D";
export const colorsSecondaryGreenLight700 = "#3B7C0F";
export const colorsSecondaryGreenLight800 = "#326212";
export const colorsSecondaryGreenLight900 = "#2B5314";
export const colorsSecondaryGreen50 = "#EDFCF2";
export const colorsSecondaryGreen100 = "#D3F8DF";
export const colorsSecondaryGreen200 = "#AAF0C4";
export const colorsSecondaryGreen300 = "#73E2A3";
export const colorsSecondaryGreen400 = "#3CCB7F";
export const colorsSecondaryGreen500 = "#16B364";
export const colorsSecondaryGreen600 = "#099250";
export const colorsSecondaryGreen700 = "#087443";
export const colorsSecondaryGreen800 = "#095C37";
export const colorsSecondaryGreen900 = "#084C2E";
export const colorsSecondaryTeal50 = "#f0fdfa";
export const colorsSecondaryTeal100 = "#ccfbf1";
export const colorsSecondaryTeal200 = "#99f6e4";
export const colorsSecondaryTeal300 = "#5eead4";
export const colorsSecondaryTeal400 = "#2dd4bf";
export const colorsSecondaryTeal500 = "#14b8a6";
export const colorsSecondaryTeal600 = "#0d9488";
export const colorsSecondaryTeal700 = "#0f766e";
export const colorsSecondaryTeal800 = "#115e59";
export const colorsSecondaryTeal900 = "#134e4a";
export const colorsSecondaryBlueLight50 = "#F0F9FF";
export const colorsSecondaryBlueLight100 = "#E0F2FE";
export const colorsSecondaryBlueLight200 = "#B9E6FE";
export const colorsSecondaryBlueLight300 = "#7CD4FD";
export const colorsSecondaryBlueLight400 = "#36BFFA";
export const colorsSecondaryBlueLight500 = "#0BA5EC";
export const colorsSecondaryBlueLight600 = "#0086C9";
export const colorsSecondaryBlueLight700 = "#026AA2";
export const colorsSecondaryBlueLight800 = "#065986";
export const colorsSecondaryBlueLight900 = "#0B4A6F";
export const colorsSecondaryBlueDark50 = "#EFF4FF";
export const colorsSecondaryBlueDark100 = "#D1E0FF";
export const colorsSecondaryBlueDark200 = "#B2CCFF";
export const colorsSecondaryBlueDark300 = "#84ADFF";
export const colorsSecondaryBlueDark400 = "#528BFF";
export const colorsSecondaryBlueDark500 = "#2970FF";
export const colorsSecondaryBlueDark600 = "#155EEF";
export const colorsSecondaryBlueDark700 = "#004EEB";
export const colorsSecondaryBlueDark800 = "#0040C1";
export const colorsSecondaryBlueDark900 = "#00359E";
export const colorsSecondaryIndigo50 = "#EEF4FF";
export const colorsSecondaryIndigo100 = "#E0EAFF";
export const colorsSecondaryIndigo200 = "#C7D7FE";
export const colorsSecondaryIndigo300 = "#A4BCFD";
export const colorsSecondaryIndigo400 = "#8098F9";
export const colorsSecondaryIndigo500 = "#6172F3";
export const colorsSecondaryIndigo600 = "#444CE7";
export const colorsSecondaryIndigo700 = "#3538CD";
export const colorsSecondaryIndigo800 = "#2D31A6";
export const colorsSecondaryIndigo900 = "#2D3282";
export const colorsSecondaryViolet50 = "#f5f3ff";
export const colorsSecondaryViolet100 = "#ede9fe";
export const colorsSecondaryViolet200 = "#ddd6fe";
export const colorsSecondaryViolet300 = "#c4b5fd";
export const colorsSecondaryViolet400 = "#a78bfa";
export const colorsSecondaryViolet500 = "#8b5cf6";
export const colorsSecondaryViolet600 = "#7c3aed";
export const colorsSecondaryViolet700 = "#6d28d9";
export const colorsSecondaryViolet800 = "#5b21b6";
export const colorsSecondaryViolet900 = "#4c1d95";
export const colorsSecondaryPurple50 = "#faf5ff";
export const colorsSecondaryPurple100 = "#f3e8ff";
export const colorsSecondaryPurple200 = "#e9d5ff";
export const colorsSecondaryPurple300 = "#d8b4fe";
export const colorsSecondaryPurple400 = "#c084fc";
export const colorsSecondaryPurple500 = "#a855f7";
export const colorsSecondaryPurple600 = "#9333ea";
export const colorsSecondaryPurple700 = "#7e22ce";
export const colorsSecondaryPurple800 = "#6b21a8";
export const colorsSecondaryPurple900 = "#581c87";
export const colorsSecondaryFuchsia50 = "#fdf4ff";
export const colorsSecondaryFuchsia100 = "#fae8ff";
export const colorsSecondaryFuchsia200 = "#f5d0fe";
export const colorsSecondaryFuchsia300 = "#f0abfc";
export const colorsSecondaryFuchsia400 = "#e879f9";
export const colorsSecondaryFuchsia500 = "#d946ef";
export const colorsSecondaryFuchsia600 = "#c026d3";
export const colorsSecondaryFuchsia700 = "#a21caf";
export const colorsSecondaryFuchsia800 = "#86198f";
export const colorsSecondaryFuchsia900 = "#701a75";
export const colorsSecondaryPink50 = "#fdf2f8";
export const colorsSecondaryPink100 = "#fce7f3";
export const colorsSecondaryPink200 = "#fbcfe8";
export const colorsSecondaryPink300 = "#f9a8d4";
export const colorsSecondaryPink400 = "#f472b6";
export const colorsSecondaryPink500 = "#ec4899";
export const colorsSecondaryPink600 = "#db2777";
export const colorsSecondaryPink700 = "#be185d";
export const colorsSecondaryPink800 = "#9d174d";
export const colorsSecondaryPink900 = "#831843";
export const colorsSecondaryRose50 = "#FFF1F3";
export const colorsSecondaryRose100 = "#FFE4E8";
export const colorsSecondaryRose200 = "#FECDD6";
export const colorsSecondaryRose300 = "#FEA3B4";
export const colorsSecondaryRose400 = "#FD6F8E";
export const colorsSecondaryRose500 = "#F63D68";
export const colorsSecondaryRose600 = "#E31B54";
export const colorsSecondaryRose700 = "#C01048";
export const colorsSecondaryRose800 = "#A11043";
export const colorsSecondaryRose900 = "#89123E";
export const colorsSecondaryBrown50 = "#FAF5F1";
export const colorsSecondaryBrown100 = "lch(91.3 3.22 54)";
export const colorsSecondaryBrown200 = "#d8cbc4";
export const colorsSecondaryBrown300 = "#bca89f";
export const colorsSecondaryBrown400 = "#a08679";
export const colorsSecondaryBrown500 = "#8b6c5c";
export const colorsSecondaryBrown600 = "#765341";
export const colorsSecondaryBrown700 = "#6a4a3a";
export const colorsSecondaryBrown800 = "#5b3e31";
export const colorsSecondaryBrown900 = "#4c3228";
export const space0 = "0px";
export const space1 = "2px";
export const space2 = "4px";
export const space3 = "6px";
export const space4 = "8px";
export const space5 = "12px";
export const spaceMd = "16px";
export const space7 = "20px";
export const space8 = "24px";
export const space9 = "32px";
export const space10 = "40px";
export const space11 = "48px";
export const space12 = "64px";
export const space13 = "80px";
export const space14 = "96px";
export const space15 = "112px";
export const space16 = "128px";
export const gapNull = "0px";
export const gapXxxs = "2px";
export const gapXxs = "4px";
export const gapXs = "6px";
export const gapSm = "8px";
export const gapMd = "12px";
export const gapLg = "16px";
export const gapXl = "20px";
export const gapXxl = "24px";
export const gapXxxl = "32px";
export const gapXxxxl = "40px";
export const gapXxxxxl = "48px";
export const borderRadiusNone = "0px";
export const borderRadiusXs = "4px";
export const borderRadiusSm = "6px";
export const borderRadiusMd = "8px";
export const borderRadiusLg = "12px";
export const borderRadiusXl = "16px";
export const borderRadiusFull = "100px";
export const size2xl = "56px";
export const sizeLg = "40px";
export const sizeMd = "32px";
export const sizeSm = "24px";
export const sizeXs = "20px";
export const size2xs = "16px";
export const size3xs = "14px";
export const size4xs = "12px";
export const shadowsNoStrokeXs = "0 1px 2px 0 #1018280d";
export const shadowsNoStrokeSm = "0 1px 2px 0 #1018280f, 0 1px 3px 0 #1018281a";
export const shadowsNoStrokeMd = "0 2px 4px -2px #1018280f, 0 4px 8px -2px #1018281a";
export const shadowsNoStrokeLg = "0 12px 16px -4px #10182814, 0 12px 16px -4px #10182814";
export const shadowsNoStrokeXl = "0 8px 8px -4px #10182808, 0 20px 24px -4px #10182814";
export const shadowsNoStroke2xl = "0 24px 48px -12px #1018282e";
export const shadowsNoStroke3xl = "0 32px 64px -12px #10182824";
export const shadowsNoStrokeFocusXsFocusOffset = "0 0 0 4px #dbeafe, 0 0 0 1px #ffffff"; // shadow for focus state
export const shadowsNoStrokeFocusXsFocusRing = "0 1px 2px 0 rgba(16,24,41,5%), 0 0 0 4px #dbeafe"; // shadow for focus state
export const shadowsNoStrokeFocusXsFocusRingDanger = "0 1px 2px 0 rgba(16,24,41,5%), 0 0 0 4px #FEE4E2"; // shadow for focus state
export const shadowsStrokedXs = "0 0 0 1px #10182814, 0 1px 2px 0 #1018280d";
export const shadowsStrokedSm = "0 0 0 1px #10182814, 0 1px 2px 0 #1018280f, 0 1px 3px 0 #1018281a";
export const shadowsStrokedMd = "0 0 0 1px #10182814, 0 2px 4px -2px #1018280f, 0 4px 8px -2px #1018281a";
export const shadowsStrokedLg = "0 0 0 1px #10182814, 0 6px 6px -2px #10182808, 0 12px 16px -4px #10182814";
export const shadowsStrokedXl = "0 0 0 1px #10182814, 0 8px 8px -4px #10182808, 0 20px 24px -4px #10182814";
export const shadowsStroked2xl = "0 0 0 1px #10182814, 0 24px 48px -12px #1018282e";
export const shadowsStroked3xl = "0 0 0 1px #10182814, 0 32px 64px -12px #10182824";
export const dividerPrimary = "1px solid #e5e7eb";
export const dividerSecondary = "1px solid #d1d5db";
export const borderPrimary = "1px solid #e5e7eb";
export const borderPrimaryDisabled = "1px solid #f3f4f6";
export const borderSecondary = "1px solid #d1d5db";
export const borderSecondaryDisabled = "1px solid #f3f4f6";
export const borderDropdown = "1px solid #d1d5db";
export const borderMuted = "1px solid #f9fafb";
export const borderAccent = "1px solid #2563eb";
export const borderAccentDisabled = "1px solid #bfdbfe";
export const borderSuccess = "1px solid #059669";
export const borderSuccessDisabled = "1px solid #a7f3d0";
export const borderWarning = "1px solid #ea580c";
export const borderWarningDisabled = "1px solid #fed7aa";
export const borderDanger = "1px solid #dc2626";
export const borderDangerDisabled = "1px solid #fecaca";
export const cardBorder = "1px solid lch(89.6 2.46 261)";
export const cardBorderHover = "1px solid #3b82f6";
export const cardBorderSelected = "1px solid #3b82f6";
export const cardBorderRadius = "8px";
export const cardBackground = "#ffffff";
export const cardShadow = "0 2px 4px -2px #1018280f, 0 4px 6px #1018281a";
export const cardPadding = "16px 16px";
export const cardGap = "12px";
export const cardBodyPadding = "0px 0px";
export const cardBodyGap = "12px";
export const cardHoverBackground = "hsl(221 83.2% 97.2%)";
export const cardSelectedBackground = "#ffffff";
export const cardOverdueBorder = "1px solid #ef4444";
export const cardOverdueBorderHover = "1px solid #ef4444";
export const cardOverdueBorderSelected = "1px solid #ef4444";
export const cardOverdueBorderRadius = "8px";
export const cardOverdueBackground = "#fef2f2";
export const cardOverdueHoverBackground = "hsl(0 96.3% 95.8%)";
export const cardOverdueSelectedBackground = "#ffffff";
export const cardOverdueShadow = "0 2px 4px -2px #1018280f, 0 4px 6px #1018281a";
export const cardOverdueBodyPadding = "0px 0px";
export const cardOverdueBodyGap = "12px";
export const cardOverduePadding = "16px 16px";
export const cardOverdueGap = "12px";
export const breadcrumbMdGap = "1px";
export const breadcrumbMdHeight = "28px";
export const breadcrumbMdTextPadding = "0px 8px";
export const breadcrumbMdTextHeight = "28px";
export const breadcrumbMdDividerHeight = "28px";
export const breadcrumbMdDividerPadding = "0px 4px";
export const breadcrumbMdOverflowTextHeight = "28px";
export const breadcrumbMdOverflowTextPadding = "0px 0px";
export const breadcrumbLgGap = "0px";
export const breadcrumbLgHeight = "40px";
export const breadcrumbLgTextPadding = "0px 8px";
export const breadcrumbLgTextHeight = "40px";
export const breadcrumbLgDividerHeight = "40px";
export const breadcrumbLgOverflowTextHeight = "40px";
export const chipBorderDefault = "1px solid #e5e7eb";
export const chipBorderHover = "1px solid #d1d5db";
export const chipBorderSelected = "1px solid #d1d5db";
export const chipBorderActive = "1px solid #3b82f6";
export const chipBorderDisabled = "1px solid #e5e7eb";
export const chipBorderFocused = "1px solid #93c5fd";
export const chipBorderRadiusFull = "100%";
export const chipBorderRadiusMd = "10px";
export const chipText = "#374151";
export const chipIcon = "#6b7280";
export const chipBorder = "#e5e7eb";
export const chipBackground = "#ffffff";
export const chipHoverText = "#111827";
export const chipHoverIcon = "#374151";
export const chipHoverBorder = "#d1d5db";
export const chipHoverBackground = "#f9fafb";
export const chipActiveText = "#374151";
export const chipActiveIcon = "#6b7280";
export const chipActiveBorder = "#3b82f6";
export const chipActiveBackground = "#ffffff";
export const chipSelectedText = "#374151";
export const chipSelectedIcon = "#6b7280";
export const chipSelectedBorder = "#d1d5db";
export const chipSelectedBackground = "#ffffff";
export const chipFocusedText = "#374151";
export const chipFocusedIcon = "#6b7280";
export const chipFocusedBorder = "#93c5fd";
export const chipFocusedBackground = "#ffffff";
export const chipShadowDefault = "0 1px 2px 0 #1018280d";
export const chipShadowFocused = "0 1px 2px 0 rgba(16,24,41,5%), 0 0 0 4px #dbeafe";
export const chipHeightSm = "24px";
export const chipHeightMd = "56px";
export const chipDisabledText = "#d1d5db";
export const chipDisabledIcon = "#e5e7eb";
export const chipDisabledBorder = "#e5e7eb";
export const chipDisabledBackground = "#ffffff";
export const dropdownMenuItemXs = "20px";
export const tabSmFont = "500 12px/18px Inter";
export const tabSmHeight = "28px";
export const tabSmBorderRadiusSquared = "6px";
export const tabSmPadding = "4px 8px";
export const tabSmBorderWidth1px = "1px";
export const tabSmGap = "6px";
export const tabMdFont = "500 13px/18px Inter";
export const tabMdHeight = "32px";
export const tabMdBorderRadius = "6px";
export const tabMdBorderwidth1px = "1px";
export const tabMdGap = "8px";
export const tabMdPadding = "8px 12px";
export const tabLgFont = "500 16px/24px Inter";
export const tabLgHeight = "40px";
export const tabLgBorderRadius = "8px";
export const tabLgPadding = "8px 16px";
export const tabLgGap = "8px";
export const tabLgBorderWidth1px = "1px";
export const modalHeaderPadding = "32px 24px 0px 24px";
export const modalHeaderGap = "16px";
export const modalWidth = "560px";
export const modalBorderRadius = "12px";
export const modalFooterPadding = "32px 24px 24px 88px";
export const modalFooterGap = "12px";
export const modalFooterActionsGap = "12px";
export const modalText = "#111827";
export const modalSubtext = "#374151";
export const modalBackground = "#ffffff";
export const modalIcon = "48px";
export const modalIconBackgroundAccentMuted = "#dbeafe";
export const modalIconBackgroundAccentSubtle = "#eff6ff";
export const modalIconBackgroundNeutralMuted = "#f3f4f6";
export const modalIconBackgroundNeutralSubtle = "#f9fafb";
export const modalIconBackgroundInfoMuted = "#e0f2fe";
export const modalIconBackgroundInfoSubtle = "#f0f9ff";
export const modalIconBackgroundDangerMuted = "#fee2e2";
export const modalIconBackgroundDangerSubtle = "#fef2f2";
export const modalIconBackgroundWarningMuted = "#fef3c7";
export const modalIconBackgroundWarningSubtle = "#fffbeb";
export const modalIconBackgroundSuccessMuted = "#d1fae5";
export const modalIconBackgroundSuccessSubtle = "#ecfdf5";
export const compositionModalFooterSpacing = "12px";
export const compositionModalFooterPaddingTop = "32px";
export const compositionModalFooterPaddingRight = "24px";
export const compositionModalFooterPaddingLeft = "24px";
export const compositionModalFooterPaddingBottom = "0px";
export const compositionModalFooterItemSpacing = "16px";
export const sideNavContainerBackground = "#111827";
export const sideNavContainerBorder = "#334155";
export const sideNavContainerText = "#9ca3af";
export const sideNavContainerDivider = "#374151";
export const sideNavItemsText = "#CDD5DF";
export const sideNavItemsSubtext = "#94a3b8";
export const sideNavItemsIcon = "#94a3b8";
export const sideNavItemsIconSubtle = "#697586";
export const sideNavItemsTextSubtle = "#9AA4B2";
export const sideNavItemsHoverText = "#CDD5DF";
export const sideNavItemsHoverSubtext = "#94a3b8";
export const sideNavItemsHoverBackground = "#6b728033";
export const sideNavItemsHoverIcon = "#94a3b8";
export const sideNavItemsHoverIconSubtle = "#d1d5db";
export const sideNavItemsHoverTextSubtle = "#9AA4B2";
export const sideNavItemsSelectedText = "#F8FAFC";
export const sideNavItemsSelectedSubtext = "#94a3b8";
export const sideNavItemsSelectedBackground = "#6b728033";
export const sideNavItemsSelectedIcon = "#cbd5e1";
export const sideNavItemsBorderRadius = "6px";
export const sideNavItemsHeight = "30px";
export const sideNavTooltipText = "#CDD5DF";
export const sideNavTooltipBackground = "#1f2937";
export const sideNavTooltipIcon = "#94a3b8";
export const sideNavTooltipTextSubtle = "#9AA4B2";
export const sideNavTooltipHoverText = "#CDD5DF";
export const sideNavTooltipHoverSubtext = "#94a3b8";
export const sideNavTooltipHoverBackground = "#6b728033";
export const sideNavTooltipHoverIcon = "#94a3b8";
export const sideNavTooltipHoverIconSubtle = "#d1d5db";
export const sideNavTooltipHoverTextSubtle = "#9AA4B2";
export const sideNavTooltipSelectedText = "#f3f4f6";
export const sideNavTooltipSelectedSubtext = "#94a3b8";
export const sideNavTooltipSelectedBackground = "#6b728033";
export const sideNavTooltipSelectedIcon = "#cbd5e1";
export const sideNavTooltipItemsPadding = "4px 8px";
export const sideNavTooltipItemsGap = "6px";
export const sideNavTooltipPadding = "8px 8px";
export const sideNavTooltipGap = "6px";
export const sideNavAvatarPadding = "6px 8px";
export const sideNavAvatarGap = "12px";
export const sideNavMainSelectPadding = "6px 8px";
export const sideNavMainSelectGap = "10px";
export const sideNavSubSelectPadding = "6px 8px 6px 24px";
export const sideNavSubSelectGap = "10px";
export const sideNavOptionPadding = "6px 12px";
export const sideNavOptionGap = "10px";
export const sideNavNotificationPadding = "8px 8px 10px 10px";
export const sideNavNotificationGap = "6px";
export const sideNavNotificationText = "#CDD5DF";
export const sideNavNotificationBackground = "#202939";
export const sideNavNotificationBorder = "#30374F";
export const sideNavNotificationIcon = "#8b5cf6";
export const sideNavNotificationSubtext = "#697586";
export const sideNavNotificationButtonDefaultText = "#8b5cf6";
export const sideNavNotificationButtonDefaultIcon = "#8b5cf6";
export const sideNavNotificationButtonHoverText = "#6d28d9";
export const sideNavNotificationButtonHoverIcon = "#7c3aed";
export const sideNavSearchText = "#CDD5DF";
export const sideNavSearchBackground = "#202939";
export const sideNavSearchBorder = "#30374F";
export const sideNavSearchIcon = "#8b5cf6";
export const sideNavSearchSubtext = "#697586";
export const sideNavSearchDefaultText = "#8b5cf6";
export const sideNavSearchDefaultIcon = "#8b5cf6";
export const sideNavSearchHoverText = "#6d28d9";
export const sideNavSearchHoverIcon = "#7c3aed";
export const sideNavSearchPadding = "8px 8px 10px 10px";
export const sideNavSearchGap = "6px";
export const sideNavInverseContainerBackground = "#EAECF0";
export const sideNavInverseContainerBorder = "#D0D5DD";
export const sideNavInverseContainerText = "#111827";
export const sideNavInverseItemsText = "#374151";
export const sideNavInverseItemsSubtext = "#94a3b8";
export const sideNavInverseItemsIcon = "#6b7280";
export const sideNavInverseItemsHoverText = "#111827";
export const sideNavInverseItemsHoverSubtext = "#94a3b8";
export const sideNavInverseItemsHoverBackground = "#f3f4f6";
export const sideNavInverseItemsHoverIcon = "#374151";
export const sideNavInverseItemsFocusedText = "#374151";
export const sideNavInverseItemsFocusedSubtext = "#94a3b8";
export const sideNavInverseItemsFocusedBackground = "#ffffff";
export const sideNavInverseItemsFocusedIcon = "#6b7280";
export const sideNavInverseItemsFocusedBackgroundSubtle = "#f9fafb";
export const alphabetFilterBackground = "#FFFFFF00";
export const alphabetFilterButtonText = "#374151";
export const alphabetFilterButtonHoverText = "#1d4ed8";
export const alphabetFilterButtonSelectedText = "#1d4ed8";
export const alphabetFilterButtonHeight = "24px";
export const alphabetFilterButtonWidth = "24px";
export const alphabetFilterButtonFont = "500 10px/14px Inter";
export const alphabetFilterGap = "0px";
export const alphabetFilterPadding = "0px 8px";
export const tableCellMdFont = "400 13px/18px Inter";
export const tableCellMdGap = "8px";
export const tableCellMdHeaderGap = "16px";
export const tableCellMdPadding = "8px 8px";
export const tableCellMdBorderBottom = "1px solid #e5e7eb";
export const tableCellMdHeight = "40px";
export const radioButtonSmBorderDefault = "1px solid #d1d5db";
export const radioButtonSmBorderHover = "1px solid #1d4ed8";
export const radioButtonSmBorderFocused = "1px solid #3b82f6";
export const radioButtonSmBorderDanger = "1px solid #ef4444";
export const radioButtonSmBorderDangerFocused = "1px solid #fca5a5";
export const radioButtonSmBorderDisabled = "1px solid #e5e7eb";
export const radioButtonSmBorderChecked = "1px solid #3b82f6";
export const radioButtonSmBorderHoverChecked = "1px solid #1d4ed8";
export const radioButtonSmBorderFocusedChecked = "1px solid #3b82f6";
export const radioButtonSmBorderDisabledChecked = "1px solid #e5e7eb";
export const radioButtonSmBorderRadius = "100px";
export const radioButtonSmShadow = "0 1px 2px 0 #e5e7eb";
export const radioButtonSmShadowFocused = "0 1px 2px 0 #1018290d, 0 0 0 4px #dbeafe";
export const radioButtonSmShadowFocusedDanger = "0 1px 2px 0 #fecdca, 0 0 0 4px #fee4e2";
export const radioButtonSmHeight = "14px";
export const radioButtonSmWidth = "14px";
export const radioButtonSmGap = "8px";
export const radioButtonMdBorderDefault = "1px solid #d1d5db";
export const radioButtonMdBorderHover = "1px solid #1d4ed8";
export const radioButtonMdBorderFocused = "1px solid #3b82f6";
export const radioButtonMdBorderDanger = "1px solid #ef4444";
export const radioButtonMdBorderDangerFocused = "1px solid #fca5a5";
export const radioButtonMdBorderDisabled = "1px solid #e5e7eb";
export const radioButtonMdBorderChecked = "1px solid #3b82f6";
export const radioButtonMdBorderHoverChecked = "1px solid #1d4ed8";
export const radioButtonMdBorderFocusedChecked = "1px solid #3b82f6";
export const radioButtonMdBorderDisabledChecked = "1px solid #e5e7eb";
export const radioButtonMdBorderRadius = "100px";
export const radioButtonMdShadow = "0 1px 2px 0 #e5e7eb";
export const radioButtonMdShadowFocused = "0 1px 2px 0 #1018290d, 0 0 0 4px #dbeafe";
export const radioButtonMdShadowFocusedDanger = "0 1px 2px 0 #fecdca, 0 0 0 4px #fee4e2";
export const radioButtonMdHeight = "20px";
export const radioButtonMdWidth = "20px";
export const radioButtonMdGap = "10px";
export const radioButtonXsBorderDefault = "0.5px solid #d1d5db";
export const radioButtonXsBorderHover = "0.5px solid #1d4ed8";
export const radioButtonXsBorderFocused = "0.5px solid #3b82f6";
export const radioButtonXsBorderDanger = "0.5px solid #ef4444";
export const radioButtonXsBorderDangerFocused = "0.5px solid #fca5a5";
export const radioButtonXsBorderDisabled = "0.5px solid #e5e7eb";
export const radioButtonXsBorderChecked = "0.5px solid #3b82f6";
export const radioButtonXsBorderHoverChecked = "0.5px solid #1d4ed8";
export const radioButtonXsBorderFocusedChecked = "0.5px solid #3b82f6";
export const radioButtonXsBorderDisabledChecked = "0.5px solid #e5e7eb";
export const radioButtonXsBorderRadius = "100px";
export const radioButtonXsShadow = "0 1px 2px 0 #e5e7eb";
export const radioButtonXsShadowFocused = "0 1px 2px 0 #1018290d, 0 0 0 2px #dbeafe";
export const radioButtonXsShadowFocusedDanger = "0 1px 2px 0 #fecdca, 0 0 0 2px #fee4e2";
export const radioButtonXsHeight = "12px";
export const radioButtonXsWidth = "12px";
export const radioButtonXsGap = "6px";
export const checkboxXsBorderDefault = "0.5px solid #d1d5db";
export const checkboxXsBorderHover = "0.5px solid #1d4ed8";
export const checkboxXsBorderFocused = "0.5px solid #3b82f6";
export const checkboxXsBorderDisabled = "0.5px solid #e5e7eb";
export const checkboxXsBorderIndeterminate = "0.5px solid #3b82f6";
export const checkboxXsBorderChecked = "0.5px solid #3b82f6";
export const checkboxXsBorderDanger = "0.5px solid #ef4444";
export const checkboxXsBorderFocusedDanger = "0.5px solid #fca5a5";
export const checkboxXsBorderRadius = "3px";
export const checkboxXsBorderRadiusFull = "100px";
export const checkboxXsHeight = "12px";
export const checkboxXsWidth = "12px";
export const checkboxXsShadow = "0 1px 2px 0 #e5e7eb";
export const checkboxXsShadowFocused = "0 1px 2px 0 #1018290d, 0 0 0 2px #dbeafe";
export const checkboxXsShadowFocusedDanger = "0 1px 2px 0 #fecdca, 0 0 0 2px #fee4e2";
export const checkboxXsGap = "6px";
export const checkboxSmBorderDefault = "1px solid #d1d5db";
export const checkboxSmBorderHover = "1px solid #1d4ed8";
export const checkboxSmBorderFocused = "1px solid #3b82f6";
export const checkboxSmBorderDisabled = "1px solid #e5e7eb";
export const checkboxSmBorderIndeterminate = "1px solid #3b82f6";
export const checkboxSmBorderChecked = "1px solid #3b82f6";
export const checkboxSmBorderDanger = "1px solid #ef4444";
export const checkboxSmBorderFocusedDanger = "1px solid #fca5a5";
export const checkboxSmBorderRadius = "4px";
export const checkboxSmBorderRadiusFull = "100px";
export const checkboxSmHeight = "14px";
export const checkboxSmWidth = "14px";
export const checkboxSmShadow = "0 1px 2px 0 #e5e7eb";
export const checkboxSmShadowFocused = "0 1px 2px 0 #1018290d, 0 0 0 2px #dbeafe";
export const checkboxSmShadowFocusedDanger = "0 1px 2px 0 #fecdca, 0 0 0 2px #fee4e2";
export const checkboxSmGap = "8px";
export const checkboxMdBorderDefault = "1px solid #d1d5db";
export const checkboxMdBorderHover = "1px solid #1d4ed8";
export const checkboxMdBorderFocused = "1px solid #3b82f6";
export const checkboxMdBorderDisabled = "1px solid #e5e7eb";
export const checkboxMdBorderIndeterminate = "1px solid #3b82f6";
export const checkboxMdBorderChecked = "1px solid #3b82f6";
export const checkboxMdBorderDanger = "1px solid #ef4444";
export const checkboxMdBorderFocusedDanger = "1px solid #fca5a5";
export const checkboxMdBorderRadius = "6px";
export const checkboxMdBorderRadiusFull = "100px";
export const checkboxMdHeight = "20px";
export const checkboxMdWidth = "20px";
export const checkboxMdShadow = "0 1px 2px 0 #e5e7eb";
export const checkboxMdShadowFocused = "0 1px 2px 0 #1018290d, 0 0 0 4px #dbeafe";
export const checkboxMdShadowFocusedDanger = "0 1px 2px 0 #fecdca, 0 0 0 4px #fee4e2";
export const checkboxMdGap = "12px";
export const textAreaSmGap = "4px";
export const textAreaSmVerticalPadding = "8px";
export const textAreaSmHorizontalPadding = "12px";
export const textAreaSmFont = "500 10px/14px Inter";
export const textAreaSmHeight = "100px";
export const textAreaSmBorderRadius = "6px";
export const textAreaMdBorderRadius = "8px";
export const textAreaMdGap = "6px";
export const textAreaMdVerticalPadding = "12px";
export const textAreaMdHorizontalPadding = "16px";
export const textAreaMdFont = "400 13px/18px Inter";
export const textAreaMdHeight = "124px";
export const textAreaLgBorderRadius = "8px";
export const textAreaLgGap = "6px";
export const textAreaLgVerticalPadding = "12px";
export const textAreaLgHorizontalPadding = "16px";
export const textAreaLgFont = "500 10px/14px Inter";
export const textAreaLgHeight = "140px";
export const textAreaBorderDefault = "1px solid #f3f4f6";
export const textAreaBorderHover = "1px solid #93c5fd";
export const textAreaBorderFocused = "1px solid #93c5fd";
export const textAreaBorderDisabled = "1px solid #f3f4f6";
export const textAreaBorderDanger = "1px solid #fca5a5";
export const textAreaBorderHoverDanger = "1px solid #fca5a5";
export const textAreaBorderFocusedDanger = "1px solid #fca5a5";
export const textAreaShadow = "0 1px 2px 0 #1018280d";
export const textAreaShadowFocused = "0 1px 2px 0 #B2CCFF, 0 0 0 4px #dbeafe";
export const textAreaShadowFocusedDanger = "0 1px 2px 0 #FECDCA, 0 0 0 4px #FEE4E2";
export const textAreaBorderWidth = "1px";
export const inputFieldSmBorderRadius = "6px";
export const inputFieldSmVerticalPadding = "4px";
export const inputFieldSmHorizontalPadding = "8px";
export const inputFieldSmFont = "500 10px/14px Inter";
export const inputFieldSmHeight = "24px";
export const inputFieldBorderDefault = "1px solid #f3f4f6";
export const inputFieldBorderHover = "1px solid #93c5fd";
export const inputFieldBorderFocused = "1px solid #93c5fd";
export const inputFieldBorderDisabled = "1px solid #f3f4f6";
export const inputFieldBorderDanger = "1px solid #fca5a5";
export const inputFieldBorderHoverDanger = "1px solid #fca5a5";
export const inputFieldBorderFocusedDanger = "1px solid #fca5a5";
export const inputFieldShadow = "0 1px 2px 0 #1018280d";
export const inputFieldShadowFocused = "0 1px 2px 0 #B2CCFF, 0 0 0 4px #dbeafe";
export const inputFieldShadowFocusedDanger = "0 1px 2px 0 #FECDCA, 0 0 0 4px #FEE4E2";
export const inputFieldBorderWidth = "1px";
export const inputFieldMdBorderRadius = "8px";
export const inputFieldMdVerticalPadding = "6px";
export const inputFieldMdHorizontalPadding = "12px";
export const inputFieldMdFont = "500 13px/18px Inter";
export const inputFieldMdHeight = "32px";
export const inputFieldLgBorderRadius = "8px";
export const inputFieldLgVerticalPadding = "8px";
export const inputFieldLgHorizontalPadding = "12px";
export const inputFieldLgFont = "500 16px/24px Inter";
export const inputFieldLgHeight = "40px";
